<template>
	<div class="unselectable" v-loading="loading" v-if="show">
		<div
			style="width: 100%;height: 50px;background-color: #ffffff;border-bottom: solid 2px #cccccc ;display: flex;align-items: center;justify-content: space-between;">
			<img style="height: 40px;margin-left: 10px;margin-top: 2px;" src="./img/logo.png" />
			<div v-if="pageValue != pageValueEnum.globalConfig && pageValue != pageValueEnum.menu"
				style="width: 237px;display: flex;justify-content: center;height: 42px;z-index: 100;background-color: #fff;"
				flex-shrink:0>
				<div :style="{background:equipment == 'pc'?'#242754':'#ffffff'}" @click="changeEq('pc')"
					style="width: 38px;height: 38px;border-radius: 4px 4px 4px 4px;display: flex;align-items: center;justify-content: center;cursor: pointer;font-size: 20px;">
					<i :style="{color:equipment == 'pc'?'#ffffff':'#000000'}" class="el-icon-s-platform" style=""></i>
				</div>
				<div :style="{background:equipment == 'phone'?'#242754':'#ffffff'}" @click="changeEq('phone')"
					style="width: 38px;height: 38px;border-radius: 4px 4px 4px 4px;display: flex;align-items: center;justify-content: center;cursor: pointer;font-size: 20px;margin-left: 10px;">
					<i @click="changeEq('phone')" :style="{color:equipment == 'phone'?'#ffffff':'#000000'}"
						class="el-icon-mobile left-top"></i>
				</div>
			</div>
			<div style="width: 237px;display: flex;justify-content: center;height: 50px;z-index: 100;background-color: #fff;"
				flex-shrink:0>
				<div
					style="display: flex;align-items: center;width: 237px;justify-content: space-around;font-size: 16px;padding: 2px;">
					<div style="display: flex;align-items: center;font-size: 14px;">
						<div style="margin-top: 3px;"><img src="./img/homeIcon.png" /></div>
						<div style="cursor: pointer;" @click="linkFront">访问前台</div>
					</div>
					<!-- <el-button size="mini" @click="preview">预览</el-button> -->
					<el-button size="mini" style="background-color: #242754;border: solid 1px #242754;" @click="save"
						type="primary">保存发布</el-button>
				</div>
			</div>
		</div>
		<div class="tool-box">
			<div style="width: 60px;height: calc(100vh - 55px);border: solid 1px #242754;background-color: #242754;">
				<div
					style="display:flex;flex-direction: column;align-items: center;height: 100%;width: 100%;overflow-y: scroll;">
					<div style="width: 60px;height: 1px;"></div>
					<div :style="{color:getPageValueRule(item,'or')?'#ffffff':'#ffffff',backgroundColor:getPageValueRule(item,'or')? '#fff':'#242754'}"
						style="margin-top: 20px;cursor: pointer;width: 50px;height: 50px;display: flex;align-items: center;justify-content: center;border-radius: 10px;flex-shrink:0"
						@click="drawerStruct = false;pageValue = item.pageValue; item.pageValue !='10' &&  item.pageValue !='11'?changePage(item.pageValue):''"
						v-for="(item,index) in config.left.menu">
						<div v-if="getPageValueRule(item,'and')"
							style="display: flex;flex-direction: column;align-items: center;font-size: 12px;">
							<div style="font-size: 16px;">
								<i v-if="item.iconComponent == 'elIcon'" :class="item.iconName"></i>
								<van-icon v-if="item.iconComponent == 'vantIcon'" :name="item.iconName" />
							</div>
							<div>{{item.name}}</div>
						</div>
						<div v-if="getPageValueRule(item,'or')"
							style="display: flex;flex-direction: column;align-items: center;color: #000;font-size: 12px;">
							<div style="font-size: 16px;">
								<i v-if="item.iconComponent == 'elIcon'" :class="item.iconName"></i>
								<van-icon v-if="item.iconComponent == 'vantIcon'" :name="item.iconName" />
							</div>
							<div>{{item.name}}</div>
						</div>
					</div>
					<!-- <div v-if="pageValue != '10' && pageValue != '11'"
						style="margin-top: 60px;cursor: pointer;color: #ffffff;color: #ffffff;width: 50px;height: 50px;display: flex;align-items: center;justify-content: center;border-radius: 10px;border: solid 1px #fff;flex-shrink: 0;">
						<div style="display: flex;flex-direction: column;align-items: center;font-size: 12px;">
							<van-switch size="14px" v-model="guides" />
							<div style="margin-top: 4px;">辅助线</div>
						</div>
					</div> -->
					<!-- <div v-if="pageValue != '10' && pageValue != '11'" @click="drawerStruct = true"
						style="margin-top: 20px;cursor: pointer;color: #ffffff;color: #ffffff;width: 50px;height: 50px;display: flex;align-items: center;justify-content: center;border-radius: 10px;border: solid 1px #fff;flex-shrink: 0;margin-bottom: 20px;">
						<div style="display: flex;flex-direction: column;align-items: center;font-size: 12px;">
							<div style="font-size: 16px;"><i class="el-icon-s-operation"></i></div>
							<div>结构树</div>
						</div>
					</div> -->

					<div v-if="pageValue != '10' && pageValue != '11'" @click="retrunList"
						style="cursor: pointer;margin-top: 20px;color: #ffffff; margin-top: auto;margin-bottom: 20px;">
						<van-icon class="tit-icon1" name="revoke" style="font-size: 14px;font-weight: bold;" />
					</div>
				</div>
				<!-- <div v-show="pageValue != '10' && pageValue != '11'"
					style="position: fixed;z-index: 1000;bottom: 20px;left: 80px;background-color: #ffffff;font-weight: bold;">
					<i style="cursor: pointer;" @click="leftBoxShow = !leftBoxShow" class="el-icon-arrow-right "></i>
				</div> -->
				<div @click="currentNodeKey = '';treeKey = treeKey + 1;selectdItem = null;needTreeAddCmp = null"
					style="width: 198px;position: absolute;z-index: 1000;">
					<el-drawer class="tree-drawer" :show-close="false"
						style="z-index: 1;width: 198px;border: solid 1px #dfdfdf;height: calc(100vh - 96px);margin-top: 94px;margin-left:62px"
						:wrapperClosable="true" :modal="false" size="220px" direction="ltr" title=" "
						:visible.sync="drawerStruct"
						:before-close="()=>{drawerStruct = false;editableTabsValue = '1';cmpZindex = 0}">
						<!-- <div style="display: flex;align-items: center;justify-content: center;font-size: 14px;">
						</div> -->
						<el-tree icon-class=" " :expand-on-click-node="false" highlight-current
							@current-change="currentChangeNode" :current-node-key="currentNodeKey"
							:default-expanded-keys="expandedKeys" :key="treeKey"
							@node-click="(e)=>{currentNodeKey = e.id}" @node-drag-start="handleDragStart"
							@node-drag-enter="handleDragEnter" @node-drag-leave="handleDragLeave"
							@node-drag-over="handleDragOver" @node-drag-end="handleDragEnd" @node-drop="handleDrop"
							draggable :allow-drop="allowDrop" :allow-drag="allowDrag" node-key="id" class="custom-tree"
							:data="centerList" :props="propsTree" ref="tree">
							<span :style="getLevelStyle(node.level,node)"
								style="height: 26px;border-radius: 6px;color: #fff;padding-left: 4px;"
								@mouseleave="mouseenterItem = null" @mouseover="mouseenterSet(data,data,data)"
								class="custom-tree-node" slot-scope="{ node, data }">
							
								<span >
									<i v-if="!node.expanded && data.children && data.children.length > 0 && data.name == '容器'" @click="treeSwitch(node,data)"
										class="el-icon-caret-right"></i>
									<i v-if="node.expanded && data.children && data.children.length > 0 && data.name == '容器'" @click="treeSwitch(node,data)"
										class="el-icon-caret-bottom"></i>
									<i class="el-icon-rank" style="margin-left: 2px;"></i>
								</span>
								<span style="font-size: 13px;">
									{{ renderContent(node,data)}}
									<span>
										{{data.level == 1 && data.applyType != 'all'?data.applyType == 'pc'?'(pc端)':'(移动端)' :''}}
									</span>
								</span>
								<span>
									<i v-if="data.name != '商品详情' && data.name != '商品分类'"  @click.stop.prevent="copyComp(data,node)" class="el-icon-document-copy"
										style="margin-right: 6px;"></i>
									<i v-if="(data.level < 3 && data.name == '容器') || (data.compontChildren && data.compontChildren.length == 0 && data.name == '容器')"
										@click.stop.prevent="addNode(data,node)" style="margin-right: 6px;"
										class="el-icon-plus tit-icon"></i>
									<!-- <i @click.stop.prevent="setNode(data,node)" style="margin-right: 10px;"
										class="el-icon-setting tit-icon"></i> -->
									<!-- v-if="data.level != 1 || centerList.length != 1 || centerList[0].id != data.id" -->
									<i @click.stop.prevent="delNode(data,node)"
										v-if="data.name != '商品详情' && data.name != '商品分类'" style="margin-right: 6px;"
										class="el-icon-delete tit-icon"></i>
								</span>
							</span>
						</el-tree>
						<div @click.stop.prevent="selectComp"
							style="font-size: 12px;background-color: #090909;color:#fff;border-radius: 10px;padding: 6px 8px;width: fit-content;margin: auto;margin-top: 15px;cursor: pointer;">
							添加组件
						</div>
					</el-drawer>
				</div>
			</div>
			<transition>
				<div v-show="pageValue != '10' && pageValue != '11'"
					:style="{top:leftTop + 'px',left:'54' + 'px',zIndex: cmpZindex}" class="left"
					style="height: calc(100vh - 55px);">
					<div style="width: 100%;height: 100%;width: 200px;">

						<div v-if="cmpZindex == 0" style="display: flex;align-items: center;color:#fff">
							<div :style="{ backgroundColor:editableTabsValue == '1'?'#605bf6':'#aaa7a7',
						}" style="width: 50%;padding: 10px 6px;text-align: center;cursor: pointer;"
								@click="editableTabsValue = '1';drawerStruct = false;cmpZindex = 0">模块仓</div>
							<div :style="{ backgroundColor:editableTabsValue == '2'?'#605bf6':'#aaa7a7',
						}" style="width: 50%;padding: 10px 6px;text-align: center;cursor: pointer;"
								@click="editableTabsValue = '2';drawerStruct = true;showTree()">结构树</div>
						</div>
						<div v-if="cmpZindex > 0" @click="cmpZindex = 0"
							style="font-size: 12px;width: 100%;padding: 10px;color: #55aaff ;text-align: center;cursor: pointer;">
							取消选择
						</div>
						<div style="height: calc(100% - 41px);overflow-y: scroll;">
							<div :key="indexComp" v-for="(itemComp, indexComp) in editableTabs" :label="itemComp.title"
								:name="itemComp.name">
								<div :key="index" v-for="(item,index) in getCompList(leftList)">
									<div style="margin: 10px;">
										{{item.name}}
									</div>
									<draggable :clone="cloneRule" :move="onMove" @add="leftEnd1"
										@start="leftStart($event,item.list)" @end="leftEnd" animation="300"
										v-model="item.list"
										v-bind="{group:{name:'center',pull:'clone',put:false},sort: false}">
										<transition-group class="group">
											<div @click="treeSelectItem(itemDrag)"
												v-for="(itemDrag,indexDrag) in item.list" :key="indexDrag">
												<div class="item">
													<img style="width: 24px;height: 24px;object-fit: contain;"
														:src="dragIcon[itemDrag.icon]" />
													<div style="margin-top: 6px;">
														{{ itemDrag.name }}
													</div>
												</div>
											</div>
										</transition-group>
									</draggable>
								</div>
							</div>
							<div style="height: 20px;width: 100%;"></div>
						</div>
						<!-- <el-tabs style="margin-top: 0px;padding-bottom: 10px;" class="margin-10" v-model="editableTabsValue" type="card"
							@edit="handleTabsEdit">
							<el-tab-pane :key="indexComp" v-for="(itemComp, indexComp) in editableTabs"
								:label="itemComp.title" :name="itemComp.name">
								<div :key="index" v-for="(item,index) in getCompList(leftList)">
									<div style="margin: 10px;">
										{{item.name}}
									</div>
									<draggable :clone="cloneRule" :move="onMove" @add="leftEnd1"
										@start="leftStart($event,item.list)" @end="leftEnd" animation="300"
										v-model="item.list"
										v-bind="{group:{name:'center',pull:'clone',put:false},sort: false}">
										<transition-group class="group">
											<div @click="treeSelectItem(itemDrag)"
												v-for="(itemDrag,indexDrag) in item.list" :key="indexDrag">
												<div class="item">
													<img style="width: 24px;height: 24px;object-fit: contain;"
														:src="dragIcon[itemDrag.icon]" />
													<div style="margin-top: 6px;">
														{{ itemDrag.name }}
													</div>
												</div>
											</div>
										</transition-group>
									</draggable>
								</div>
							</el-tab-pane>
						</el-tabs> -->
					</div>
				</div>
			</transition>
			<global-set @changeSetList="($event)=>{setConfigList = $event}"
				v-if="globalSetShow && (pageValue == '10' || pageValue == '11')" :all_setting="all_setting"
				:pageValue="pageValue" :systemConfig="systemConfig"></global-set>
			<div style="width: 100vw;" class="center" v-if="pageValue != '10' &&  pageValue != '11'"
				:style="getBgStyle()">
				<div style="width:100%;height: 100%;overflow: hidden;">
					<div style="width:100%;height: 100%;">
						<div style="width:100%;overflow: scroll;" :style="getFootHeight()">
							<div :style="getCenterStyle()"
								style="width: 100%;display: flex;justify-content: center;height: 100%;">
								<div style="height: 100%;width: 100%;">
									<div style="height:100%;display: flex;justify-content: center;width:100%;">
										<!-- <img v-if="equipment == 'phone'"
											style="position: absolute;height: calc(100vh - 105px);z-index: 10;width: 460px;object-fit: fill;margin-top: 25px;"
											src="./img/Mobile@2x.png" /> -->
										<div :style="{width:equipment == 'pc'?'100%':'410px',marginTop:equipment == 'pc'?'0px':'75px',paddingBottom:equipment == 'pc'?'0px':'0px',...getPhoneStyle('container'),border:equipment == 'pc'?'0px':'solid 1px #646464'}"
											style="padding:0px 0px 0px 0px;z-index: 100;overflow-y: scroll;position: relative;min-height: 100%;
											will-change: transform;
											  backface-visibility: hidden;
											  transform: translateZ(0);
											">
											<div v-if="pageValue !=  pageValueEnum.globalDialog" :style="{
												...getContainerStyle('box'),
												height:centerBgHeight + 'px'
												
											}" class="child-row" style="min-height: 100%;position: absolute;margin: auto;z-index: -1;left: 50%; transform: translate( -50%);">
											</div>
											<draggable class="rowCenter" @sort="sortDrag" ghostClass="ghost"
												@start="centerStart" @end="centerEnd" style="width: 100%;"
												v-model="centerList"
												:group="{name: 'center',pull:false,put:addContainerPut,sort:true}"
												animation="300">
												<transition-group >
													<el-row
														:id="'s_' + containerItem.id"
														v-if="containerItem.applyType == 'all' || containerItem.applyType == equipment"
														v-for="(containerItem,containerIndex) in centerList"
														:key="containerIndex + 'level1'"
														:style="equipment == 'pc' && !containerItem.isFullWidth && !containerItem.isFullWidthBg?getContainerStyle():{width:'100%'}"
														style="margin: auto;">
														<!-- ...getPhoneStyle('container') -->
														<el-col
															:style="{border:guides?(selectdItem && selectdItem.id == containerItem.id || mouseenterItem && mouseenterItem.id == containerItem.id?'solid 1px #55aaff':''):'none',}"
															:span="getSpan(containerItem,containerItem)">
															<div :key="containerIndex + 'container'"
																@mouseleave="mouseenterItem = null"
																@mouseover.stop.prevent="mouseenterSet(containerItem,containerItem,containerItem)"
																@contextmenu.stop.prevent="rightClick($event,containerItem,1,containerIndex)"
																@click.stop.prevent="selectItemContainer(containerItem,1,containerIndex,containerIndex,containerIndex,null,null)">
																<div :style="getStyle(containerItem,'noFull')"
																	style="border: solid 1px #c6c6c6;z-index: 110;">
																	<div style="width: 100%;" :style="{
																	}">
																		<div style="margin: auto;max-width: 100%;"
																			:style="containerItem.containerLayout.col.span == 24 && equipment == 'pc'?getContainerStyle():'100%'">
																			<draggable
																				v-if="containerItem.children.length == 0"
																				style="height: 100%;width: 100%;"
																				ghostClass="ghost"
																				:options="{group:{name:'center',pull:false,put:addComponentPut},sort: true}"
																				v-model="containerItem.children">
																				<transition-group
																					:class="'level1' + containerIndex"
																					style="height: 100%;width: 100%;">
																					<div key="add1"
																						style="display: flex;"
																						:style="{border:guides?(selectdItem && selectdItem.id == containerItem.id || mouseenterItem && mouseenterItem.id == containerItem.id?'solid 1px #55aaff':''):'none',marginTop:guides?'0px':'0px',...getStyle(containerItem,'full')}">
																						<div
																							style="width: fit-content;padding: 8px;">
																							添加组件
																						</div>
																					</div>
																				</transition-group>
																			</draggable>
																		</div>
																	</div>
																	<div v-if="containerItem.children.length != 0"
																		:style="containerItem.isFullWidthBg?getStyle(containerItem,'full'):''"
																		style="width: 100%;">
																		<div style="margin: auto;max-width: 100%;"
																			:style="containerItem.containerLayout.col.span == 24 && equipment == 'pc' && !containerItem.isFullWidth?getContainerStyle():'100%'">
																			<div style="width: calc(100%-2px);"
																				:style="{marginTop:guides?'0px':'0px'}">
																				<div style="width: 100%;"
																					:style="getStyle(containerItem,'full')">
																					<el-row
																						v-if="containerItem.children.length != 0 && containerItem.children[0].level != 4"
																						key="add2"
																						:align="containerItem.containerLayout.align"
																						:justify="containerItem.containerLayout.justify"
																						style="display: flex;flex-wrap: wrap;"
																						type="flex">
																						<el-col
																							:pull="getPull(childItem,containerItem)"
																							:push="getPush(childItem,containerItem)"
																							style=""
																							v-for="(childItem,childIndex) in containerItem.children"
																							:key="childIndex"
																							:span="getSpan(containerItem,childItem,childIndex)">
																							<div style="z-index: 10;"
																								@contextmenu.stop.prevent="rightClick($event,childItem,2)"
																								:style="{margin:guides?'0px':'0px',border:ghostClass == ('level2' + childIndex + containerIndex)?'solid 1px #aa55ff':guides?(selectdItem && selectdItem.id == childItem.id || mouseenterItem && mouseenterItem.id == childItem.id?'solid 1px #aa55ff':''):'none'}"
																								:key="childIndex"
																								@mouseleave="mouseenterItem = null"
																								@mouseover.stop.prevent="mouseenterSet(childItem,childItem,containerItem)"
																								@click.stop.prevent="selectItemContainer(childItem,2,childIndex,childIndex,containerIndex,containerItem,containerItem)">
																								<div
																									:style="getStyle(childItem)">
																									<el-row
																										:key="'child' + childIndex"
																										:align="childItem.containerLayout.align"
																										:justify="childItem.containerLayout.justify"
																										type="flex"
																										style="margin: 0px;display: flex;flex-wrap: wrap;"
																										:gutter="childItem.containerLayout.row.gutter">
																										<draggable
																											v-if="childItem.children.length == 0"
																											ghostClass="ghost"
																											style="width: 100%;height:100%;"
																											:options="{group:{name:'center',pull:false,put:addComponentPut && childItem.name == '容器'},sort: true}"
																											v-model="childItem.children">
																											<transition-group
																												:class="'level2' + childIndex + containerIndex"
																												style="height:  100%;width: 100%;">
																												<div key="add1"
																													style="padding: 10px;">
																													添加组件
																												</div>
																											</transition-group>
																										</draggable>
																										<el-col
																											v-if="childItem.children.length != 0 && childItem.children[0].level != 4"
																											:style="{padding:guides?'0px 0px':'0px 0px',border:ghostClass == ('level3' + childrenTwoIndex + childIndex + containerIndex)?'solid 1px #ff5500':''}"
																											:pull="childrenTwoItem.containerLayout.col.pull == 0?null:childrenTwoItem.containerLayout.col.pull"
																											:push="childrenTwoItem.containerLayout.col.push == 0?null:childrenTwoItem.containerLayout.col.push"
																											:span="getSpan(childrenTwoItem,childrenTwoItem,childrenTwoIndex)"
																											style="height: 100%;"
																											:key="childrenTwoIndex"
																											v-for="(childrenTwoItem,childrenTwoIndex) in childItem.children">
																											<draggable
																												ghostClass="ghost"
																												:style="{padding:guides?'0px':'0px',border:guides?(selectdItem && selectdItem.id == childrenTwoItem.id  || mouseenterItem && mouseenterItem.id == childrenTwoItem.id?'solid 1px #ff5500':''):'none'}"
																												style="height: 100%;height: 100%;overflow: hidden;"
																												:options="{group:{name:'center',pull:false,put:addComponentPut && childrenTwoItem.compontChildren == 0},sort: true}"
																												v-model="childrenTwoItem.compontChildren">
																												<transition-group
																													:class="'level3' + childrenTwoIndex + childIndex + containerIndex"
																													style="width: 100%;height: 100%;">
																													<div @mouseleave="mouseenterItem = null"
																														@mouseover.stop.prevent="mouseenterSet(childrenTwoItem,childItem,containerItem)"
																														:key="childrenTwoIndex"
																														style="position: relative;">
																														<div :key="childrenTwoIndex"
																															@click.stop.prevent="selectItemContainer(childrenTwoItem,3,childrenTwoIndex,childItem,containerItem,childItem,containerItem)"
																															class="container-child"
																															key="addCompoent"
																															v-if="childrenTwoItem.compontChildren.length == 0">
																															<div
																																style="padding: 10px;">
																																添加组件
																															</div>
																														</div>
																														<div :style="{...getStyleComponentFather(childItem)}"
																															style="width: 100%;height: 100%;display: flex;position: relative;"
																															@click.stop.prevent="selectItemContainer(childrenTwoItem,4,childrenTwoIndex,childItem,containerItem,childItem,containerItem)"
																															class="container-child"
																															v-if="childrenTwoItem.compontChildren.length != 0"
																															:key="compontChildrenIndex"
																															v-for="(compontChildrenItem,compontChildrenIndex) in childrenTwoItem.compontChildren">
																															<div style="display: flex;padding: 1px;width: 100%;"
																																:style="{
																																			justifyContent:childrenTwoItem.containerLayout.justify,
																																			border:guides?(selectdItem && selectdItem.id == childrenTwoItem.id  || mouseenterItem && mouseenterItem.id == childrenTwoItem.id?'solid 1px #ff5500':''):'none',
																																			...getComponentStyle(childrenTwoItem),padding:guides?'0px':'0px'}">
																																<div style="width: 100%;height: 100%;"
																																	v-if="!compontChildrenItem.compoentName">
																																	添加组件
																																</div>
																																<!-- zoom:compontChildrenItem.compoentName == 'wmImg' || compontChildrenItem.compoentName == 'wmGoods' || compontChildrenItem.compoentName == 'wmDetail'?1:rightBoxShow?0.73:0.86, -->
																																<component
																																	:isFullWidthKey="isFullWidthKey"
																																	@changeData="changeComponentData"
																																	:guides="guides"
																																	:all_setting="all_setting"
																																	:systemConfig="systemConfig"
																																	typeView="design"
																																	:equipment="equipment"
																																	:compontentStyle="childrenTwoItem.preStyle.compontentStyle"
																																	:selectdItem="childrenTwoItem"
																																	:style=" {
																																			zoom:compontChildrenItem.compoentName == 'wmGoodsList' || compontChildrenItem.compoentName == 'wmImgList' || compontChildrenItem.compoentName == 'wmImg' || compontChildrenItem.compoentName == 'wmGoods' || compontChildrenItem.compoentName == 'wmDetail' || equipment == 'phone' || compontChildrenItem.compoentName == 'wmClassify'?1:rightBoxShow?zoomNum:0.86,
																																			justifyContent:childrenTwoItem.containerLayout.justify,
																																				...getChildConentStyle(childrenTwoItem)
																																			}" v-if="compontChildrenItem.compoentName" style="height: 100%;width: 100%;display: flex;" :is="compontChildrenItem.compoentName">
																																</component>
																																<div v-if="equipment == 'phone' && pageValue == '20'"
																																	style="width: 1px;height: 60px;">
																																</div>
																															</div>
																														</div>
																													</div>
																												</transition-group>
																											</draggable>
																										</el-col>
																									</el-row>
																								</div>
																							</div>
																						</el-col>
																					</el-row>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</el-col>
													</el-row>
												</transition-group>
											</draggable>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="pageValue != '10' && pageValue != '11'"
				style="position: absolute;z-index: 999;bottom: 20px;right: 20px;background-color: #ffffff;font-weight: bold;">
				<i style="cursor: pointer;" @click="rightBoxShow = !rightBoxShow "
					class="el-icon-arrow-left tit-icon"></i>
			</div>
			<div v-if="rightBoxShow && pageValue != '10' && pageValue != '11'">
				<transition name="slider">
					<div style="width: 238px;"></div>
				</transition>
				<transition name="slider">
					<div style="height:calc(100vh - 53px);width: 235px;display: flex;align-items: center;flex-direction: column;position: fixed;top: 0px;right: 0px;z-index: 1000;top: 52px;"
						class="right">
						<div style="width: 235px;height: 1px;"></div>
						<!-- 	<el-tabs stretch v-if="selectdItem" style="width: 240px;flex-shrink:0" v-model="rightTab"
							type="card" @edit="handleTabsRightEdit" class="el-tabs-top">
							<el-tab-pane
								v-if="selectdItem && selectdItem.level >= 3 && selectdItem.compontChildren.length != 0"
								:key="item.name" v-for="(item, index) in rightComponentTabs"
								:label="selectdItem.compontChildren[0].name + '设计'" :name="item.name">
								
							</el-tab-pane>
							<el-tab-pane v-if="selectdItem && selectdItem.level < 3" :key="item.name"
								v-for="(item, index) in rightTabs" :label="item.title" :name="item.name">
							</el-tab-pane>
						</el-tabs>
						 -->


						<div v-if="selectdItem && selectdItem.level >= 3 && selectdItem.compontChildren.length != 0">
							<div
								style="width: 210px;padding-top: 9px;padding-bottom: 9px;font-size: 14px;margin: auto;text-align: center;background-color: #aaa7a7;margin-top: 10px;border-radius: 10px 10px 0px 0px;border-bottom: solid 1px #c6c6c6;">
								容器设置
							</div>
							<div style="font-size: 12px;" v-if="rightTab == '2'">
								<!-- 图片 -->
							</div>

							<div v-if="rightTab == '3' && selectdItem.compontChildren[0].isNeedData?true:true"
								style="font-size: 12px;">
								<div style="display: flex;justify-content: center;cursor: pointer;width: 235px;">
									<div
										style="background-color: #F6F7F9;width: 210px;display: flex;flex-direction: column;align-items: center;">

										<div v-if="selectdItem.level == 1 && pageValue != '1' && pageValue != '3'"
											style="display: flex;align-items: center;justify-content: space-around;margin-top: 5px;">
											<!-- <div style="width: 100%;height: 1px;background-color: #c7c7c7;margin: 8px 0px;"></div> -->
											<div>设备选择</div>
											<div style="display: flex;align-items: center;margin-left:8px;">
												<div @click="selectdItem.applyType = 'all'"
													:style="{backgroundColor:selectdItem.applyType == 'all'?'#8c62ff':'#fff',color:selectdItem.applyType == 'all'?'#fff':'#000',border:selectdItem.applyType == 'all'?'solid 1px #8c62ff':'solid 1px #959595' }"
													style="padding: 4px 0px;width: 38px;text-align: center;"><span
														style="scale: 0.85;">全部</span></div>
												<div @click="selectdItem.applyType = 'pc'"
													:style="{backgroundColor:selectdItem.applyType == 'pc'?'#8c62ff':'#fff',color:selectdItem.applyType == 'pc'?'#fff':'#000',border:selectdItem.applyType == 'pc'?'solid 1px #8c62ff':'solid 1px #959595' }"
													style="padding: 4px 0px;width: 38px;text-align: center;"><span
														style="scale: 0.85;">pc端</span></div>
												<div @click="selectdItem.applyType = 'phone'"
													:style="{backgroundColor:selectdItem.applyType == 'phone'?'#8c62ff':'#fff',color:selectdItem.applyType == 'phone'?'#fff':'#000',border:selectdItem.applyType == 'phone'?'solid 1px #8c62ff':'solid 1px #959595' }"
													style="border: solid 1px #959595;padding: 4px 0px;width: 38px;text-align: center;">
													<span style="scale: 0.85;">移动端</span>
												</div>
											</div>
										</div>

										<div v-if="selectdItem.level == 1  && pageValue != '1' && pageValue != '3'"
											style="color: #424242;scale: 0.85;margin-top: 4px;">
											选择本容器生效的设备
										</div>


										<div
											style="height: 28px;background-color: #F6F7F9;width: 210px;display: flex;align-items: center;justify-content: space-around;margin-top: 6px;">
											<div>
												容器宽度占比
											</div>
											<div style="display: flex;align-items: center;">
												<wm-input-number :disabled="false" style="border: solid 1px #959595 ;"
													:styleObj="{width: '50px',height: '22px'}" :step="1" :min="1"
													:max="24" :value="getColSpan()"
													@change="changeColSpan($event)"></wm-input-number>
												<div
													style="width: 50px;border: solid 1px #959595;background-color: #8c62ff;text-align: center;color: #fff;padding: 4px 0px;">
													/ 24
												</div>
											</div>
										</div>
										<div style="color: #424242;scale: 0.85;">
											页面总宽度分为24份,可设置当前容器占比父容器的比例,最外层容器父容器占页面宽度
										</div>
									</div>
								</div>
								<div style="display: flex;justify-content: center;cursor: pointer;width: 235px;">
									<div
										style="background-color: #F6F7F9;width: 210px;display: flex;flex-direction: column;">
										<div style="width: 100%;height: 1px;background-color: #c7c7c7;margin: 8px 0px;">
										</div>
										<div style="display: flex;justify-content: space-between">
											<div style="margin: 6px;">
												容器背景
											</div>
											<div v-if="selectdItem.preStyle.bg.bgtype"
												style="display: flex;align-items: center;margin-left:8px;">
												<div @click="selectdItem.preStyle.bg.bgtype = 'color'"
													:style="{backgroundColor:selectdItem.preStyle.bg.bgtype == 'color'?'#8c62ff':'#fff',color:selectdItem.preStyle.bg.bgtype == 'color'?'#fff':'#000',border:selectdItem.preStyle.bg.bgtype == 'color'?'solid 1px #8c62ff':'solid 1px #959595' }"
													style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
													<span style="scale: 0.85;">纯色</span>
												</div>
												<div @click="selectdItem.preStyle.bg.bgtype = 'gradient'"
													:style="{backgroundColor:selectdItem.preStyle.bg.bgtype == 'gradient'?'#8c62ff':'#fff',color:selectdItem.preStyle.bg.bgtype == 'gradient'?'#fff':'#000',border:selectdItem.preStyle.bg.bgtype == 'gradient'?'solid 1px #8c62ff':'solid 1px #959595' }"
													style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
													<span style="scale: 0.85;">渐变</span>
												</div>
												<div @click="selectdItem.preStyle.bg.bgtype = 'img'"
													:style="{backgroundColor:selectdItem.preStyle.bg.bgtype == 'img'?'#8c62ff':'#fff',color:selectdItem.preStyle.bg.bgtype == 'img'?'#fff':'#000',border:selectdItem.preStyle.bg.bgtype == 'img'?'solid 1px #8c62ff':'solid 1px #959595' }"
													style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
													<span style="scale: 0.85;">图片</span>
												</div>
											</div>
										</div>
										<div v-if="selectdItem.preStyle.bg.bgtype == 'img'"
											style="display: flex;justify-content: center;margin-top: 10px;width: 235px;font-size: 12px;">
											<div
												style="display: flex;align-items: center;background-color: #F6F7F9;height: 38px;width: 210px;justify-content: space-around;">
												<div style="font-size: 12px;">
													背景图片
												</div>
												<div @click="selectBgImg"
													style="height: 30px;width: 30px;background-color: #fff;display: flex;align-items: center;justify-content: center;">
													<el-image :src="selectdItem.preStyle.bg.img"
														style="cursor: pointer;">
														<div slot="error" class="image-slot">
															<i style="font-size: 16px;" class="el-icon-plus"></i>
														</div>
													</el-image>
												</div>
												<el-select size="mini" style="width: 82px;"
													v-model="selectdItem.preStyle.bg.type" filterable allow-create
													default-first-option placeholder="渲染方式">
													<el-option label="重复" value="repeat">
													</el-option>
													<el-option label="x轴重复" value="repeat-x">
													</el-option>
													<el-option label="y轴重复" value="repeat-y">
													</el-option>
													<el-option label="平铺" value="">
													</el-option>
													<el-option label="不平铺" value="no-repeat">
													</el-option>
												</el-select>
											</div>
										</div>

										<div v-if="selectdItem.preStyle.bg.bgtype == 'img'"
											style="display: flex;justify-content: center;">
											<div
												style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
												<div style="width: 40px;">
													宽度:
												</div>
												<wm-input-number style="margin-left: 10px;" :iptWidth="80"
													:disabled="false" :styleObj="{width: '100px',height: '30px'}"
													:step="1" :min="1" :max="10000000000"
													:value="selectdItem.preStyle.bg.bgImgWidth"
													@change="(e)=>{selectdItem.preStyle.bg.bgImgWidth = e}"></wm-input-number>
											</div>
										</div>
										<div v-if="selectdItem.preStyle.bg.bgtype == 'img'"
											style="display: flex;justify-content: center;">
											<div
												style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
												<div style="width: 40px;">
													高度:
												</div>
												<wm-input-number style="margin-left: 10px;" :iptWidth="80"
													:disabled="false" :styleObj="{width: '100px',height: '30px'}"
													:step="1" :min="1" :max="10000000000"
													:value="selectdItem.preStyle.bg.bgImgHeigth"
													@change="(e)=>{selectdItem.preStyle.bg.bgImgHeigth = e}"></wm-input-number>
											</div>
										</div>

										<div v-if="selectdItem.preStyle.bg.bgtype == 'img'"
											style="display: flex;align-items: center;margin-left: 10px;margin-top: 10px;">
											<div>
												背景位置
											</div>

											<el-select @change="(e)=>{selectdItem.preStyle.bg.position = e}"
												style="margin-left: 10px;width: 120px;"
												v-model="selectdItem.preStyle.bg.position" filterable allow-create
												default-first-option placeholder="图片位置">
												<el-option label="左上方" value="top left">
												</el-option>
												<el-option label="上中间" value="top center">
												</el-option>
												<el-option label="右上方" value="top right">
												</el-option>
												<el-option label="左中方" value="center left">
												</el-option>
												<el-option label="居中" value="center center">
												</el-option>
												<el-option label="右中方" value="center right">
												</el-option>
												<el-option label="下左方" value="bottom left">
												</el-option>
												<el-option label="下居中" value="bottom center">
												</el-option>
												<el-option label="下右方" value="bottom right">
												</el-option>
											</el-select>
										</div>

										<div v-if="selectdItem.preStyle.bg.bgtype == 'gradient'"
											style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
											<div
												style="width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
												<div style="display: flex;flex-direction: column;">
													<div style="display: flex;align-items: center;">
													</div>
													<el-input style="width: 172px;margin-top: 4px;" type="textarea"
														:rows="3" placeholder="请输入内容"
														v-model="selectdItem.preStyle.bg.bgGradient">
													</el-input>
												</div>
												<div style="margin-top: 6px;font-size: 12px;color: #55aaff;">
													需要更多模板设置请访问 <a target="_blank" style="margin-left: 4px;"
														href="https://www.eggradients.com/">Gradient1</a> <a
														style="margin-left: 4px;" target="_blank"
														href="https://webgradients.com/">Gradient2</a>
												</div>
											</div>
										</div>
										<div v-if="selectdItem.preStyle.bg.bgtype && selectdItem.preStyle.bg.bgtype == 'color'"
											style="display: flex;justify-content: center;margin-top: 10px;width: 210px;font-size: 12px;">
											<div
												style="display: flex;align-items: center;background-color: #F6F7F9;height: 34px;width: 210px;justify-content: space-around;">
												<div style="font-size: 12px;">
													背景纯色
												</div>
												<el-color-picker size="mini" @change="(e)=>{
															selectdItem.preStyle.background.color1 = e
															selectdItem.preStyle.background.color2 = e
														}" style="height: 28px;width: 28px;margin-top: 4px;"
													v-model="selectdItem.preStyle.background.color1"></el-color-picker>
											</div>
										</div>

									</div>
								</div>
								<div style="display: flex;justify-content: center;cursor: pointer;width: 235px;">
									<div
										style="background-color: #F6F7F9;width: 210px;display: flex;flex-direction: column;">
										<div style="width: 100%;height: 1px;background-color: #c7c7c7;margin: 8px 0px;">
										</div>
										<div style="margin: 6px;">
											容器布局
										</div>
										<div style="margin:6px;">
											<div
												style="display: flex;align-items: center;justify-content: space-between;">
												<div>水平布局</div>
												<div style="display: flex;align-items: center;margin-left:8px;">
													<div @click="changeRow({justify:'start'})"
														:style="{backgroundColor:selectdItem.containerLayout.justify == 'start'?'#8c62ff':'#fff',color:selectdItem.containerLayout.justify == 'start'?'#fff':'#000',border:selectdItem.containerLayout.justify == 'start'?'solid 1px #8c62ff':'solid 1px #959595' }"
														style="padding: 4px 0px;width: 36px;text-align: center;">
														<span style="scale: 0.85;">靠左</span>
													</div>
													<div @click="changeRow({justify:'center'})"
														:style="{backgroundColor:selectdItem.containerLayout.justify == 'center'?'#8c62ff':'#fff',color:selectdItem.containerLayout.justify == 'center'?'#fff':'#000',border:selectdItem.containerLayout.justify == 'center'?'solid 1px #8c62ff':'solid 1px #959595' }"
														style="padding: 4px 0px;width: 36px;text-align: center;">
														<span style="scale: 0.85;">居中</span>
													</div>
													<div @click="changeRow({justify:'end'})"
														:style="{backgroundColor:selectdItem.containerLayout.justify == 'end'?'#8c62ff':'#fff',color:selectdItem.containerLayout.justify == 'end'?'#fff':'#000',border:selectdItem.containerLayout.justify == 'end'?'solid 1px #8c62ff':'solid 1px #959595' }"
														style="border: solid 1px #959595;padding: 4px 0px;width: 36px;text-align: center;">
														<span style="scale: 0.85;">靠右</span>
													</div>
												</div>
											</div>
											<div style="margin-top: 15px;"
												v-if="selectdItem.compontChildren[0].compoentName != 'wmSwiper'">
												内边距
											</div>
											<div v-if="selectdItem.compontChildren[0].compoentName != 'wmSwiper'"
												style="width: 210px;display: flex;justify-content: center;margin-top: 6px;">
												<div
													style="display: flex;align-items: center;justify-content: space-between;">
													<div
														style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;width: 210px;">
														<div
															style="display: flex;flex-direction: column;align-items: center;">
															<input @input="paddingSet"
																v-model="selectdItem.preStyle.padding[0]"
																style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
															<div style="margin-top: 2px;color: #424242;scale: 0.85;">顶部
															</div>
														</div>
														<div
															style="display: flex;flex-direction: column;align-items: center;">
															<input @input="paddingSet"
																v-model="selectdItem.preStyle.padding[2]"
																style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
															<div style="margin-top: 2px;color: #424242;scale: 0.85;">左侧
															</div>
														</div>
														<div
															style="display: flex;flex-direction: column;align-items: center;">
															<input @input="paddingSet"
																v-model="selectdItem.preStyle.padding[1]"
																style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
															<div style="margin-top:2px;color: #424242;scale: 0.85;">底部
															</div>
														</div>
														<div
															style="display: flex;flex-direction: column;align-items: center;">
															<input @input="paddingSet"
																v-model="selectdItem.preStyle.padding[3]"
																style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
															<div style="margin-top: 2px;color: #424242;scale: 0.85;">右侧
															</div>
														</div>
														<div
															style="display: flex;flex-direction: column;align-items: center;margin-right:11px;">
															<i @click="selectdItem.preStyle.paddingSetAll = !selectdItem.preStyle.paddingSetAll"
																:style="{color:selectdItem.preStyle.paddingSetAll?'#8c62ff':'#000000'}"
																style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
																class="el-icon-paperclip tit-icon"></i>
														</div>
													</div>
												</div>
											</div>
											<div v-if="selectdItem.compontChildren[0].compoentName != 'wmSwiper'"
												style="margin-top: 15px;">
												外边距
											</div>
											<div v-if="selectdItem.compontChildren[0].compoentName != 'wmSwiper'"
												style="width: 210px;display: flex;justify-content: center;margin-top: 6px;">
												<div
													style="display: flex;align-items: center;justify-content: space-between;width: 210px;">
													<div
														style="display: flex;flex-direction: column;align-items: center;">
														<input @input="marginSet"
															v-model="selectdItem.preStyle.margin[0]"
															style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
														<div style="margin-top: 2px;color: #424242;scale: 0.85;">顶部
														</div>
													</div>
													<div
														style="display: flex;flex-direction: column;align-items: center;">
														<input @input="marginSet"
															v-model="selectdItem.preStyle.margin[2]"
															style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
														<div style="margin-top: 2px;color: #424242;scale: 0.85;">左侧
														</div>
													</div>
													<div
														style="display: flex;flex-direction: column;align-items: center;">
														<input @input="marginSet"
															v-model="selectdItem.preStyle.margin[1]"
															style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
														<div style="margin-top:2px;color: #424242;scale: 0.85;">底部</div>
													</div>
													<div
														style="display: flex;flex-direction: column;align-items: center;">
														<input @input="marginSet"
															v-model="selectdItem.preStyle.margin[3]"
															style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
														<div style="margin-top: 2px;color: #424242;scale: 0.85;">右侧
														</div>
													</div>
													<div
														style="display: flex;flex-direction: column;align-items: center;margin-right: 11px;">
														<i @click="selectdItem.preStyle.marginSetAll = !selectdItem.preStyle.marginSetAll"
															:style="{color:selectdItem.preStyle.marginSetAll?'#8c62ff':'#000000'}"
															style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
															class="el-icon-paperclip tit-icon"></i>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div style="display: flex;justify-content: center;cursor: pointer;width: 235px;">
									<div v-if="selectdItem.preStyle.compontentStyle.needFont"
										style="background-color: #F6F7F9;width: 210px;display: flex;flex-direction: column;">
										<div style="width: 100%;height: 1px;background-color: #c7c7c7;margin: 8px 0px;">
										</div>
										<div style="margin: 6px;">
											字体设置
										</div>
										<div
											style="display: flex;justify-content: center;font-size: 12px;margin-top: 10px;">
											<div
												style="display: flex;justify-content: space-around;align-items: center;background-color: #F6F7F9;width: 210px;font-size: 12px;">
												<div>
													字体大小
												</div>
												<wm-input-number :disabled="false" :isIcon="true"
													:styleObj="{width: '136px',height: '32px'}" :step="1" :min="1"
													:max="100000" :value="selectdItem.preStyle.font.size"
													@change="(e)=>{selectdItem.preStyle.font.size = e}"></wm-input-number>
											</div>
										</div>
										<div
											style="width: 198px;display: flex;justify-content: center;margin-top: 10px;font-size: 12px;margin-left: 6px;">
											<div class="flex-item-center"
												style="align-items: center;justify-content: space-between;width: 198px;background-color:#F6F7F9 ;">
												<div>字体斜体</div>
												<el-select size="mini" style="width: 80px;"
													v-model="selectdItem.preStyle.font.italic" placeholder="">
													<el-option label="是" :value="true">
													</el-option>
													<el-option label="否" :value="false">
													</el-option>
												</el-select>
											</div>
										</div>
										<div
											style="display: flex;justify-content: center;margin-top: 5px;font-size: 12px;width:198px;margin-left:6px">
											<div class="flex-item-center"
												style="align-items: center;justify-content: space-between;background-color:#F6F7F9 ;width:198px;">
												<div>字体颜色 / 粗细</div>
												<el-color-picker size="mini" style="height: 28px;width: 28px;"
													v-model="selectdItem.preStyle.font.color"></el-color-picker>
												<el-select size="mini" style="width: 80px;"
													v-model="selectdItem.preStyle.font.weight" placeholder="">
													<el-option v-for="item in fontOptions" :key="item.value"
														:label="item.label" :value="item.value">
													</el-option>
												</el-select>
											</div>
										</div>
										<div
											style="display: flex;justify-content: center;margin-top: 5px;font-size: 12px;width:198px;margin-left:6px">
											<div class="flex-item-center"
												style="align-items: center;justify-content: space-between;background-color:#F6F7F9 ;width:198px;">
												<div>字体类型</div>
												<el-select size="mini" style="width: 130px;"
													v-model="selectdItem.preStyle.font.fontFamily" placeholder="">
													<el-option v-for="(fontItem,index) in fontList" :key="index"
														:label="fontItem.code" :value="fontItem.name">
													</el-option>
												</el-select>
											</div>
										</div>
										<div
											style="display: flex;justify-content: center;margin-top: 5px;font-size: 12px;width:198px;margin-left:6px">
											<div class="flex-item-center"
												style="align-items: center;justify-content: space-between;background-color:#F6F7F9 ;width:198px;">
												悬停颜色
												<el-color-picker size="mini"
													style="height: 32px;width: 32px;margin-top: 4px;"
													v-model="selectdItem.preStyle.compontentStyle.hoverColor"></el-color-picker>
											</div>
										</div>

										<div v-if="selectdItem.compontChildren[0].compoentName == 'wmLangMoney'"
											style="display: flex;justify-content: center;margin-top: 5px;font-size: 12px;width:198px;margin-left:6px">
											<div class="flex-item-center"
												style="align-items: center;justify-content: space-between;background-color:#F6F7F9 ;width:198px;">
												货币图标
												<el-switch style="height:20px"
													v-model="selectdItem.preStyle.fontIcon && selectdItem.preStyle.fontIcon.currency"
													active-color="#13ce66" inactive-color="#ff4949">
												</el-switch>
											</div>
										</div>
										<div v-if="selectdItem.compontChildren[0].compoentName == 'wmLangMoney'"
											style="display: flex;justify-content: center;margin-top: 5px;font-size: 12px;width:198px;margin-left:6px">
											<div class="flex-item-center"
												style="align-items: center;justify-content: space-between;background-color:#F6F7F9 ;width:198px;">
												国旗图标
												<el-switch style="height:20px"
													v-model="selectdItem.preStyle.fontIcon && selectdItem.preStyle.fontIcon.locale"
													active-color="#13ce66" inactive-color="#ff4949">
												</el-switch>
											</div>
										</div>
										
										<div v-if="selectdItem.compontChildren[0].compoentName == 'wmLangMoney'"
											style="display: flex;justify-content: center;margin-top: 5px;font-size: 12px;width:198px;margin-left:6px">
											<div class="flex-item-center"
												style="align-items: center;justify-content: space-between;background-color:#F6F7F9 ;width:198px;">
												语言选择框宽度
												
												
												<wm-input-number :disabled="false"
													style="border: solid 1px #959595 ;"
													:styleObj="{width: '60px',height: '22px'}" :step="1" :min="1"
													:max="240000000000000000000" :value="selectdItem.preStyle.iptSelectW"
													@change="(e)=>{selectdItem.preStyle.iptSelectW = e}"></wm-input-number>
												
											</div>
										</div>
										
									</div>
								</div>
								<div style="display: flex;justify-content: center;cursor: pointer;width: 235px;">
									<div
										style="background-color: #F6F7F9;width: 210px;display: flex;flex-direction: column;">
										<div style="width: 100%;height: 1px;background-color: #c7c7c7;margin: 8px 0px;">
										</div>
										<div v-if="selectdItem.preStyle.compontentStyle.needHW && equipment == 'pc'  && selectdItem.compontChildren[0].compoentName == 'wmImg'"
											style="display: flex;align-items: center;justify-content: space-between;padding: 6px;">
											<div>显示模式</div>
											<div style="display: flex;align-items: center;margin-left:8px;">
												<div @click="selectdItem.preStyle.compontentStyle.percentWidthSwitch = true"
													:style="{backgroundColor:selectdItem.preStyle.compontentStyle.percentWidthSwitch?'#8c62ff':'#fff',color:selectdItem.preStyle.compontentStyle.percentWidthSwitch?'#fff':'#000',border:selectdItem.preStyle.compontentStyle.percentWidthSwitch?'solid 1px #8c62ff':'solid 1px #959595' }"
													style="padding: 4px 0px;width: 56px;text-align: center;">
													<span style="scale: 0.85;">裁剪填充</span>
												</div>
												<div @click="selectdItem.preStyle.compontentStyle.percentWidthSwitch = false"
													:style="{backgroundColor:!selectdItem.preStyle.compontentStyle.percentWidthSwitch?'#8c62ff':'#fff',color:!selectdItem.preStyle.compontentStyle.percentWidthSwitch?'#fff':'#000',border:!selectdItem.preStyle.compontentStyle.percentWidthSwitch?'solid 1px #8c62ff':'solid 1px #959595' }"
													style="padding: 4px 0px;width: 56px;text-align: center;">
													<span style="scale: 0.85;">原图填充</span>
												</div>
											</div>
										</div>
										<div v-if="selectdItem.preStyle.compontentStylePhone.needHW && equipment == 'phone' && selectdItem.compontChildren[0].compoentName == 'wmImg'"
											style="display: flex;align-items: center;justify-content: space-between;padding: 6px;">
											<div>显示模式</div>
											<div style="display: flex;align-items: center;margin-left:8px;">
												<div @click="selectdItem.preStyle.compontentStylePhone.percentWidthSwitch = true"
													:style="{backgroundColor:selectdItem.preStyle.compontentStylePhone.percentWidthSwitch?'#8c62ff':'#fff',color:selectdItem.preStyle.compontentStylePhone.percentWidthSwitch?'#fff':'#000',border:selectdItem.preStyle.compontentStylePhone.percentWidthSwitch?'solid 1px #8c62ff':'solid 1px #959595' }"
													style="padding: 4px 0px;width: 56px;text-align: center;">
													<span style="scale: 0.85;">裁剪填充</span>
												</div>
												<div @click="selectdItem.preStyle.compontentStylePhone.percentWidthSwitch = false"
													:style="{backgroundColor:!selectdItem.preStyle.compontentStylePhone.percentWidthSwitch?'#8c62ff':'#fff',color:!selectdItem.preStyle.compontentStylePhone.percentWidthSwitch?'#fff':'#000',border:!selectdItem.preStyle.compontentStylePhone.percentWidthSwitch?'solid 1px #8c62ff':'solid 1px #959595' }"
													style="padding: 4px 0px;width: 56px;text-align: center;">
													<span style="scale: 0.85;">原图填充</span>
												</div>
											</div>
										</div>
										<div v-if="equipment == 'pc'"
											style="display: flex;flex-direction: column;width: 210px;align-items: center;margin-top: 10px;font-size: 12px;">
											<div
												style="display: flex;justify-content: space-between;align-items: center;width: 210px;">
												<div style="margin-left:7px;"
													v-if="selectdItem.preStyle.compontentStyle.needHW ">
													{{selectdItem.compontChildren[0].name}}宽度
												</div>
												<div v-if="selectdItem.preStyle.compontentStyle.needHW">
													<wm-input-number :iptWidth="60" :disabled="false"
														:styleObj="{width: '120px',height: '32px'}" :step="1" :min="1"
														:max="10000000"
														:value="selectdItem.preStyle.compontentStyle.width"
														@change="(e)=>{selectdItem.preStyle.compontentStyle.width = e}"></wm-input-number>
												</div>
											</div>
										</div>
										<div v-if="equipment == 'pc'" :style="{
												marginTop:selectdItem.preStyle.compontentStyle.needHW?'10px':'0px'
											}" style="display: flex;flex-direction: column;width: 210px;align-items: center;font-size: 12px;">
											<div
												style="display: flex;justify-content: space-between;align-items: center;width: 210px;">
												<div style="margin-left:7px;"
													v-if="selectdItem.preStyle.compontentStyle.needHW">
													{{selectdItem.compontChildren[0].name}}高度
												</div>
												<div v-if="selectdItem.preStyle.compontentStyle.needHW">
													<wm-input-number :iptWidth="60" :disabled="false"
														:styleObj="{width: '120px',height: '34px'}" :step="1" :min="1"
														:max="10000000"
														:value="selectdItem.preStyle.compontentStyle.height"
														@change="(e)=>{selectdItem.preStyle.compontentStyle.height = e}"></wm-input-number>
												</div>
											</div>
										</div>
										<div v-if="equipment == 'phone'"
											style="display: flex;flex-direction: column;width: 210px;align-items: center;margin-top: 10px;font-size: 12px;">
											<div
												style="display: flex;justify-content: space-between;align-items: center;width: 210px;">
												<div style="margin-left:7px;"
													v-if="selectdItem.preStyle.compontentStylePhone.needHW">
													{{selectdItem.compontChildren[0].name}}宽度
												</div>
												<div v-if="selectdItem.preStyle.compontentStylePhone.needHW">
													<wm-input-number :iptWidth="60" :disabled="false"
														:styleObj="{width: '120px',height: '32px'}" :step="1" :min="1"
														:max="10000000"
														:value="selectdItem.preStyle.compontentStylePhone.width"
														@change="(e)=>{selectdItem.preStyle.compontentStylePhone.width = e}"></wm-input-number>
												</div>
											</div>
										</div>
										<div v-if="equipment == 'phone'" :style="{
												marginTop:selectdItem.preStyle.compontentStylePhone.needHW?'10px':'0PX'
											}" style="display: flex;flex-direction: column;width: 210px;align-items: center;font-size: 12px;">
											<div
												style="display: flex;justify-content: space-between;align-items: center;width: 210px;">
												<div style="margin-left:7px;"
													v-if="selectdItem.preStyle.compontentStylePhone.needHW">
													{{selectdItem.compontChildren[0].name}}高度
												</div>
												<div v-if="selectdItem.preStyle.compontentStylePhone.needHW">
													<wm-input-number :iptWidth="60" :disabled="false"
														:styleObj="{width: '120px',height: '34px'}" :step="1" :min="1"
														:max="10000000"
														:value="selectdItem.preStyle.compontentStylePhone.height"
														@change="(e)=>{selectdItem.preStyle.compontentStylePhone.height = e}"></wm-input-number>
												</div>
											</div>
										</div>


										<div style="" class="flex-item-center"
											style="align-items: center;justify-content: space-between;margin: 0px 6px;">
											<div style="font-size: 12px;">容器边框</div>
											<div style="display: flex;align-items: center;margin-left:8px;">
												<div @click="selectdItem.preStyle.border.type = ''"
													:style="{backgroundColor: selectdItem.preStyle.border.type == ''?'#8c62ff':'#fff',color: selectdItem.preStyle.border.type == ''?'#fff':'#000',border: selectdItem.preStyle.border.type == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
													style="padding: 4px 0px;width: 36px;text-align: center;">
													<span style="scale: 0.85;">无</span>
												</div>
												<div @click="selectdItem.preStyle.border.type = 'solid'"
													:style="{backgroundColor: selectdItem.preStyle.border.type == 'solid'?'#8c62ff':'#fff',color: selectdItem.preStyle.border.type == 'solid'?'#fff':'#000',border: selectdItem.preStyle.border.type == 'solid'?'solid 1px #8c62ff':'solid 1px #959595' }"
													style="padding: 4px 0px;width: 36px;text-align: center;">
													<span style="scale: 0.85;">实线</span>
												</div>
												<div @click="selectdItem.preStyle.border.type = 'dashed'"
													:style="{backgroundColor:selectdItem.preStyle.border.type == 'dashed'?'#8c62ff':'#fff',color:selectdItem.preStyle.border.type == 'dashed'?'#fff':'#000',border:selectdItem.preStyle.border.type == 'dashed'?'solid 1px #8c62ff':'solid 1px #959595' }"
													style="padding: 4px 0px;width: 36px;text-align: center;">
													<span style="scale: 0.85;">虚线</span>
												</div>
											</div>
										</div>
										<div style="" class="flex-item-center"
											style="align-items: center;justify-content: space-between;margin: 6px;">
											<div style="font-size: 12px;">边框颜色</div>
											<el-color-picker size="mini" style="height: 34px;width: 34px;"
												v-model="selectdItem.preStyle.border.color"></el-color-picker>
											<el-input size="mini" style="height: 34px;width: 82px;" disabled
												:value="selectdItem.preStyle.border.color"></el-input>
										</div>
										<div v-if="selectdItem.preStyle.border.borderSize" style="margin-top: 10px;">
											<div style="margin-left: 6px;">线条大小</div>
											<div
												style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
												<div style="display: flex;flex-direction: column;align-items: center;">
													<input @input="changeContainerSize"
														v-model="selectdItem.preStyle.border.borderSize[0]"
														style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
													<div style="margin-top: 2px;color: #424242;scale: 0.85;">顶部</div>
												</div>
												<div style="display: flex;flex-direction: column;align-items: center;">
													<input @input="changeContainerSize"
														v-model="selectdItem.preStyle.border.borderSize[1]"
														style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
													<div style="margin-top: 2px;color: #424242;scale: 0.85;">左侧</div>
												</div>
												<div style="display: flex;flex-direction: column;align-items: center;">
													<input @input="changeContainerSize"
														v-model="selectdItem.preStyle.border.borderSize[2]"
														style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
													<div style="margin-top: 2px;color: #424242;scale: 0.85;">底部</div>
												</div>
												<div style="display: flex;flex-direction: column;align-items: center;">
													<input @input="changeContainerSize"
														v-model="selectdItem.preStyle.border.borderSize[3]"
														style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
													<div style="margin-top: 2px;color: #424242;scale: 0.85;">右侧</div>
												</div>
												<div
													style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
													<i @click="borderContainerSizeAll = !borderContainerSizeAll"
														:style="{color:borderContainerSizeAll?'#8c62ff':'#000'}"
														style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
														class="el-icon-paperclip tit-icon"></i>
												</div>
											</div>
										</div>
										<div style="margin-top: 10px;" v-if="selectdItem.preStyle.border.borderRadius">
											<div style="margin-left: 6px;">边框圆角</div>
											<div
												style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px 0px 6px 6px;">
												<div style="display: flex;flex-direction: column;align-items: center;">
													<input @input="changeContainerBorderRadius"
														v-model="selectdItem.preStyle.border.borderRadius[0]"
														style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
													<div style="margin-top: 2px;color: #424242;scale: 0.85;">左上</div>
												</div>
												<div style="display: flex;flex-direction: column;align-items: center;">
													<input @input="changeContainerBorderRadius"
														v-model="selectdItem.preStyle.border.borderRadius[1]"
														style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
													<div style="margin-top: 2px;color: #424242;scale: 0.85;">右上</div>
												</div>
												<div style="display: flex;flex-direction: column;align-items: center;">
													<input @input="changeContainerBorderRadius"
														v-model="selectdItem.preStyle.border.borderRadius[2]"
														style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
													<div style="margin-top:2px;color: #424242;scale: 0.85;">右下</div>
												</div>
												<div style="display: flex;flex-direction: column;align-items: center;">
													<input @input="changeContainerBorderRadius"
														v-model="selectdItem.preStyle.border.borderRadius[3]"
														style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
													<div style="margin-top: 2px;color: #424242;scale: 0.85;">左下</div>
												</div>
												<div
													style="display: flex;flex-direction: column;align-items: center;margin-right: 4px;">
													<i @click="borderContainerRadiusAll = !borderContainerRadiusAll"
														:style="{color:borderContainerRadiusAll?'#8c62ff':'#000'}"
														style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
														class="el-icon-paperclip tit-icon"></i>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div style="display: flex;justify-content: center;cursor: pointer;width: 235px;">
									<div
										style="background-color: #F6F7F9;width: 210px;display: flex;margin-bottom: 10px;flex-direction: column;">
										<div style="width: 100%;height: 1px;background-color: #c7c7c7;margin: 8px 0px;">
										</div>
										<div style="margin: 6px;">
											容器阴影
										</div>
										<div
											style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
											<div style="display: flex;flex-direction: column;align-items: center;">
												<input v-model="selectdItem.preStyle.boxShadow.h"
													style="width: 44px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
												<div style="margin-top: 2;color: #424242;scale: 0.85;">x轴偏移</div>
											</div>
											<div style="display: flex;flex-direction: column;align-items: center;">
												<input v-model="selectdItem.preStyle.boxShadow.v"
													style="width: 44px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
												<div style="margin-top: 2;color: #424242;scale: 0.85;">Y轴偏移</div>
											</div>
											<div style="display: flex;flex-direction: column;align-items: center;">
												<input v-model="selectdItem.preStyle.boxShadow.blur"
													style="width: 44px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
												<div style="margin-top: 2;color: #424242;scale: 0.85;">模糊半径</div>
											</div>
											<div style="display: flex;flex-direction: column;align-items: center;">
												<input v-model="selectdItem.preStyle.boxShadow.spread"
													style="width: 44px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
												<div style="margin-top: 2;color: #424242;scale: 0.85;">扩散半径</div>
											</div>
										</div>

										<div
											style="width: 210px;display: flex;justify-content: center;margin-top: 10px;font-size: 12px;">
											<div class="flex-item-center"
												style="align-items: center;width: 210px;justify-content: space-around;background-color: #F6F7F9;">
												<div style="font-size: 12px;">
													颜色 / 方向
												</div>
												<el-color-picker size="mini" style="width: 34px;"
													v-model="selectdItem.preStyle.boxShadow.color"></el-color-picker>
												<el-select size="mini" style="width: 88px;"
													v-model="selectdItem.preStyle.boxShadow.type" placeholder="阴影方向">
													<el-option
														:style="{color:selectdItem.preStyle.boxShadow.type == 'outset'?'#8C62FF':'#6b6b6b'}"
														style="" label="外阴影" value="outset">
													</el-option>
													<el-option
														:style="{color:selectdItem.preStyle.boxShadow.type == 'inset'?'#8C62FF':'#6b6b6b'}"
														style="" label="内阴影" value="inset">
													</el-option>
													</el-option>
												</el-select>
											</div>
										</div>
										<div style="height: 10px;width: 100%;"></div>
									</div>
								</div>
								<div v-if="selectdItem.compontChildren[0].compoentName == 'wmGoods'"
									style="display: flex;justify-content: center;cursor: pointer;width: 235px;margin-top: 15px;">
									<div
										style="background-color: #F6F7F9;width: 210px;display: flex;margin-bottom: 10px;flex-direction: column;border-radius: 10px 10px 0px 0px;">
										<div
											style="width: 210px;padding-top: 9px;padding-bottom: 9px;font-size: 14px;margin: auto;text-align: center;background-color: #aaa7a7;border-radius: 10px 10px 0px 0px;border-bottom: solid 1px #c6c6c6;">
											{{selectdItem.compontChildren[0].name + '设置'}}
										</div>

										<div>
											<goods-tool :all_setting="all_setting" :fontList="fontList"
												:equipment="equipment" @changeSelectClassfiy="haveData = true"
												@confirmGoods="confirmGoods;" :systemConfig="systemConfig"
												:selectdItem="selectdItem"></goods-tool>
										</div>
										<div style="margin: 6px;">
											模块设置
										</div>

										<div
											style="display: flex;justify-content: center;font-size: 12px;margin-top: 10px;">
											<div
												style="display: flex;justify-content: space-around;align-items: center;background-color: #F6F7F9;width: 210px;font-size: 12px;padding: 2px 0px;">
												<div>
													价格颜色
												</div>
												<el-color-picker size="mini" style="height: 34px;width: 34px;"
													v-model="selectdItem.preStyle.border.color"></el-color-picker>
											</div>
										</div>
										<div
											style="display: flex;justify-content: center;font-size: 12px;margin-top: 10px;">
											<div
												style="display: flex;justify-content: space-around;align-items: center;background-color: #F6F7F9;width: 210px;font-size: 12px;padding: 2px 0px;">
												<div>
													模块类型
												</div>
												<el-select @change="(e)=>{
													e == 'list'?'':selectdItem.compontChildren[0].preStyle.showModuleWidthHeightPre = false
												}" size="mini" style="width: 120px;" v-model="selectdItem.compontChildren[0].preStyle.moduleType"
													placeholder="">
													<el-option label="列表" value="list">
													</el-option>
													<el-option label="左右滑动列表" value="scroll">
													</el-option>
												</el-select>
											</div>
										</div>
										<div
											style="display: flex;justify-content: center;font-size: 12px;margin-top: 10px;">
											<div
												style="display: flex;justify-content: center;font-size: 12px;margin-top: 0px;">
												<div
													style="display: flex;justify-content: space-around;align-items: center;background-color: #F6F7F9;width: 210px;font-size: 12px;padding: 6px 0px;">
													<div>隐藏名称和价格</div>
													<div style="width: 90px;">
														<el-switch
															v-model="selectdItem.compontChildren[0].preStyle.showNamePrice"
															active-color="#13ce66" inactive-color="#ff4949">
														</el-switch>
													</div>
												</div>
											</div>
										</div>
										<div
											style="display: flex;justify-content: center;font-size: 12px;margin-top: 10px;">
											<div
												style="display: flex;justify-content: center;font-size: 12px;margin-top: 0px;">
												<div
													style="display: flex;justify-content: space-around;align-items: center;background-color: #F6F7F9;width: 210px;font-size: 12px;padding: 6px 0px;">
													<div>开启模块宽高按百分比</div>
													<div style="width: 60px;">
														<el-switch
															v-model="selectdItem.compontChildren[0].preStyle.showModuleWidthHeightPre"
															active-color="#13ce66" inactive-color="#ff4949">
														</el-switch>
													</div>
												</div>
											</div>
										</div>
										<div
											style="display: flex;justify-content: center;font-size: 12px;margin-top: 10px;">
											<div v-if="selectdItem.compontChildren[0].preStyle.showModuleWidthHeightPre"
												style="display: flex;justify-content: center;font-size: 12px;margin-top: 0px;">
												<div
													style="display: flex;justify-content: space-around;align-items: center;background-color: #F6F7F9;width: 210px;font-size: 12px;">
													<div>
														宽高按百分比(仅列表)
													</div>
													<wm-input-number :disabled="false"
														:styleObj="{width: '60px',height: '32px'}" :step="1" :min="0"
														:max="100000"
														:value="selectdItem.compontChildren[0].preStyle.moduleWidthHeightPre"
														@change="(e)=>{selectdItem.compontChildren[0].preStyle.moduleWidthHeightPre = e}"></wm-input-number>
												</div>
											</div>
										</div>
										<div
											style="display: flex;justify-content: center;font-size: 12px;margin-top: 0px;">
											<div v-if="!selectdItem.compontChildren[0].preStyle.showModuleWidthHeightPre"
												style="display: flex;justify-content: center;font-size: 12px;margin-top: 0px;">
												<div
													style="display: flex;justify-content: space-around;align-items: center;background-color: #F6F7F9;width: 210px;font-size: 12px;">
													<div>
														宽高像素
													</div>
													<wm-input-number :disabled="false"
														:styleObj="{width: '100px',height: '32px'}" :step="1" :min="0"
														:max="100000"
														:value="selectdItem.compontChildren[0].preStyle.moduleWidthHeight"
														@change="(e)=>{selectdItem.compontChildren[0].preStyle.moduleWidthHeight = e}"></wm-input-number>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div style="margin-top: 15px;">
									<div
										style="display: flex;flex-direction: column;width: 235px;align-items: center;margin-top: 15px;">
									</div>
								</div>
							</div>
							<div v-if="rightTab == '3'" style="font-size: 12px;">
								<component :isFullWidthKey="isFullWidthKey"
									v-if="selectdItem.compontChildren[0].designToolName" :fontList="fontList"
									:all_setting="all_setting" :systemConfig="systemConfig" type="design"
									:equipment="equipment" :selectdItem="selectdItem" style="height: 100%;width: 100%;"
									:is="selectdItem.compontChildren[0].designToolName">
								</component>
								<div style="width: 210px;margin-left: 12px;background-color: #F6F7F9;">
									<div v-if="selectdItem.compontChildren[0].data.imgUrl">
										<div
											style="width: 210px;padding-top: 9px;padding-bottom: 9px;font-size: 14px;margin: auto;text-align: center;background-color: #aaa7a7;margin-top: 10px;border-radius: 10px 10px 0px 0px;border-bottom: solid 1px #c6c6c6;">
											{{selectdItem.compontChildren[0].name + '设置'}}
										</div>
										<div style="padding-bottom: 10px;"
											v-for="(imgItem,imgIndex) in selectdItem.compontChildren[0].data.imgUrl.list"
											:key="imgIndex">
											<div style="margin-left: 20px;padding-top: 10px;">图片{{imgIndex + 1}}
											</div>
											<div style="display: flex;justify-content: center;">
												<div
													style="display: flex;align-items: center;height: 72px;width: 210px;justify-content: space-around;">
													<div @click="dialogVisibleImgs = true;imgsIndex = imgIndex"
														style="height: 60px;width: 120px;background-color: #fff;display: flex;align-items: center;justify-content: center;cursor: pointer;">
														<el-image fit="contain" style="width: 100%;height: 100%;"
															:src="imgItem.url">
															<div slot="error" class="image-slot"
																style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;">
																<i style="font-weight: bold;font-size: 22px;"
																	class="el-icon-plus"></i>
															</div>
														</el-image>
													</div>
													<div @click="deleteImgs(imgIndex);"
														v-if="imgIndex != 0 && imgIndex != selectdItem.compontChildren[0].data.imgUrl.list.length - 1"
														style="color: #8c62ff;cursor: pointer;font-weight: bold;">删除
													</div>
												</div>
											</div>
											<select-page :link="imgItem.link"
												@confirmSelect="($event)=>{imgItem.link = $event}"></select-page>
										</div>
									</div>
									<div style="display: flex;justify-content: center;flex-direction: column;align-items: center;width: 100%;padding: 7px 0px;"
										v-if="selectdItem.compontChildren[0].data.text">
										<select-page :link="selectdItem.compontChildren[0].data.link"
											style="width: 210px;"
											@confirmSelect="($event)=>{selectdItem.compontChildren[0].data.link = $event;haveData = true}"></select-page>
										<wm-text-data style="margin-top: 10px;" :all_setting="all_setting"
											:systemConfig="systemConfig" typeView="design" :equipment="equipment"
											:compontentStyle="selectdItem.preStyle.compontentStyle"
											:selectdItem="selectdItem"></wm-text-data>
									</div>
									<div style="display: flex;justify-content: center;flex-direction: column;align-items: center;width: 100%;padding: 0px 0px;"
										v-if="selectdItem.compontChildren[0].designName">
										<component :isFullWidthKey="isFullWidthKey" :fontList="fontList"
											:all_setting="all_setting" :systemConfig="systemConfig" typeView="design"
											:equipment="equipment"
											:compontentStyle="selectdItem.preStyle.compontentStyle"
											:selectdItem="selectdItem" :is="selectdItem.compontChildren[0].designName">
										</component>
									</div>
								</div>
								<div style="width: 100%;height: 30px;"></div>
							</div>
						</div>

						<div class="parent-container" v-if="selectdItem && selectdItem.level < 3" :key="item.name"
							v-for="(item, index) in rightTabs" :label="item.title" :name="item.name">
							<div
								style="width: 210px;padding-top: 9px;padding-bottom: 9px;font-size: 14px;margin: auto;text-align: center;background-color: #aaa7a7;margin-top: 10px;border-radius: 10px 10px 0px 0px;border-bottom: solid 1px #c6c6c6;">
								{{item.title + '设置'}}
							</div>
							<div style="padding: 0px 4px 0px 4px;font-size: 14px;font-size: 12px;">
								<div>
									<div v-if="pageValue == pageValueEnum.pcNav || pageValue == pageValueEnum.phoneNav"
										style="display: flex;flex-direction: column;width: 235px;align-items: center;font-size: 12px;">
										<div
											style="display: flex;align-items: center;background-color: #F6F7F9;height: 36px;width: 210px;justify-content: space-around;">
											<div>
												粘性置顶
											</div>
											<el-switch v-model="selectdItem.preStyle.sticky" active-color="#13ce66"
												inactive-color="#ff4949">
											</el-switch>
										</div>
									</div>
									<div :style="{marginTop:pageValue == pageValueEnum.pcNav || pageValue == pageValueEnum.phoneNav?'0px':'0px'}"
										style="display: flex;justify-content: center;cursor: pointer;width: 235px;">
										<div
											style="background-color: #F6F7F9;width: 210px;display: flex;flex-direction: column;align-items: center;">
											<div v-if="selectdItem.level == 1  && pageValue != '1' && pageValue != '3'"
												style="display: flex;align-items: center;justify-content: space-around;margin-top: 5px;width: 210px;">
												<div>设备选择</div>
												<div style="display: flex;align-items: center;margin-left:8px;">
													<div @click="selectdItem.applyType = 'all'"
														:style="{backgroundColor:selectdItem.applyType == 'all'?'#8c62ff':'#fff',color:selectdItem.applyType == 'all'?'#fff':'#000',border:selectdItem.applyType == 'all'?'solid 1px #8c62ff':'solid 1px #959595' }"
														style="padding: 4px 0px;width: 38px;text-align: center;">
														<span style="scale: 0.85;">全部</span>
													</div>
													<div @click="selectdItem.applyType = 'pc'"
														:style="{backgroundColor:selectdItem.applyType == 'pc'?'#8c62ff':'#fff',color:selectdItem.applyType == 'pc'?'#fff':'#000',border:selectdItem.applyType == 'pc'?'solid 1px #8c62ff':'solid 1px #959595' }"
														style="padding: 4px 0px;width: 38px;text-align: center;">
														<span style="scale: 0.85;">pc端</span>
													</div>
													<div @click="selectdItem.applyType = 'phone'"
														:style="{backgroundColor:selectdItem.applyType == 'phone'?'#8c62ff':'#fff',color:selectdItem.applyType == 'phone'?'#fff':'#000',border:selectdItem.applyType == 'phone'?'solid 1px #8c62ff':'solid 1px #959595' }"
														style="border: solid 1px #959595;padding: 4px 0px;width: 38px;text-align: center;">
														<span style="scale: 0.85;">移动端</span>
													</div>
												</div>
											</div>
											<div v-if="selectdItem.level == 1  && pageValue != '1' && pageValue != '3'"
												style="color: #424242;scale: 0.85;margin-top: 4px;">
												选择本容器生效的设备
											</div>
											<div
												style="height: 28px;background-color: #F6F7F9;width: 210px;display: flex;align-items: center;justify-content: space-around;margin-top: 6px;">
												<div>
													容器宽度占比
												</div>
												<div style="display: flex;align-items: center;">
													<wm-input-number :disabled="false"
														style="border: solid 1px #959595 ;"
														:styleObj="{width: '50px',height: '22px'}" :step="1" :min="1"
														:max="24" :value="getColSpan()"
														@change="changeColSpan($event)"></wm-input-number>
													<div
														style="width: 50px;border: solid 1px #959595;background-color: #8c62ff;text-align: center;color: #fff;padding: 4px 0px;">
														/ 24
													</div>
												</div>
											</div>
											<div style="color: #424242;scale: 0.85;">
												页面总宽度分为24份,可设置当前容器占比父容器的比例,最外层容器父容器占页面宽度
											</div>
										</div>
									</div>
								</div>
								<div style="display: flex;justify-content: center;cursor: pointer;width: 235px;">
									<div
										style="background-color: #F6F7F9;width: 210px;display: flex;flex-direction: column;">
										<div
											style="width: 100%; height: 1px;background-color: #c7c7c7;margin: 8px 0px;">
										</div>
										<div v-if="selectdItem.level == 1 && isBoxWidth && equipment == 'pc' && selectdItem.containerLayout.col.span == 24"
											style="display: flex;justify-content: space-between">
											<div style="margin: 6px;">
												背景突破
											</div>
											<div style="display: flex;align-items: center;margin-left:8px;">
												<div @click="selectdItem.isFullWidthBg = true"
													:style="{backgroundColor:selectdItem.isFullWidthBg?'#8c62ff':'#fff',color:selectdItem.isFullWidthBg?'#fff':'#000',border:selectdItem.isFullWidthBg?'solid 1px #8c62ff':'solid 1px #959595' }"
													style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
													<span style="scale: 0.85;">是</span>
												</div>
												<div @click="selectdItem.isFullWidthBg = false"
													:style="{backgroundColor:!selectdItem.isFullWidthBg?'#8c62ff':'#fff',color:!selectdItem.isFullWidthBg?'#fff':'#000',border:!selectdItem.isFullWidthBg?'solid 1px #8c62ff':'solid 1px #959595' }"
													style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
													<span style="scale: 0.85;">否</span>
												</div>
											</div>
										</div>
										<div v-if="selectdItem.level == 1 && isBoxWidth && equipment == 'pc' && selectdItem.containerLayout.col.span == 24"
											style="display: flex;justify-content: space-between">
											<div style="margin: 6px;">
												容器突破
											</div>
											<div style="display: flex;align-items: center;margin-left:8px;">
												<div @click="selectdItem.isFullWidth = true;isFullWidthKey = isFullWidthKey + 1"
													:style="{backgroundColor:selectdItem.isFullWidth?'#8c62ff':'#fff',color:selectdItem.isFullWidth?'#fff':'#000',border:selectdItem.isFullWidth?'solid 1px #8c62ff':'solid 1px #959595' }"
													style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
													<span style="scale: 0.85;">是</span>
												</div>
												<div @click="selectdItem.isFullWidth = false;isFullWidthKey = isFullWidthKey + 1"
													:style="{backgroundColor:!selectdItem.isFullWidth?'#8c62ff':'#fff',color:!selectdItem.isFullWidth?'#fff':'#000',border:!selectdItem.isFullWidth?'solid 1px #8c62ff':'solid 1px #959595' }"
													style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
													<span style="scale: 0.85;">否</span>
												</div>
											</div>
										</div>
										<div style="display: flex;justify-content: space-between;margin-top: 10px;">
											<div style="margin: 6px;">
												容器背景
											</div>
											<div v-if="selectdItem.preStyle.bg.bgtype"
												style="display: flex;align-items: center;margin-left:8px;">
												<div @click="selectdItem.preStyle.bg.bgtype = 'color'"
													:style="{backgroundColor:selectdItem.preStyle.bg.bgtype == 'color'?'#8c62ff':'#fff',color:selectdItem.preStyle.bg.bgtype == 'color'?'#fff':'#000',border:selectdItem.preStyle.bg.bgtype == 'color'?'solid 1px #8c62ff':'solid 1px #959595' }"
													style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
													<span style="scale: 0.85;">纯色</span>
												</div>
												<div @click="selectdItem.preStyle.bg.bgtype = 'gradient'"
													:style="{backgroundColor:selectdItem.preStyle.bg.bgtype == 'gradient'?'#8c62ff':'#fff',color:selectdItem.preStyle.bg.bgtype == 'gradient'?'#fff':'#000',border:selectdItem.preStyle.bg.bgtype == 'gradient'?'solid 1px #8c62ff':'solid 1px #959595' }"
													style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
													<span style="scale: 0.85;">渐变</span>
												</div>
												<div @click="selectdItem.preStyle.bg.bgtype = 'img'"
													:style="{backgroundColor:selectdItem.preStyle.bg.bgtype == 'img'?'#8c62ff':'#fff',color:selectdItem.preStyle.bg.bgtype == 'img'?'#fff':'#000',border:selectdItem.preStyle.bg.bgtype == 'img'?'solid 1px #8c62ff':'solid 1px #959595' }"
													style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
													<span style="scale: 0.85;">图片</span>
												</div>
											</div>

										</div>




										<div v-if="selectdItem.preStyle.bg.bgtype == 'img'"
											style="display: flex;justify-content: center;margin-top: 10px;width: 235px;font-size: 12px;">
											<div
												style="display: flex;align-items: center;background-color: #F6F7F9;height: 38px;width: 210px;justify-content: space-around;">
												<div style="font-size: 12px;">
													背景图片
												</div>
												<div @click="selectBgImg"
													style="height: 30px;width: 30px;background-color: #fff;display: flex;align-items: center;justify-content: center;">
													<el-image :src="selectdItem.preStyle.bg.img"
														style="cursor: pointer;">
														<div slot="error" class="image-slot">
															<i style="font-size: 16px;" class="el-icon-plus"></i>
														</div>
													</el-image>
												</div>
												<el-select size="mini" style="width: 82px;"
													v-model="selectdItem.preStyle.bg.type" filterable allow-create
													default-first-option placeholder="渲染方式">
													<el-option label="重复" value="repeat">
													</el-option>
													<el-option label="x轴重复" value="repeat-x">
													</el-option>
													<el-option label="y轴重复" value="repeat-y">
													</el-option>
													<el-option label="平铺" value="">
													</el-option>
													<el-option label="不平铺" value="no-repeat">
													</el-option>
												</el-select>
											</div>
										</div>
										<div v-if="selectdItem.preStyle.bg.bgtype == 'img'"
											style="display: flex;justify-content: center;">
											<div
												style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
												<div style="width: 40px;">
													宽度:
												</div>
												<wm-input-number style="margin-left: 10px;" :iptWidth="80"
													:disabled="false" :styleObj="{width: '100px',height: '30px'}"
													:step="1" :min="1" :max="10000000000"
													:value="selectdItem.preStyle.bg.bgImgWidth"
													@change="(e)=>{selectdItem.preStyle.bg.bgImgWidth = e}"></wm-input-number>
											</div>
										</div>
										<div v-if="selectdItem.preStyle.bg.bgtype == 'img'"
											style="display: flex;justify-content: center;">
											<div
												style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
												<div style="width: 40px;">
													高度:
												</div>
												<wm-input-number style="margin-left: 10px;" :iptWidth="80"
													:disabled="false" :styleObj="{width: '100px',height: '30px'}"
													:step="1" :min="1" :max="10000000000"
													:value="selectdItem.preStyle.bg.bgImgHeigth"
													@change="(e)=>{selectdItem.preStyle.bg.bgImgHeigth = e}"></wm-input-number>
											</div>
										</div>

										<div v-if="selectdItem.preStyle.bg.bgtype == 'img'"
											style="display: flex;align-items: center;margin-left: 10px;margin-top: 10px;">
											<div>
												背景位置
											</div>

											<el-select @change="(e)=>{selectdItem.preStyle.bg.position = e}"
												style="margin-left: 10px;width: 120px;"
												v-model="selectdItem.preStyle.bg.position" filterable allow-create
												default-first-option placeholder="图片位置">
												<el-option label="左上方" value="top left">
												</el-option>
												<el-option label="上中间" value="top center">
												</el-option>
												<el-option label="右上方" value="top right">
												</el-option>
												<el-option label="左中方" value="center left">
												</el-option>
												<el-option label="居中" value="center center">
												</el-option>
												<el-option label="右中方" value="center right">
												</el-option>
												<el-option label="下左方" value="bottom left">
												</el-option>
												<el-option label="下居中" value="bottom center">
												</el-option>
												<el-option label="下右方" value="bottom right">
												</el-option>
											</el-select>
										</div>

										<div v-if="selectdItem.preStyle.bg.bgtype == 'gradient'"
											style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
											<div
												style="width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
												<div style="display: flex;flex-direction: column;">
													<div style="display: flex;align-items: center;">
													</div>
													<el-input style="width: 172px;margin-top: 4px;" type="textarea"
														:rows="3" placeholder="请输入内容"
														v-model="selectdItem.preStyle.bg.bgGradient">
													</el-input>
												</div>
												<div style="margin-top: 6px;font-size: 12px;color: #55aaff;">
													需要更多模板设置请访问 <a target="_blank" style="margin-left: 4px;"
														href="https://www.eggradients.com/">Gradient1</a> <a
														style="margin-left: 4px;" target="_blank"
														href="https://webgradients.com/">Gradient2</a>
												</div>
											</div>
										</div>


										<div v-if="selectdItem.preStyle.bg.bgtype && selectdItem.preStyle.bg.bgtype == 'color'"
											style="display: flex;justify-content: center;margin-top: 10px;width: 210px;margin-bottom: 0px;font-size: 12px;">
											<div
												style="display: flex;align-items: center;background-color: #F6F7F9;height: 34px;width: 210px;justify-content: space-around;">
												<div style="font-size: 12px;">
													背景纯色
												</div>
												<el-color-picker size="mini" @change="(e)=>{
														selectdItem.preStyle.background.color1 = e
														selectdItem.preStyle.background.color2 = e
													}" style="height: 28px;width: 28px;margin-top: 4px;"
													v-model="selectdItem.preStyle.background.color1"></el-color-picker>
											</div>
										</div>
									</div>
								</div>
								<div style="display: flex;justify-content: center;cursor: pointer;width: 235px;">
									<div
										style="background-color: #F6F7F9;width: 210px;display: flex;flex-direction: column;">
										<div
											style="width: 100%; height: 1px;background-color: #c7c7c7;margin: 8px 0px;">
										</div>
										<div style="margin: 6px;">
											容器布局
										</div>
										<div style="margin:6px;">
											<div
												style="display: flex;align-items: center;justify-content: space-between;">
												<div>水平布局</div>
												<div style="display: flex;align-items: center;margin-left:8px;">
													<div @click="changeRow({justify:'start'})"
														:style="{backgroundColor:selectdItem.containerLayout.justify == 'start'?'#8c62ff':'#fff',color:selectdItem.containerLayout.justify == 'start'?'#fff':'#000',border:selectdItem.containerLayout.justify == 'start'?'solid 1px #8c62ff':'solid 1px #959595' }"
														style="padding: 4px 0px;width: 36px;text-align: center;">
														<span style="scale: 0.85;">靠左</span>
													</div>
													<div @click="changeRow({justify:'center'})"
														:style="{backgroundColor:selectdItem.containerLayout.justify == 'center'?'#8c62ff':'#fff',color:selectdItem.containerLayout.justify == 'center'?'#fff':'#000',border:selectdItem.containerLayout.justify == 'center'?'solid 1px #8c62ff':'solid 1px #959595' }"
														style="padding: 4px 0px;width: 36px;text-align: center;">
														<span style="scale: 0.85;">居中</span>
													</div>
													<div @click="changeRow({justify:'end'})"
														:style="{backgroundColor:selectdItem.containerLayout.justify == 'end'?'#8c62ff':'#fff',color:selectdItem.containerLayout.justify == 'end'?'#fff':'#000',border:selectdItem.containerLayout.justify == 'end'?'solid 1px #8c62ff':'solid 1px #959595' }"
														style="border: solid 1px #959595;padding: 4px 0px;width: 36px;text-align: center;">
														<span style="scale: 0.85;">靠右</span>
													</div>
												</div>
											</div>
											<div
												style="display: flex;align-items: center;justify-content: space-between;margin-top: 6px;">
												<div>垂直布局</div>
												<div style="display: flex;align-items: center;margin-left:8px;">
													<div @click="changeCol({align:'top'})"
														:style="{backgroundColor: selectdItem.containerLayout.align == 'top'?'#8c62ff':'#fff',color: selectdItem.containerLayout.align == 'top'?'#fff':'#000',border: selectdItem.containerLayout.align == 'top'?'solid 1px #8c62ff':'solid 1px #959595' }"
														style="padding: 4px 0px;width: 36px;text-align: center;">
														<span style="scale: 0.85;">靠上</span>
													</div>
													<div @click="changeCol({align:'middle'})"
														:style="{backgroundColor:selectdItem.containerLayout.align == 'middle'?'#8c62ff':'#fff',color:selectdItem.containerLayout.align == 'middle'?'#fff':'#000',border:selectdItem.containerLayout.align == 'middle'?'solid 1px #8c62ff':'solid 1px #959595' }"
														style="padding: 4px 0px;width: 36px;text-align: center;">
														<span style="scale: 0.85;">居中</span>
													</div>
													<div @click="changeCol({align:'bottom'})"
														:style="{backgroundColor:selectdItem.containerLayout.align == 'bottom'?'#8c62ff':'#fff',color:selectdItem.containerLayout.align == 'bottom'?'#fff':'#000',border:selectdItem.containerLayout.align == 'bottom'?'solid 1px #8c62ff':'solid 1px #959595' }"
														style="border: solid 1px #959595;padding: 4px 0px;width: 36px;text-align: center;">
														<span style="scale: 0.85;">靠下</span>
													</div>
												</div>
											</div>
											<div style="margin-top: 15px;">
												内边距
											</div>
											<div
												style="width: 210px;display: flex;justify-content: center;margin-top: 6px;">
												<div
													style="display: flex;align-items: center;justify-content: space-between;">
													<div
														style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;width: 210px;">
														<div
															style="display: flex;flex-direction: column;align-items: center;">
															<input @input="paddingSet"
																v-model="selectdItem.preStyle.padding[0]"
																style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
															<div style="margin-top: 2px;color: #424242;scale: 0.85;">顶部
															</div>
														</div>
														<div
															style="display: flex;flex-direction: column;align-items: center;">
															<input @input="paddingSet"
																v-model="selectdItem.preStyle.padding[2]"
																style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
															<div style="margin-top: 2px;color: #424242;scale: 0.85;">左侧
															</div>
														</div>
														<div
															style="display: flex;flex-direction: column;align-items: center;">
															<input @input="paddingSet"
																v-model="selectdItem.preStyle.padding[1]"
																style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
															<div style="margin-top:2px;color: #424242;scale: 0.85;">底部
															</div>
														</div>
														<div
															style="display: flex;flex-direction: column;align-items: center;">
															<input @input="paddingSet"
																v-model="selectdItem.preStyle.padding[3]"
																style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
															<div style="margin-top: 2px;color: #424242;scale: 0.85;">右侧
															</div>
														</div>
														<div
															style="display: flex;flex-direction: column;align-items: center;margin-right:11px;">
															<i @click="selectdItem.preStyle.paddingSetAll = !selectdItem.preStyle.paddingSetAll"
																:style="{color:selectdItem.preStyle.paddingSetAll?'#8c62ff':'#000000'}"
																style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
																class="el-icon-paperclip tit-icon"></i>
														</div>
													</div>
												</div>
											</div>
											<div style="margin-top: 15px;">
												外边距
											</div>
											<div
												style="width: 210px;display: flex;justify-content: center;margin-top: 6px;">
												<div
													style="display: flex;align-items: center;justify-content: space-between;width: 210px;">
													<div
														style="display: flex;flex-direction: column;align-items: center;">
														<input @input="marginSet"
															v-model="selectdItem.preStyle.margin[0]"
															style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
														<div style="margin-top: 2px;color: #424242;scale: 0.85;">顶部
														</div>
													</div>
													<div
														style="display: flex;flex-direction: column;align-items: center;">
														<input @input="marginSet"
															v-model="selectdItem.preStyle.margin[2]"
															style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
														<div style="margin-top: 2px;color: #424242;scale: 0.85;">左侧
														</div>
													</div>
													<div
														style="display: flex;flex-direction: column;align-items: center;">
														<input @input="marginSet"
															v-model="selectdItem.preStyle.margin[1]"
															style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
														<div style="margin-top:2px;color: #424242;scale: 0.85;">底部</div>
													</div>
													<div
														style="display: flex;flex-direction: column;align-items: center;">
														<input @input="marginSet"
															v-model="selectdItem.preStyle.margin[3]"
															style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
														<div style="margin-top: 2px;color: #424242;scale: 0.85;">右侧
														</div>
													</div>
													<div
														style="display: flex;flex-direction: column;align-items: center;margin-right: 11px;">
														<i @click="selectdItem.preStyle.marginSetAll = !selectdItem.preStyle.marginSetAll"
															:style="{color:selectdItem.preStyle.marginSetAll?'#8c62ff':'#000000'}"
															style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
															class="el-icon-paperclip tit-icon"></i>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div style="display: flex;justify-content: center;cursor: pointer;width: 235px;">
									<div
										style="background-color: #F6F7F9;width: 210px;display: flex;flex-direction: column;">
										<div
											style="width: 100%; height: 1px;background-color: #c7c7c7;margin: 8px 0px;">
										</div>
										<div style="" class="flex-item-center"
											style="align-items: center;justify-content: space-between;margin: 6px;">
											<div style="font-size: 12px;">容器边框</div>
											<div style="display: flex;align-items: center;margin-left:8px;">
												<div @click="selectdItem.preStyle.border.type = ''"
													:style="{backgroundColor: selectdItem.preStyle.border.type == ''?'#8c62ff':'#fff',color: selectdItem.preStyle.border.type == ''?'#fff':'#000',border: selectdItem.preStyle.border.type == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
													style="padding: 4px 0px;width: 36px;text-align: center;">
													<span style="scale: 0.85;">无</span>
												</div>
												<div @click="selectdItem.preStyle.border.type = 'solid'"
													:style="{backgroundColor: selectdItem.preStyle.border.type == 'solid'?'#8c62ff':'#fff',color: selectdItem.preStyle.border.type == 'solid'?'#fff':'#000',border: selectdItem.preStyle.border.type == 'solid'?'solid 1px #8c62ff':'solid 1px #959595' }"
													style="padding: 4px 0px;width: 36px;text-align: center;">
													<span style="scale: 0.85;">实线</span>
												</div>
												<div @click="selectdItem.preStyle.border.type = 'dashed'"
													:style="{backgroundColor:selectdItem.preStyle.border.type == 'dashed'?'#8c62ff':'#fff',color:selectdItem.preStyle.border.type == 'dashed'?'#fff':'#000',border:selectdItem.preStyle.border.type == 'dashed'?'solid 1px #8c62ff':'solid 1px #959595' }"
													style="padding: 4px 0px;width: 36px;text-align: center;">
													<span style="scale: 0.85;">虚线</span>
												</div>
											</div>
										</div>
										<div style="" class="flex-item-center"
											style="align-items: center;justify-content: space-between;margin: 6px;">
											<div style="font-size: 12px;">边框颜色</div>
											<el-color-picker size="mini" style="height: 34px;width: 34px;"
												v-model="selectdItem.preStyle.border.color"></el-color-picker>
											<el-input size="mini" style="height: 34px;width: 82px;" disabled
												:value="selectdItem.preStyle.border.color"></el-input>
										</div>
										<div v-if="selectdItem.preStyle.border.borderSize" style="margin-top: 10px;">
											<div style="margin-left: 6px;">线条大小</div>
											<div
												style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
												<div style="display: flex;flex-direction: column;align-items: center;">
													<input @input="changeContainerSize"
														v-model="selectdItem.preStyle.border.borderSize[0]"
														style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
													<div style="margin-top: 2px;color: #424242;scale: 0.85;">顶部</div>
												</div>
												<div style="display: flex;flex-direction: column;align-items: center;">
													<input @input="changeContainerSize"
														v-model="selectdItem.preStyle.border.borderSize[1]"
														style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
													<div style="margin-top: 2px;color: #424242;scale: 0.85;">左侧</div>
												</div>
												<div style="display: flex;flex-direction: column;align-items: center;">
													<input @input="changeContainerSize"
														v-model="selectdItem.preStyle.border.borderSize[2]"
														style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
													<div style="margin-top: 2px;color: #424242;scale: 0.85;">底部</div>
												</div>
												<div style="display: flex;flex-direction: column;align-items: center;">
													<input @input="changeContainerSize"
														v-model="selectdItem.preStyle.border.borderSize[3]"
														style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
													<div style="margin-top: 2px;color: #424242;scale: 0.85;">右侧</div>
												</div>
												<div
													style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
													<i @click="borderContainerSizeAll = !borderContainerSizeAll"
														:style="{color:borderContainerSizeAll?'#8c62ff':'#000'}"
														style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
														class="el-icon-paperclip tit-icon"></i>
												</div>
											</div>
										</div>
										<div style="margin-top: 10px;" v-if="selectdItem.preStyle.border.borderRadius">
											<div style="margin-left: 6px;">边框圆角</div>
											<div
												style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px 6px 6px 6px;">
												<div style="display: flex;flex-direction: column;align-items: center;">
													<input @input="changeContainerBorderRadius"
														v-model="selectdItem.preStyle.border.borderRadius[0]"
														style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
													<div style="margin-top: 2px;color: #424242;scale: 0.85;">左上</div>
												</div>
												<div style="display: flex;flex-direction: column;align-items: center;">
													<input @input="changeContainerBorderRadius"
														v-model="selectdItem.preStyle.border.borderRadius[1]"
														style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
													<div style="margin-top: 2px;color: #424242;scale: 0.85;">右上</div>
												</div>
												<div style="display: flex;flex-direction: column;align-items: center;">
													<input @input="changeContainerBorderRadius"
														v-model="selectdItem.preStyle.border.borderRadius[2]"
														style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
													<div style="margin-top:2px;color: #424242;scale: 0.85;">右下</div>
												</div>
												<div style="display: flex;flex-direction: column;align-items: center;">
													<input @input="changeContainerBorderRadius"
														v-model="selectdItem.preStyle.border.borderRadius[3]"
														style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
													<div style="margin-top: 2px;color: #424242;scale: 0.85;">左下</div>
												</div>
												<div
													style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
													<i @click="borderContainerRadiusAll = !borderContainerRadiusAll"
														:style="{color:borderContainerRadiusAll?'#8c62ff':'#000'}"
														style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
														class="el-icon-paperclip tit-icon"></i>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div style="display: flex;justify-content: center;cursor: pointer;width: 235px;">
									<div
										style="background-color: #F6F7F9;width: 210px;display: flex;flex-direction: column;">
										<div
											style="width: 100%; height: 1px;background-color: #c7c7c7;margin: 8px 0px;">
										</div>
										<div style="margin: 6px;">
											容器阴影
										</div>
										<div
											style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
											<div style="display: flex;flex-direction: column;align-items: center;">
												<input v-model="selectdItem.preStyle.boxShadow.h"
													style="width: 44px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
												<div style="margin-top: 2;color: #424242;scale: 0.85;">x轴偏移</div>
											</div>
											<div style="display: flex;flex-direction: column;align-items: center;">
												<input v-model="selectdItem.preStyle.boxShadow.v"
													style="width: 44px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
												<div style="margin-top: 2;color: #424242;scale: 0.85;">Y轴偏移</div>
											</div>
											<div style="display: flex;flex-direction: column;align-items: center;">
												<input v-model="selectdItem.preStyle.boxShadow.blur"
													style="width: 44px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
												<div style="margin-top: 2;color: #424242;scale: 0.85;">模糊半径</div>
											</div>
											<div style="display: flex;flex-direction: column;align-items: center;">
												<input v-model="selectdItem.preStyle.boxShadow.spread"
													style="width: 44px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
												<div style="margin-top: 2;color: #424242;scale: 0.85;">扩散半径</div>
											</div>
										</div>

										<div
											style="width: 210px;display: flex;justify-content: center;margin-top: 10px;font-size: 12px;">
											<div class="flex-item-center"
												style="align-items: center;width: 210px;justify-content: space-around;background-color: #F6F7F9;">
												<div style="font-size: 12px;">
													颜色 / 方向
												</div>
												<el-color-picker size="mini" style="width: 34px;"
													v-model="selectdItem.preStyle.boxShadow.color"></el-color-picker>
												<el-select size="mini" style="width: 88px;"
													v-model="selectdItem.preStyle.boxShadow.type" placeholder="阴影方向">
													<el-option
														:style="{color:selectdItem.preStyle.boxShadow.type == 'outset'?'#8C62FF':'#6b6b6b'}"
														style="" label="外阴影" value="outset">
													</el-option>
													<el-option
														:style="{color:selectdItem.preStyle.boxShadow.type == 'inset'?'#8C62FF':'#6b6b6b'}"
														style="" label="内阴影" value="inset">
													</el-option>
													</el-option>
												</el-select>
											</div>

										</div>
										<div style="width: 100%;height: 10px;"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</transition>
			</div>
		</div>
		<el-dialog title="选择商品" :visible.sync="dialogGoodsVisible" width="60%"
			:before-close="()=>{dialogGoodsVisible = false}">
			<addGoods :selectdItem="selectdItem" @cancelGoods="dialogGoodsVisible = false" @confirmGoods="confirmGoods"
				v-if="dialogGoodsVisible"></addGoods>
		</el-dialog>
		<el-dialog custom-class="select-imgs" title="文件管理器" :visible.sync="dialogVisible" width="80%"
			:before-close="()=>{dialogVisible = false}">
			<select-img style="height: 70vh" @confirmImg="confirmImg" v-if="dialogVisible"></select-img>
		</el-dialog>
		<el-dialog title="编辑文本" :visible.sync="dialogTextVisible">
			<add-text-form :systemConfig="systemConfig" v-if="dialogTextVisible" @confirmText="confirmText"
				@cancelText="dialogTextVisible = false" :selectdItem="selectdItem"></add-text-form>
		</el-dialog>
		<el-dialog title="预览" :visible.sync="showPreview" width="80%" :before-close="()=>{showPreview = false}">
			<wm-preview :list="centerList"></wm-preview>
		</el-dialog>
		<el-dialog custom-class="select-imgs" title="文件管理器" :visible.sync="dialogVisibleImgs" width="80%"
			:before-close="()=>{dialogVisibleImgs = false}">
			<select-img style="height: 70vh" @confirmImg="confirmSelectImg($event,'dialogVisibleImgs')"
				v-if="dialogVisibleImgs"></select-img>
		</el-dialog>
	</div>
</template>

<script>
	import rowImg from './img/rows.png'
	import searchPng from './img/search-lg@2x.png'
	import starPng from './img/star-01@2x.png'
	import userPng from './img/user-03@2x.png'
	import layoutPng from './img/layout-left@2x.png'
	import translatePng from './img/translate-01@2x.png'
	import maximizePng from './img/maximize-02@2x.png'
	import layoutAltPng from './img/layout-alt-01@2x.png'
	import imagePng from './img/image-01@2x.png'
	import switchHorizontalPng from './img/switch-horizontal-02@2x.png'
	import imageRightPng from './img/image-right@2x.png'
	import typePng from './img/type-01@2x.png'
	import shoppingBagPng from './img/shopping-bag-02@2x.png'
	import filePng from './img/file-05@2x.png'
	import emailPng from './img/email.png'
	import lyPng from './img/ly.png'
	let that;
	import {
		mapState,
		mapGetters,
		mapActions,
		mapMutations
	} from 'vuex';
	import compoentsConfig from './config/config.js'
	import draggable from 'vuedraggable'
	import lodash from 'lodash';
	import wangEditor from './cpm/wangEditor.vue'
	import globalSet from './globalSet/index.vue'
	import selectPage from './cpm/selectPage.vue'
	import addTextForm from './cpm/addTextForm.vue'
	import addGoods from './cpm/addGoods.vue'
	import goodsTool from './cpm/goodsTool.vue'
	import apiConfig from './config/apiConfig.js'
	import selectImg from './components/selectImg.vue'
	import config from './config.js'
	import {
		getDesignSave,
		getDesignHome,
		getDesignShow,
		getSetting,
		getDesignAllSetting,
		getDesignSetting,
		getNewDesignSetting
	} from '../api/all.js'
	import {
		obj,
		componentObj
	} from './config/configInfo.js'
	import {
		pageValueEnum
	} from './config/enum.js';
	// 自动导入组件
	const components = require.context(
		"./components", //组件所在目录的相对路径
		true, //是否查询其子目录
		/\w+.vue$/ //匹配基础组件文件名的正则表达式
	);
	const comObj = {};
	components.keys().forEach(fileName => {
		// 获取文件名
		var names = fileName.split("/").pop().replace(/.\w+$/, "");
		names = 'wm' + names.charAt(0).toUpperCase() + names.slice(1);
		// 获取组件配置
		const comp = components(fileName);
		// 若该组件是通过"export default"导出的，优先使用".default"，否则退回到使用模块的根
		comObj[names] = comp.default || comp;
	});
	const componentsRightToolTab = require.context(
		"./rightToolTab", //组件所在目录的相对路径
		true, //是否查询其子目录
		/\w+.vue$/ //匹配基础组件文件名的正则表达式
	);
	const comToolTabObj = {};
	componentsRightToolTab.keys().forEach(fileName => {
		// 获取文件名
		var names = fileName.split("/").pop().replace(/.\w+$/, "");
		names = 'wm' + names.charAt(0).toUpperCase() + names.slice(1);
		// // 获取组件配置
		const comp = componentsRightToolTab(fileName);
		// // 若该组件是通过"export default"导出的，优先使用".default"，否则退回到使用模块的根
		comToolTabObj[names] = comp.default || comp;
	});
	console.log('comToolTabObj', comToolTabObj)
	export default {
		components: {
			addTextForm,
			wangEditor,
			selectImg,
			draggable,
			goodsTool,
			globalSet,
			selectPage,
			addGoods,
			...comObj,
			...comToolTabObj
		},
		data() {
			return {
				isFullWidthKey: 1,
				// 分类商品装修的数据
				centerBgHeight: 0,
				dragIcon: {
					layoutPng,
					rowImg,
					searchPng,
					starPng,
					userPng,
					translatePng,
					maximizePng,
					layoutAltPng,
					imagePng,
					switchHorizontalPng,
					imageRightPng,
					shoppingBagPng,
					filePng,
					typePng,
					emailPng,
					lyPng
				},
				isBoxWidth: false,
				zoomNum: 1,
				pageValueEnum,
				remote: "",
				haveData: false,
				borderContainerSizeAll: true,
				borderContainerRadiusAll: true,
				cotainerLayoutSetType: 'all', // pc phone all
				ghostClass: "",
				ppItem: null,
				pContainerItem: null,
				expandedKeys: [],
				needTreeAddCmp: null,
				cmpZindex: 0,
				config,
				fontList: [],
				setConfigList: [],
				globalSetShow: false,
				all_setting: [],
				leftToolType: "1",
				rightBoxShow: true,
				leftBoxShow: false,
				currentNodeKey: "",
				domnClientX: 0,
				domnClientY: 0,
				leftDetail: '',
				rightDetail: '',
				rightTop: 48,
				rightL: 0,
				isDragging: false,
				leftTop: 0,
				leftL: 0,
				guides: true,
				propsTree: {
					children: 'children',
					label: 'name',
				},
				treeKey: 1,
				dataStruct: [],
				filterText: "",
				drawerStruct: false,
				pageNewValue: '1',
				systemConfig: null,
				loading: false,
				dialogGoodsVisible: false,
				imgsIndex: 0,
				dialogVisibleImgs: false,
				navShow: true,
				pageOptions: [{
						value: '1',
						label: '页眉'
					},
					// {
					// 	value: '2',
					// 	label: 'phone页眉'
					// },
					{
						value: '3',
						label: '页脚'
					},
					// {
					// 	value: '4',
					// 	label: 'phone页脚'
					// },
					{
						value: '5',
						label: '首页装修'
					},
					// {
					// 	value: '6',
					// 	label: '底部购物栏'
					// }
				],
				pageValue: '10',
				navItem: null,
				mouseenterItem: null,
				languageOptions: [{
						value: "zh_en",
						label: "中文"
					},
					{
						value: "en",
						label: "英文"
					},
					{
						value: "ja",
						label: "日文"
					},
					{
						value: "zh_hk",
						label: "繁体中文"
					}
				],
				textForm: {
					language: "",
					languageName: "",
					text: ""
				},
				dialogTextVisible: false,
				show: true,
				newElementId: null,
				delInfo: {

				},
				// 右击菜单可见性
				dropdown_visible: false
					// 触发下拉事件的选项卡 name
					,
				dropdown_name: undefined
					// 右击菜单位置
					,
				left: undefined
					// 右击菜单位置
					,
				top: undefined,

				showPreview: false,
				sideOrCorner: [{
						label: 'left',
						value: 'left'
					},
					{
						label: 'right',
						value: 'right'
					},
					{
						label: 'top',
						value: 'top'
					},
					{
						label: 'bottom',
						value: 'bottom'
					}
				],
				fontOptions: [{
						label: '无',
						value: ''
					},

					{
						label: '加粗',
						value: 'bold',
					},
					// {
					// 	label: '100',
					// 	value: '100',
					// },
					// {
					// 	label: '200',
					// 	value: '200',
					// },
					// {
					// 	label: '300',
					// 	value: '300',
					// },
					// {
					// 	label: '400',
					// 	value: '400',
					// },
					// {
					// 	label: '500',
					// 	value: '500',
					// },
					// {
					// 	label: '600',
					// 	value: '600',
					// },
					// {
					// 	label: '700',
					// 	value: '700',
					// },
					// {
					// 	label: '800',
					// 	value: '800',
					// },
					// {
					// 	label: '900',
					// 	value: '900',
					// },
				],
				dialogVisible: false,
				detail: "",
				layoutTags: [{
					type: '',
					label: '左边',
					justify: "start" // start/end/center/space-around/space-between
				}, {
					type: '',
					label: '中间',
					justify: "center"
				}, {
					type: '',
					label: '右边',
					justify: "end"
				}],

				rowTags: [{
					type: '',
					label: '左边',
					justify: "start" // start/end/center/space-around/space-between
				}, {
					type: '',
					label: '中间',
					justify: "center"
				}, {
					type: '',
					label: '右边',
					justify: "end"
				}, {
					type: '',
					label: '分布两端',
					justify: "space-around"
				}, {
					type: '',
					label: '均匀分布',
					justify: "space-between"
				}],
				colTags: [{
					type: '',
					label: '上边',
					align: "top",
				}, {
					type: '',
					label: '中间',
					align: "middle",
				}, {
					type: '',
					label: '下边',
					align: "bottom",
				}],


				equipment: "pc",
				selectdItem: null, // 点击选中的item

				addContainerPut: true,
				addComponentPut: true,
				leftList: [],
				editableTabsValue: '1',
				editableTabs: [{
						title: '基础',
						name: '1',
					},
					// {
					// 	title: '其他',
					// 	name: '2',
					// }
				],
				// center 
				centerList: [],
				recordCenterLists: [],
				qjCenterLists: [],
				returnListState: true,
				// right
				rightTab: "1",
				rightTabs: [{
					title: '容器',
					name: '1',
				}],
				rightComponentTabs: [{
						title: '组件样式',
						name: '3',
					},
					{
						title: '数据',
						name: '2',
					},
				]
			}
		},
		computed: {
			...mapState("lowCodeStore", ['test', 'navList', 'navPhoneList', 'footerList', 'footerPhoneList', 'homeList',
				'bottomCartPhoneList', 'detailList', 'classifyList', 'globalDialogList', 'goodsConfig'
			]),
			style: function() {
				return "left: " + this.left + "px; top: " + this.top + "px;";
			},
			newCenterList() {
				return lodash.cloneDeep(this.centerList)
			}
		},
		watch: {
			newCenterList: {
				deep: true,
				handler: function(newVal, oldVal) {
					// console.log('newVal', newVal)
					// console.log('oldVal', oldVal)
					this.watchPageChange(newVal)
					this.treeKey = this.treeKey + 1
					if (this.returnListState && oldVal.length > 0) {
						if (this.recordCenterLists.length == 30) {
							this.recordCenterLists.splice(0, 1)
						}
						this.recordCenterLists.push(JSON.stringify(lodash.cloneDeep(oldVal)))
						// console.log('recordCenterLists newVal',this.recordCenterLists)
						// console.log('recordCenterLists newVal',this.recordCenterLists.length == 15)
					}
					this.returnListState = true
				}
			}
		},



		updated() {
			this.changeBgheight()
		},

		async mounted() {
			try {
				this.changeFavicon('/image/favicon.png')
				that = this
				this.loading = true
				let wsid = this.$cookies.get("wsid")
				let systemConfig = await getNewDesignSetting({
					wsid
				})
				this.systemConfig = systemConfig.data.data
				// this.systemConfig = {
				// 	local:"zh_cn"
				// }
				console.log('systemConfig', systemConfig)
				// 落下鼠标时，需要移除展开的右击菜单
				window.addEventListener('mousedown', this.onWindowsMousedown);
				this.changePage('1')
				// console.log('test', this.test)
				// 初始化 + 监听窗口变化
				// this.$nextTick(()=>{
				// 	this.resizeChild();
				// 	window.addEventListener('resize', this.resizeChild);
				// })


			} catch (e) {
				this.loading = false
			}
		},
		methods: {
			showTree() {
				// if (this.expandedKeys.length == 0) {
				// 	this.centerList.forEach(data => {
				// 		this.expandedKeys.push(data.id)
				// 	})
				// }
			},
			// 获取当前页面的favicon链接
			getFavicon() {
				return document.querySelector("link[rel*='icon']");
			},

			// 修改favicon
			changeFavicon(src) {
				const favicon = this.getFavicon();
				if (favicon) {
					favicon.href = src;
				} else {
					console.log('changeFaviconchangeFavicon', src)

					const link = document.createElement('link');
					link.rel = 'icon';
					link.href = src;
					document.head.appendChild(link);
				}
			},
			changeBgheight() {
				if (this.equipment == 'pc') {
					if (document.getElementsByClassName('rowCenter').length > 0) {
						let arr = document.getElementsByClassName('rowCenter')
						// console.log('arr', arr)
						let num = 0
						for (let i = 0; i < arr.length; i++) {
							console.log(arr[i].offsetHeight);
							num = num + arr[i].offsetHeight
						}
						this.centerBgHeight = num
						return num
						console.log('this.centerBgHeight', this.centerBgHeight)
					}
				}
			},
			changeComponentData() {
				// 组件数据变换重新渲染高度
				this.changeBgheight()
			},

			resizeChild() {
				const parent = document.querySelector('.parent-row');
				const child = document.querySelector('.child-row');
				console.log('parent.offsetHeight')
				child.style.height = parent.offsetHeight + 'px';
			},
			getCompList(leftList) {
				let containerList = {
					name: "容器类",
					list: []

				}
				let basisList = {
					name: "基础类",
					list: []
				}
				let contentList = {
					name: "内容类",
					list: []
				}
				let goodsList = {
					name: "商品类",
					list: []
				}
				console.log('getCompListleftList', leftList)
				leftList.forEach(item => {
					if (item.groupName == 'container') {
						containerList.list.push(item)
					}
					if (item.groupName == 'basic') {
						basisList.list.push(item)
					}
					if (item.groupName == 'content') {
						contentList.list.push(item)
					}
					if (item.groupName == 'goods') {
						if (item.name != '商品详情' && item.name != '商品分类') {
							goodsList.list.push(item)
						}

					}
				})
				let list = [containerList, basisList, contentList, goodsList]

				console.log('getCompList', list)
				return list
			},
			isShowDesignPanel() {
				this.haveData = true
				this.selectdItem.compontChildren[0].isNeedData = false
			},
			changeContainerSize(e) {
				if (this.borderContainerSizeAll) {
					this.selectdItem.preStyle.border.borderSize = []
					this.selectdItem.preStyle.border.borderSize.push(e.target.value)
					this.selectdItem.preStyle.border.borderSize.push(e.target.value)
					this.selectdItem.preStyle.border.borderSize.push(e.target.value)
					this.selectdItem.preStyle.border.borderSize.push(e.target.value)
				}
			},
			changeContainerBorderRadius(e) {
				if (this.borderContainerRadiusAll) {
					this.selectdItem.preStyle.border.borderRadius = []
					this.selectdItem.preStyle.border.borderRadius.push(e.target.value)
					this.selectdItem.preStyle.border.borderRadius.push(e.target.value)
					this.selectdItem.preStyle.border.borderRadius.push(e.target.value)
					this.selectdItem.preStyle.border.borderRadius.push(e.target.value)
				}
			},
			changeColSpan(e) {
				// if (this.equipment == 'pc') {
				// 	console.log('this.pContainerItem e', this.pContainerItem)
				// 	if (this.pContainerItem) {
				// 		this.pContainerItem.containerLayout.col.span = e
				// 		this.pContainerItem.isFullWidth = false
				// 		this.pContainerItem.isFullWidthBg = false
				// 	} else {
				// 		this.selectdItem.containerLayout.col.span = e
				// 		this.selectdItem.isFullWidth = false
				// 		this.selectdItem.isFullWidthBg = false
				// 	}
				// } else {
				// 	if (this.pContainerItem) {
				// 		this.pContainerItem.containerLayout.phoneCol.span = e
				// 	} else {
				// 		this.selectdItem.containerLayout.col.span = e
				// 	}
				// }
				
				if (this.equipment == 'pc') {
					if (this.pContainerItem) {
						this.pContainerItem.containerLayout.col.span = e
						this.pContainerItem.isFullWidth = false
						this.pContainerItem.isFullWidthBg = false
					} else {
						this.selectdItem.containerLayout.col.span = e
						this.selectdItem.isFullWidth = false
						this.selectdItem.isFullWidthBg = false
					}
				} else {
					console.log('this.pContainerItem e', this.pContainerItem)
					// if(this.pageNewValue == 2 ||  this.pageNewValue == 4) {
					// 	this.selectdItem.containerLayout.phoneCol.span = e
					// }
					
					if (this.pContainerItem) {
						this.pContainerItem.containerLayout.phoneCol.span = e
					} else {
						this.selectdItem.containerLayout.phoneCol.span = e
					}
				}
				
				


				// if (this.selectdItem.level == 1) {
				// 	if (this.equipment == 'pc') {
				// 		if (this.selectdItem.containerLayout.col.span != 24) {
				// 			this.selectdItem.isFullWidth = false
				// 			this.selectdItem.isFullWidthBg = false
				// 		}
				// 	} else {
				// 		if (this.selectdItem.containerLayout.phoneCol.span != 24) {
				// 			this.selectdItem.isFullWidth = false
				// 			this.selectdItem.isFullWidthBg = false
				// 		}
				// 	}
				// }


				// if (this.pContainerItem) {
				// 	if (this.cotainerLayoutSetType == 'all') {
				// 		this.pContainerItem.containerLayout.col.span = e
				// 		this.pContainerItem.containerLayout.phoneCol.span = e
				// 	}
				// 	if (this.cotainerLayoutSetType == 'pc') {
				// 		this.pContainerItem.containerLayout.col.span = e
				// 	}
				// 	if (this.cotainerLayoutSetType == 'phone') {
				// 		this.pContainerItem.containerLayout.phoneCol.span = e
				// 	}
				// } else {
				// 	if (this.cotainerLayoutSetType == 'all') {
				// 		this.selectdItem.containerLayout.col.span = e
				// 		this.selectdItem.containerLayout.phoneCol.span = e
				// 	}
				// 	if (this.cotainerLayoutSetType == 'pc') {
				// 		this.selectdItem.containerLayout.col.span = e
				// 	}
				// 	if (this.cotainerLayoutSetType == 'phone') {
				// 		this.selectdItem.containerLayout.col.span = e
				// 	}
				// }
			},
			getColSpan() {

				if (this.equipment == 'pc') {
					if (this.pContainerItem) {
						return this.pContainerItem.containerLayout.col.span
					} else {
						return this.selectdItem.containerLayout.col.span
					}
				} else {
					if (this.pContainerItem) {
						return this.pContainerItem.containerLayout.phoneCol.span
					} else {
						return this.selectdItem.containerLayout.phoneCol.span
					}
				}


				// if (this.pContainerItem) {
				// 	if (this.cotainerLayoutSetType == 'all') {
				// 		return this.pContainerItem.containerLayout.col.span
				// 	}
				// 	if (this.cotainerLayoutSetType == 'pc') {
				// 		return this.pContainerItem.containerLayout.col.span
				// 	}
				// 	if (this.cotainerLayoutSetType == 'phone') {
				// 		return this.pContainerItem.containerLayout.phoneCol.span
				// 	}
				// } else {
				// 	if (this.cotainerLayoutSetType == 'all') {
				// 		return this.selectdItem.containerLayout.col.span
				// 	}
				// 	if (this.cotainerLayoutSetType == 'pc') {
				// 		return this.selectdItem.containerLayout.col.span
				// 	}
				// 	if (this.cotainerLayoutSetType == 'phone') {
				// 		return this.selectdItem.containerLayout.phoneCol.span
				// 	}
				// }
			},
			treeSwitch(node, data) {
				node.expanded = !node.expanded
			},
			getLevelStyle(level, node) {
				const colors = ['#5555ff', '#8C62FF', '#9c75ff'];
				console.log('currentNodeKey111', this.currentNodeKey)
				console.log('currentNodeKeynode', node)
				console.log('this.mouseenterItem', this.mouseenterItem)
				let color = colors[(level - 1) % colors.length]
				if (node.data.id == this.currentNodeKey) {
					color = '#000000'
				}
				if (this.mouseenterItem && this.mouseenterItem.id == node.data.id) {
					color = '#000000'
				}
				

				if (node.data.name != '容器') {
					if (node.data.level == 2) {
						if (this.mouseenterItem && this.mouseenterItem.id == node.data.children[0].id) {
							color = '#000000'
						}
					}
					
					if (node.data.level == 1) {
						if (this.mouseenterItem && this.mouseenterItem.id == node.data.children[0].children[0].id) {
							color = '#000000'
						}
					}
				}

				// console.log('colorcolor', color)
				// console.log('colorcolor', node.id == this.currentNodeKey)
				return {
					'background-color': color,
					'width': level == '1' ? '175px' : level == '2' ? '156px' : '138px'
				}
			},
			onMove(e, originalEvent) {
				console.log('onMove', e)
				console.log('e.to._prevClass', e.to._prevClass)
				this.ghostClass = e.to._prevClass
			},
			selectComp() {
				if (this.needTreeAddCmp && this.needTreeAddCmp.name != '容器') {
					// this.currentNodeKey = '';
					// this.treeKey = this.treeKey + 1;
					// this.selectdItem = null;
					// this.needTreeAddCmp = null
					this.$message.error('请选择容器')
					return
				}
				// this.currentNodeKey = '';
				// this.treeKey = this.treeKey + 1;
				// this.selectdItem = null;
				// this.needTreeAddCmp = null
				this.cmpZindex = 1000
			},
			changePcRow(selectdItem, e) {
				selectdItem.containerLayout.pcMax = e
			},
			getPageValueRule(item, type) {
				let bol = true

				if (type == 'or') {
					bol = false
					item.selectRule.forEach(e => {
						bol = (this.pageValue == e) || bol
					})
				}
				if (type == 'and') {
					bol = true
					item.selectRule.forEach(e => {
						bol = bol && (this.pageValue != e)
					})
				}
				return bol
			},

			getBoxBgStyle() {
				if (this.pageValue == '1' || this.pageValue == '3') {
					console.log('this.pageValue1010', this.pageValue == '1')
					if (this.pageValue == '1') {
						return this.navBgBoxStyle() // 盒装背景
					}

					if (this.pageValue == '3') {
						return this.footBgBoxStyle() // 盒装背景
					}
				}
				return this.getBoxStyle()
			},

			getBoxStyle() {
				if (this.equipment == 'phone') {
					return
				}
				if (this.pageValue == '1' || this.pageValue == '3') {
					return
				}
				try {
					if (this.all_setting.length > 0) {
						let setItem = this.all_setting[0].tabList[0].config
						console.log('setItemsetItem', setItem)
						let style = {}
						if (setItem.bg.setWidth.type == 'px') {
							if (setItem.box.bgType == 'checked1') {
								style.background = setItem.box.boxSingleBgColor.bgColor
							}
							if (setItem.box.bgType == 'checked2') {
								style = {
									...style,
									...this.cssStringToObject(setItem.box.boxColor.bgColor)
								}
								// return setItem.box.boxColor.bgColor
							}

							if (setItem.box.bgType == 'checked3') {
								let backgroundImage = `url(${setItem.box.boxBgImg.url})`
								if (setItem.box.boxBgImg.width) {
									style.backgroundSize = setItem.box.boxBgImg.width + 'px';
								} else {
									style.backgroundSize = '100%';
								}
								if (setItem.box.boxBgImg.height) {
									style.backgroundSize = style.backgroundSize + ' ' + (setItem.box.boxBgImg.height +
										'px')
								} else {
									style.backgroundSize = style.backgroundSize + ' 100%'
								}
								if (setItem.box.boxBgImg.type) {
									style.backgroundRepeat = setItem.box.boxBgImg.type
								}
								if (setItem.box.boxBgImg.position) {
									style.backgroundPosition = setItem.box.boxBgImg.position
								}
								style.backgroundImage = backgroundImage
							}
						}
						console.log('setItemsetItemstyle', style)
						return style
					}
				} catch (e) {}
			},



			getNavFootBoxStyle() {

			},

			getContainerStyle(type = '') {
				if (pageValueEnum.globalDialog == this.pageValue) {
					if (this.all_setting.length > 0) {
						if (this.all_setting[0].tabList[2].config.globalDialog) {
							const globalDialog = this.all_setting[0].tabList[2].config.globalDialog
							return {
								width: globalDialog.width + 'px'
							}
						}
					}
					// return {
					// 	width: '200px',
					// 	backgroundColor: '#ffaa00'
					// }
				}

				if (this.equipment == 'phone') {
					let style = {}
					
					// if(this.pageNewValue == 2 && type == 'box'){
					// 	if (this.all_setting.length > 0) {
					// 		let setItem = this.all_setting[0].tabList[0].config.nav
					// 		if (setItem.btoShadow.bgColor) {
					// 			style.boxShadow =
					// 				`0px -${setItem.btoShadow.y}px ${setItem.btoShadow.r}px ${setItem.btoShadow.bgColor} inset`
					// 		}
					// 		console.log('stylestylestyle123',setItem)
					// 		console.log('stylestylestyle123',style)
					// 	}
					// }
					// boxShadow: "0px -21px 21px #3ECC1B inset"
					// if(this.pageNewValue == 4){
					// 	if (this.all_setting.length > 0) {
					// 		let setItem = this.all_setting[0].tabList[0].config.nav
					// 		if (setItem.btoShadow.bgColor) {
					// 			style.boxShadow =
					// 				`0px -${setItem.btoShadow.y}px ${setItem.btoShadow.r}px ${setItem.btoShadow.bgColor} inset`
					// 		}
					// 	}
					// 	console.log('stylestylestyle123',style)
					// }
					
					
					
					return style
				}
				if (this.pageValue != pageValueEnum.pcNav && this.pageValue != pageValueEnum.phoneNav && this.pageValue !=
					pageValueEnum.pcFooter && this.pageValue != pageValueEnum.phoneFooter) {
					// 不是页眉和页脚 
					// 是否盒装 获取宽度
					let style = {
						...this.getWidthStyle(), // 宽度
						// ...this.getBoxStyle() // 盒装背景
					}
					
					
					
					
					if (type == 'box') {
						// if (setItem.topShadow.bgColor) {
						// 	style.boxShadow =
						// 		`0px ${setItem.topShadow.y}px ${setItem.topShadow.r}px ${setItem.topShadow.bgColor} inset`
						// }

						style = {
							...style,
							...this.getBoxStyle() // 盒装背景
						}
					}
					// console.log('getContainerStyletype', type)
					return style
				}

				if (this.pageValue == '1') {
					// 页眉和页脚
					// 是否盒装 获取宽度 
					let style = {
						// navBoxStyle
						...this.navBoxStyle(), // 宽度
						// ...this.navBgBoxStyle() // 盒装背景
					}

					if (type == 'box') {





						style = {
							...style,
							...this.navBgBoxStyle() // 盒装背景
						}

						if (this.all_setting.length > 0) {
							let setItem = this.all_setting[0].tabList[0].config.nav
							if (setItem.btoShadow.bgColor) {
								style.boxShadow =
									`0px -${setItem.btoShadow.y}px ${setItem.btoShadow.r}px ${setItem.btoShadow.bgColor} inset`
							}
						}




					}
					return style

					// return this.navStyle()
				}
				if (this.pageValue == '3') {
					let style = {
						// navBoxStyle
						...this.footBoxStyle(), // 宽度.
						// ...this.footBgBoxStyle() // 盒装背景

					}
					if (type == 'box') {
						style = {
							...style,
							...this.footBgBoxStyle() // 盒装背景
						}

						if (this.all_setting.length > 0) {
							let setItem = this.all_setting[0].tabList[0].config.foot
							if (setItem.topShadow.bgColor) {
								style.boxShadow =
									`0px ${setItem.topShadow.y}px ${setItem.topShadow.r}px ${setItem.topShadow.bgColor} inset`
							}
						}

					}

					return style
					// return this.footStyle()
				}

			},

			getWidthStyle() {
				try {
					if (this.pageValue != pageValueEnum.pcNav || this.pageValue != pageValueEnum.phoneNav || this
						.pageValue != pageValueEnum.pcFooter || this.pageValue != pageValueEnum.phoneFooter) {
						if (this.all_setting.length > 0) {
							let setItem = this.all_setting[0].tabList[0].config
							let style = {}
							if (setItem.bg.setWidth.type == 'px') {
								this.isBoxWidth = true
								if (setItem.bg.setWidth.width > 1920) {
									setItem.bg.setWidth.width = 1920
								}
								if (setItem.bg.setWidth.width > 1415) {
									let num = (setItem.bg.setWidth.width - 1415) / 20 // 计算差值
									if (num > 0) {
										this.zoomNum = 1 - ((num + 2) * 0.01)
										console.log('zoomNumzoomNumzoomNum', this.zoomNum)
									}
									style.width = 1414 + 'px'
								} else {
									style.width = setItem.bg.setWidth.width + 'px'
								}


							} else {
								this.zoomNum = 0.725
							}
							return style
						}
					} else {
						// this.zoomNum = 0.73
						return {
							width: '100%'
						}
					}
				} catch (e) {

				}
			},

			getPhoneStyle(type) {
				if (this.equipment == 'pc') {
					return
				}
				console.log('this.pageValuethis.pageValue', this.pageValue)
				let style = {
					
				}
				// 手机端默认用全局
				try {
					if (this.pageValueEnum.globalDialog == this.pageValue) {
						if (this.all_setting.length > 0) {
							if (this.all_setting[0].tabList[2].config.globalDialog) {
								const globalDialog = this.all_setting[0].tabList[2].config.globalDialog

								let style = {
									// margin:"auto"

								}
								style.width = globalDialog.phoneWidth + 'px'
								// style.height = globalDialog.phoneHeight + 'px'
								if (globalDialog.bg.bgType == 'color') {
									style.backgroundColor = globalDialog.bg.bgColor
								}
								if (globalDialog.bg.bgType == 'gradient') {
									let obj = this.cssStringToObject(globalDialog.bg.bgGradient)
									for (let k in obj) {
										style[k] = obj[k]
									}
								}
								if (globalDialog.bg.bgType == 'img') {
									style.backgroundImage = `url(${globalDialog.bg.bgImg.url})`

									if (globalDialog.bg.bgImg.width) {
										style.backgroundSize = globalDialog.bg.bgImg.width + 'px'
									} else {
										style.backgroundSize = '100%'
									}

									if (globalDialog.bg.bgImg.height) {
										style.backgroundSize = style.backgroundSize + ' ' + (globalDialog.bg.bgImg.height +
											'px')
									} else {
										style.backgroundSize = style.backgroundSize + ' 100%'
									}

									if (globalDialog.bg.bgImg.type) {
										style.backgroundRepeat = globalDialog.bg.bgImg.type
									}

									if (globalDialog.bg.bgImg.position) {
										style.backgroundPosition = globalDialog.bg.bgImg.position
									}
								}

								console.log('getDialogStyle', style)
								return style

							}
						}
					}



					 // && type == 'all'
					if (this.pageValue != '1' && this.pageValue != '3') {
						if (this.all_setting.length > 0) {
							let setItem = this.all_setting[0].tabList[0].config

							if (setItem.bg.bgType == 'checked1') {
								style.background = setItem.bg.singleBgColor.bgColor
							}
							if (setItem.bg.bgType == 'checked2') {
								// return setItem.bg.bgColor.bgColor
								style = {
									...style,
									...this.cssStringToObject(setItem.bg.bgColor.bgColor)
								}

							}
							if (setItem.bg.bgType == 'checked3') {
								let backgroundImage = `url(${setItem.bg.bgImg.url})`
								if (setItem.bg.bgImg.width) {
									style.backgroundSize = setItem.bg.bgImg.width + 'px';
								} else {
									style.backgroundSize = '100%';
								}
								if (setItem.bg.bgImg.height) {
									style.backgroundSize = style.backgroundSize + ' ' + (setItem.bg.bgImg.height +
										'px')
								} else {
									style.backgroundSize = style.backgroundSize + ' 100%'
								}
								if (setItem.bg.bgImg.type) {
									style.backgroundRepeat = setItem.bg.bgImg.type
								}
								if (setItem.bg.bgImg.position) {
									style.backgroundPosition = setItem.bg.bgImg.position
								}
								style.backgroundImage = backgroundImage
							}
						}
					}
					if (this.pageValue == '1' && type == 'container') {
						style = this.navStyle()
						style.height = 'none'

					}
					if (this.pageValue == '3' && type == 'container') {
						style = this.footStyle()
						style.height = 'none'
					}
					
					// console.log('getPhoneStylethise', style)
					// 手机端阴影
					if(this.pageNewValue == 2 && this.pageValue == 1){
						if (this.all_setting.length > 0) {
							let setItem = this.all_setting[0].tabList[0].config.nav
							if (setItem.btoShadow.bgColor) {
								style.boxShadow =
									`0px -${setItem.btoShadow.y}px ${setItem.btoShadow.r}px ${setItem.btoShadow.bgColor} inset`
							}
						}
					}
					
					if(this.pageNewValue == 4 && this.pageValue == 3){
						if (this.all_setting.length > 0) {
							let setItem = this.all_setting[0].tabList[0].config.foot
							if (setItem.topShadow.bgColor) {
								style.boxShadow =
									`0px ${setItem.topShadow.y}px ${setItem.topShadow.r}px ${setItem.topShadow.bgColor} inset`
							}
						}
					}
					
					
					// style.boxShadow = "0px -21px 21px #3ECC1B inset"
					return style
				} catch (e) {
					console.log('getPhoneStylethise', e)
				}
			},
			getBgStyle() {
				if (this.equipment == 'phone') {

					return {
						background: '#e2e2e2'
					}
				}

				if (this.pageValue == '1' || this.pageValue == '3') {
					return
				}
				try {
					if (this.all_setting.length > 0) {
						let setItem = this.all_setting[0].tabList[0].config
						let style = {}
						if (setItem.bg.bgType == 'checked1') {
							style.background = setItem.bg.singleBgColor.bgColor
						}
						if (setItem.bg.bgType == 'checked2') {
							return setItem.bg.bgColor.bgColor
						}
						if (setItem.bg.bgType == 'checked3') {
							let backgroundImage = `url(${setItem.bg.bgImg.url})`
							if (setItem.bg.bgImg.width) {
								style.backgroundSize = setItem.bg.bgImg.width + 'px';
							} else {
								style.backgroundSize = '100%';
							}
							if (setItem.bg.bgImg.height) {
								style.backgroundSize = style.backgroundSize + ' ' + (setItem.bg.bgImg.height +
									'px')
							} else {
								style.backgroundSize = style.backgroundSize + ' 100%'
							}
							if (setItem.bg.bgImg.type) {
								style.backgroundRepeat = setItem.bg.bgImg.type
							}
							if (setItem.bg.bgImg.position) {
								style.backgroundPosition = setItem.bg.bgImg.position
							}
							style.backgroundImage = backgroundImage
						}
						return style
					}
				} catch (e) {

				}
			},


			getFootHeight() {
				let str = ""
				if (this.equipment == 'phone') {
					str = str + 'height:calc(100vh - 130px);'
				} else {
					str = str + 'height:100%;'
				}


				if (this.pageValue == '3') {
					str = str + 'display: flex;align-items: flex-end;justify-content: center;'
					return str
				}
				return str
			},
			getDialogStyle() {
				if (this.all_setting.length > 0) {
					if (this.all_setting[0].tabList[2].config.globalDialog) {
						const globalDialog = this.all_setting[0].tabList[2].config.globalDialog

						let style = {
							margin: "auto",
						}

						if (this.equipment == 'pc') {
							style.width = globalDialog.width + 'px'
							style.height = globalDialog.height + 'px'
							if (globalDialog.bg.bgType == 'color') {
								style.backgroundColor = globalDialog.bg.bgColor
							}
							if (globalDialog.bg.bgType == 'gradient') {
								let obj = this.cssStringToObject(globalDialog.bg.bgGradient)
								for (let k in obj) {
									style[k] = obj[k]
								}
							}
							if (globalDialog.bg.bgType == 'img') {
								style.backgroundImage = `url(${globalDialog.bg.bgImg.url})`

								if (globalDialog.bg.bgImg.width) {
									style.backgroundSize = globalDialog.bg.bgImg.width + 'px'
								} else {
									style.backgroundSize = '100%'
								}

								if (globalDialog.bg.bgImg.height) {
									style.backgroundSize = style.backgroundSize + ' ' + (globalDialog.bg.bgImg.height +
										'px')
								} else {
									style.backgroundSize = style.backgroundSize + ' 100%'
								}

								if (globalDialog.bg.bgImg.type) {
									style.backgroundRepeat = globalDialog.bg.bgImg.type
								}

								if (globalDialog.bg.bgImg.position) {
									style.backgroundPosition = globalDialog.bg.bgImg.position
								}
							}

						} else {
							// style.width = '100%'
							style.height = globalDialog.phoneHeight + 'px'
						}


						console.log('getDialogStyle', style)
						return style

					}
				}
			},
			getCenterStyle() {
				if (pageValueEnum.globalDialog == this.pageValue) {
					// 获取弹窗高度 背景

					return this.getDialogStyle()

				}
				if (this.equipment == 'phone') {
					return
				}
				if (this.pageValue == '1') {
					return this.navStyle()
				}
				if (this.pageValue == '3') {
					return this.footStyle()
				}
				return {
					width: '100%',
					height: '100%',
				}
			},
			getCenterBoxStyle() {
				if (this.equipment == 'phone') {
					return
				}
				if (this.pageValue == '1' && this.equipment == 'pc') {
					return this.navBoxStyle()
				}
				if (this.pageValue == '3' && this.equipment == 'pc') {
					return this.footBoxStyle()
				}
				return {
					width: '100%',
					height: '100%',

				}
			},
			getCenterBoxBgStyle() {
				if (this.equipment == 'phone') {
					return
				}
				console.log('getCenterBoxBgStyle', this.pageValue)
				if (this.pageValue == '1') {
					return this.navBgBoxStyle()
				}
				if (this.pageValue == '3') {
					return this.footBgBoxStyle()
				}
				return {
					width: '100%',
					height: '100%',
				}
			},
			footBgBoxStyle() {
				try {
					if (this.all_setting.length > 0) {
						console.log('this.all_setting', this.all_setting)
						let setItem = this.all_setting[0].tabList[0].config.foot
						let style = {}
						if (setItem.bg.setWidth.type == 'px') {
							if (setItem.box.bgType == 'checked1') {
								style.background = setItem.box.boxSingleBgColor.bgColor
							}
							if (setItem.box.bgType == 'checked2') {

								// return setItem.box.boxColor.bgColor

								style = {
									...style,
									...this.cssStringToObject(setItem.box.boxColor.bgColor)
								}
							}
							if (setItem.box.bgType == 'checked3') {
								let backgroundImage = `url(${setItem.box.boxBgImg.url})`
								if (setItem.box.boxBgImg.width) {
									style.backgroundSize = setItem.box.boxBgImg.width + 'px';
								} else {
									style.backgroundSize = '100%';
								}
								if (setItem.box.boxBgImg.height) {
									style.backgroundSize = style.backgroundSize + ' ' + (setItem.box.boxBgImg.height +
										'px')
								} else {
									style.backgroundSize = style.backgroundSize + ' 100%'
								}
								if (setItem.box.boxBgImg.type) {
									style.backgroundRepeat = setItem.box.boxBgImg.type
								}
								if (setItem.box.boxBgImg.position) {
									style.backgroundPosition = setItem.box.boxBgImg.position
								}
								style.backgroundImage = backgroundImage
							}
						}
						console.log('getBoxStyle', style)
						return style
					}
				} catch (e) {
					console.log('e', e)
				}
			},
			navBgBoxStyle() {
				try {
					if (this.all_setting.length > 0) {
						console.log('this.all_setting123', this.all_setting)
						let setItem = this.all_setting[0].tabList[0].config.nav
						let style = {}
						if (setItem.bg.setWidth.type == 'px') {
							if (setItem.box.bgType == 'checked1') {
								style.background = setItem.box.boxSingleBgColor.bgColor
							}
							if (setItem.box.bgType == 'checked2') {
								style = {
									...style,
									...this.cssStringToObject(setItem.box.boxColor.bgColor)
								}
								// return setItem.box.boxColor.bgColor
							}
							if (setItem.box.bgType == 'checked3') {
								let backgroundImage = `url(${setItem.box.boxBgImg.url})`
								if (setItem.box.boxBgImg.width) {
									style.backgroundSize = setItem.box.boxBgImg.width + 'px';
								} else {
									style.backgroundSize = '100%';
								}
								if (setItem.box.boxBgImg.height) {
									style.backgroundSize = style.backgroundSize + ' ' + (setItem.box.boxBgImg.height +
										'px')
								} else {
									style.backgroundSize = style.backgroundSize + ' 100%'
								}
								if (setItem.box.boxBgImg.type) {
									style.backgroundRepeat = setItem.box.boxBgImg.type
								}
								if (setItem.box.boxBgImg.position) {
									style.backgroundPosition = setItem.box.boxBgImg.position
								}
								style.backgroundImage = backgroundImage
							}
						}
						console.log('getBoxStyle', style)
						return style
					}
				} catch (e) {
					console.log('catchcatche', e)
				}
			},
			footBoxStyle() {
				try {
					if (this.all_setting.length > 0) {
						console.log('this.all_setting', this.all_setting)
						let setItem = this.all_setting[0].tabList[0].config.foot
						let style = {}
						if (setItem.bg.setWidth.type == 'px') {
							this.isBoxWidth = true
							if (setItem.bg.setWidth.width > 1415) {
								let num = (setItem.bg.setWidth.width - 1415) / 20 // 计算差值
								if (num > 0) {
									this.zoomNum = 1 - ((num + 2) * 0.01)
									console.log('zoomNumzoomNumzoomNum', this.zoomNum)
								}
								style.width = 1414 + 'px'
							} else {
								this.zoomNum = 1
								style.width = setItem.bg.setWidth.width + 'px'
							}



						} else {
							this.zoomNum = 0.73
							style.width = "100%"
						}
						// if (setItem.footerSetHeight.height) {
						// 	style.height = setItem.footerSetHeight.height + 'px'
						// } else {
						// 	style.height = "100%"
						// }
						// if (setItem.topShadow.bgColor) {
						// 	style.boxShadow =
						// 		`0px ${setItem.topShadow.y}px ${setItem.topShadow.r}px ${setItem.topShadow.bgColor} inset`
						// }
						console.log('footBoxStyle', style)
						return style
					}
				} catch (e) {
					console.log('e', e)
				}
			},
			navBoxStyle() {
				try {
					if (this.all_setting.length > 0) {
						console.log('this.all_setting', this.all_setting)
						let setItem = this.all_setting[0].tabList[0].config.nav
						let style = {}
						if (setItem.bg.setWidth.type == 'px') {
							this.isBoxWidth = true
							if (setItem.bg.setWidth.width > 1415) {
								let num = (setItem.bg.setWidth.width - 1415) / 20 // 计算差值
								if (num > 0) {
									this.zoomNum = 1 - ((num + 2) * 0.01)
									console.log('zoomNumzoomNumzoomNum', this.zoomNum)
								}
								style.width = 1414 + 'px'
							} else {
								this.zoomNum = 1
								style.width = setItem.bg.setWidth.width + 'px'
							}
						} else {
							this.zoomNum = 0.73
							style.width = "100%"
						}
						// if (setItem.navSetHeight.height) {
						// 	style.height = parseInt(setItem.navSetHeight.height) + 'px'
						// } else {
						// 	style.height = "100%"
						// }
						// if (setItem.btoShadow.bgColor) {
						// 	style.boxShadow =
						// 		`0px -${setItem.btoShadow.y}px ${setItem.btoShadow.r}px ${setItem.btoShadow.bgColor} inset`
						// }
						console.log('navBoxStyle', style)
						return style
					}
				} catch (e) {
					console.log('e', e)
				}
			},
			footStyle() {
				try {
					if (this.all_setting.length > 0) {
						console.log('this.getBgStyle.all_setting', this.all_setting)
						let setItem = this.all_setting[0].tabList[0].config.foot
						let style = {}
						if (setItem.bg.bgType == 'checked1') {
							style.background = setItem.bg.singleBgColor.bgColor
						}
						if (setItem.bg.bgType == 'checked2') {
							console.log('setItem.bg.bgColor.bgColor', setItem.bg.bgColor.bgColor)
							// return setItem.bg.bgColor.bgColor
							style = {
								...style,
								...this.cssStringToObject(setItem.bg.bgColor.bgColor)
							}
						}
						if (setItem.bg.bgType == 'checked3') {
							let backgroundImage = `url(${setItem.bg.bgImg.url})`
							if (setItem.bg.bgImg.width) {
								style.backgroundSize = setItem.bg.bgImg.width + 'px';
							} else {
								style.backgroundSize = '100%';
							}
							if (setItem.bg.bgImg.height) {
								style.backgroundSize = style.backgroundSize + ' ' + (setItem.bg.bgImg.height + 'px')
							} else {
								style.backgroundSize = style.backgroundSize + ' 100%'
							}
							if (setItem.bg.bgImg.type) {
								style.backgroundRepeat = setItem.bg.bgImg.type
							}
							if (setItem.bg.bgImg.position) {
								style.backgroundPosition = setItem.bg.bgImg.position
							}
							style.backgroundImage = backgroundImage
						}
						console.log('navStyle', style)
						return style

					}
				} catch (e) {
					console.log('e', e)
				}
			},
			navStyle() {
				try {
					if (this.all_setting.length > 0) {
						console.log('this.getBgStyle.all_setting', this.all_setting)
						let setItem = this.all_setting[0].tabList[0].config.nav
						let style = {}

						if (setItem.bg.bgType == 'checked1') {
							style.background = setItem.bg.singleBgColor.bgColor
						}
						if (setItem.bg.bgType == 'checked2') {
							console.log('setItem.bg.bgColor.bgColor', setItem.bg.bgColor.bgColor)

							style = {
								...style,
								...this.cssStringToObject(setItem.bg.bgColor.bgColor)
							}

							// return setItem.bg.bgColor.bgColor
						}
						if (setItem.bg.bgType == 'checked3') {
							let backgroundImage = `url(${setItem.bg.bgImg.url})`
							if (setItem.bg.bgImg.width) {
								style.backgroundSize = setItem.bg.bgImg.width + 'px';
							} else {
								style.backgroundSize = '100%';
							}
							if (setItem.bg.bgImg.height) {
								style.backgroundSize = style.backgroundSize + ' ' + (setItem.bg.bgImg.height + 'px')
							} else {
								style.backgroundSize = style.backgroundSize + ' 100%'
							}
							if (setItem.bg.bgImg.type) {
								style.backgroundRepeat = setItem.bg.bgImg.type
							}
							if (setItem.bg.bgImg.position) {
								style.backgroundPosition = setItem.bg.bgImg.position
							}
							style.backgroundImage = backgroundImage
						}
						console.log('navStyle', style)
						if (setItem.navSetHeight.height) {
							// style.height = parseInt(setItem.navSetHeight.height) + 'px'
							style.height = "100%"
						} else {
							style.height = "100%"
						}
						return style
					}
				} catch (e) {
					console.log('e', e)
				}
			},
			startRightDrag(e) {
				this.domnClientX = e.offsetX
				this.domnClientY = e.offsetY
				document.addEventListener('mousemove', this.onRightDrag);
				document.addEventListener('mouseup', this.stopRightDrag);
			},
			onRightDrag(e) {
				console.log('e', e)
				this.isDragging = true;
				this.rightL = e.clientX - 120; // 调整元素中心偏移
				this.rightTop = e.clientY - 30;

			},
			stopRightDrag(e) {
				let that = this
				document.removeEventListener('mousemove', this.onRightDrag);
				document.removeEventListener('mouseup', this.stopRightDrag);
				setTimeout(() => {
					that.isDragging = false;
				}, 100)
			},
			startDrag(e) {
				this.domnClientX = e.offsetX
				this.domnClientY = e.offsetY
				console.log('startDrag e', e)
				document.addEventListener('mousemove', this.onDrag);
				document.addEventListener('mouseup', this.stopDrag);
			},
			onDrag(e) {
				this.isDragging = true;
				this.leftL = e.clientX - 120; // 调整元素中心偏移
				this.leftTop = e.clientY - 30;

			},
			stopDrag() {
				let that = this
				document.removeEventListener('mousemove', this.onDrag);
				document.removeEventListener('mouseup', this.stopDrag);
				setTimeout(() => {
					that.isDragging = false;
				}, 100)
			},
			leftDragstart(e) {
				console.log('e', e)
				this.leftTop = e.offsetY
				this.leftL = e.offsetX
			},
			setNode(data, node) {
				this.selectdItem = null
				this.$nextTick(() => {
					if (data.name != '容器') {
						if (data.level == 2) {
							this.selectdItem = data.children[0]
						}
						if (data.level == 3) {
							this.selectdItem = data
						}
						if (data.level == 1) {
							this.selectdItem = data.children[0].children[0]
						}
					} else {
						this.selectdItem = data
						console.log('this.selectdItem', this.selectdItem)
					}
					
					if(this.selectdItem.preStyle.font){
						let itemSetFont = ''
						if (this.all_setting.length > 0) {
							// 全局设置
							let itemSetFont = this.all_setting[0].tabList[1]
							if(!this.selectdItem.preStyle.font.fontFamily){
								this.$set(this.selectdItem.preStyle.font,'fontFamily',itemSetFont.config.setfontFamily)
							}
						}
					}
					this.pContainerItem = data
					this.setSelectdItem(this.selectdItem)
					if (this.selectdItem.level < 3) {
						this.rightTab = '1'
					} else {
						this.rightTab = '3'
					}
				})
			},
			changeAddSGNum(e, selectdItem) {
				console.log('changeSGNum e', e)
				console.log('changeSGNum this.selectdItem', this.selectdItem)
				let num = 0
				selectdItem.containerLayout.num = e
				if (selectdItem.children) {
					let len = selectdItem.children.length
					num = e - len
					if (num > 0) {
						// 判断层级
						if (selectdItem.level == 1) {
							let newObj = lodash.cloneDeep(obj)
							newObj.id = new Date().getTime()
							newObj.children[0].id = (new Date().getTime()) + "child"
							console.log("newObj.id ", newObj.id)
							selectdItem.children.push(newObj)
						}
						if (selectdItem.level == 2) {
							selectdItem.children.push({
								...lodash.cloneDeep(componentObj),
								id: new Date().getTime()
							})
						}
					}
					if (num < 0) {
						selectdItem.children.splice(len - (len - num), len - num)
					}
				}
			},
			treeSelectItem(item) {
				if (this.cmpZindex == 0) {
					return
				}
				if (item.level == 4) {
					if (item.isNeedData) {
						this.haveData = false
					}
				}
				if (this.needTreeAddCmp == null && item.level == 4) {
					// 直接添加
					let newComp = lodash.cloneDeep(compoentsConfig[0])
					let newItem = lodash.cloneDeep(item)
					newItem.id = new Date().getTime()
					// 添加id
					newComp.id = (new Date().getTime()) + 'container1'
					newComp.children[0].id = (new Date().getTime()) + 'container2'
					newComp.children[0].children[0].id = (new Date().getTime()) + 'container3'

					// newComp.children[0].children[0].preStyle.compontentStyle = {
					// 	...newComp.children[0].children[0].preStyle.compontentStyle,
					// 	...newItem.preStyle,
					// 	...newItem.preStyle.pc
					// }
					// newComp.children[0].children[0].preStyle.compontentStylePhone = {
					// 	...newComp.children[0].children[0].preStyle.compontentStylePhone,
					// 	...newItem.preStyle,
					// 	...newItem.preStyle.phone
					// }
					this.treeSelectItemClone(newComp.children[0].children[0])
					newComp.children[0].children[0].preStyle = {
						...newComp.children[0].children[0].preStyle,
						...newItem.preStyle,
					}
					newComp.children[0].children[0].compontChildren.push(newItem)

					this.centerList.push(newComp)
					newComp.name = newItem.name
					newComp.children[0].name = newItem.name
					this.needTreeAddCmp = null
					this.cmpZindex = 0

					this.newElementId = newItem.id
					this.initStyle()
					return
				}
				if (this.needTreeAddCmp == null && item.level == 1) {
					let newItem = lodash.cloneDeep(item)
					console.log('newItem', newItem)
					newItem.id = new Date().getTime()
					newItem.children = []
					this.centerList.push(newItem)
					this.cmpZindex = 0

					this.newElementId = newItem.id
					this.initStyle()
					return
				}
				console.log('itemitemitemitemitem', this.needTreeAddCmp)
				console.log('itemitemitemitemitem', this.cmpZindex)
				console.log('itemitemitemitemitem', item)
				let newItem = lodash.cloneDeep(item)
				newItem.id = new Date().getTime()
				if (newItem.level == 1) {
					if (this.needTreeAddCmp.level == 1) {
						// 容器 直接加一层 但是只是展示一层
						let addChildren = lodash.cloneDeep(newItem.children[0])
						addChildren.id = (new Date().getTime()) + 'container1'
						addChildren.children = []
						this.needTreeAddCmp.children.push(addChildren)
						this.needTreeAddCmp.containerLayout.num = this.needTreeAddCmp.children.length
					}
					if (this.needTreeAddCmp.level == 2) {
						// 容器2 直接添加一层
						let addChildren = lodash.cloneDeep(newItem.children[0].children[0])
						addChildren.id = new Date().getTime()



						this.needTreeAddCmp.children.push(addChildren)
						this.needTreeAddCmp.containerLayout.num = this.needTreeAddCmp.children.length
					}
				}
				if (newItem.level == 4) {
					if (this.needTreeAddCmp.level == 1) {
						newItem.addLevel = 1
						// 添加两层容器
						let addChildren = lodash.cloneDeep(compoentsConfig[0].children[0])
						addChildren.id = (new Date().getTime()) + 'container2'
						console.log('addChildren2222', addChildren.id)
						addChildren.name = newItem.name
						addChildren.children[0].id = (new Date().getTime()) + 'container3'
						// 添加组件

						// 添加默认样式
						// addChildren.children[0].preStyle.compontentStyle = {
						// 	...addChildren.children[0].preStyle.compontentStyle,
						// 	...newItem.preStyle,
						// 	...newItem.preStyle.pc
						// }
						// addChildren.children[0].preStyle.compontentStylePhone = {
						// 	...addChildren.children[0].preStyle.compontentStylePhone,
						// 	...newItem.preStyle,
						// 	...newItem.preStyle.phone
						// }
						this.treeSelectItemClone(addChildren.children[0])
						let newPreStyle = {
							...addChildren.children[0].preStyle,
							...newItem.preStyle,
						}
						addChildren.children[0].preStyle = newPreStyle

						// addChildren.children[0].preStyle.compontentStyle = {
						// 	...newItem.preStyle.compontentStyle
						// }
						// Object.assign(addChildren.children[0].preStyle,newItem.preStyle)
						// addChildren.children[0].preStyle.
						console.log('1addChildrenaddChildrenaddChildren', addChildren.children[0].preStyle)
						console.log('1addChildrenaddChildrenaddChildren', newItem.preStyle)

						addChildren.children[0].compontChildren.push(newItem)

						this.needTreeAddCmp.children.push(addChildren)
					}
					if (this.needTreeAddCmp.level == 2) {
						// 添加两层容器
						newItem.addLevel = 2
						let addChildren = lodash.cloneDeep(compoentsConfig[0].children[0].children[0])
						addChildren.name = newItem.name
						console.log('addChildren111', addChildren)
						addChildren.id = (new Date().getTime()) + 'container3'
						// 添加默认样式
						// if (this.equipment == 'pc') {
						// 	addChildren.preStyle.compontentStyle = {
						// 		...addChildren.preStyle.compontentStyle,
						// 		...newItem.preStyle,
						// 		...newItem.preStyle.pc
						// 	}
						// } else {
						// 	addChildren.preStyle.compontentStyle = {
						// 		...addChildren.preStyle.compontentStyle,
						// 		...newItem.preStyle,
						// 		...newItem.preStyle.phone
						// 	}
						// }
						addChildren = this.treeSelectItemClone(addChildren)
						addChildren.preStyle = {
							...addChildren.preStyle,
							...newItem.preStyle,
						}
						// addChildren.preStyle.compontentStyle = {
						// 	...addChildren.preStyle.compontentStyle,
						// 	...newItem.preStyle,
						// 	...newItem.preStyle.pc
						// }
						// addChildren.preStyle.compontentStylePhone = {
						// 	...addChildren.preStyle.compontentStylePhone,
						// 	...newItem.preStyle,
						// 	...newItem.preStyle.phone
						// }
						addChildren.compontChildren.push(newItem)


						this.needTreeAddCmp.children.push(addChildren)
					}
					if (this.needTreeAddCmp.level == 3) {
						// 添加两层容器
						newItem.addLevel = 3
						this.needTreeAddCmp.name = newItem.name
						// 添加默认样式
						this.needTreeAddCmp = this.treeSelectItemClone(this.needTreeAddCmp)
						this.needTreeAddCmp.preStyle = {
							...this.needTreeAddCmp.preStyle,
							...newItem.preStyle,
						}

						// this.needTreeAddCmp.preStyle.compontentStyle = {
						// 	...this.needTreeAddCmp.preStyle.compontentStyle,
						// 	...newItem.preStyle,
						// 	...newItem.preStyle.pc
						// }
						// this.needTreeAddCmp.preStyle.compontentStylePhone = {
						// 	...this.needTreeAddCmp.preStyle.compontentStylePhone,
						// 	...newItem.preStyle,
						// 	...newItem.preStyle.phone
						// }


						this.needTreeAddCmp.compontChildren.push(newItem)

					}
					if (this.needTreeAddCmp.level < 3) {
						this.needTreeAddCmp.containerLayout.num = this.needTreeAddCmp.children.length
					}

				}
				// this.expandedKeys = []
				this.needTreeAddCmp = null
				this.cmpZindex = 0
				console.log('this.cmpZindex', this.cmpZindex)
				this.newElementId = newItem.id
				this.initStyle()
			},
			treeSelectItemClone(childItem) {
				if (this.all_setting.length > 0) {
					// 全局字体设置
					let itemSetFont = this.all_setting[0].tabList[1]
					childItem.preStyle.font.color = itemSetFont.config.setColor.color
					childItem.preStyle.font.size = parseInt(itemSetFont.config.setFontSize.fontSize)
					childItem.preStyle.font.fontFamily = itemSetFont.config.setfontFamily
						.fontFamily
					childItem.preStyle.font.name = itemSetFont.config.setfontFamily.name
				}
				return childItem
			},

			addNode(data, node) {
				console.log('data, node', data, node)
				this.cmpZindex = 1000
				this.needTreeAddCmp = data
			},
			delNode(data, node) {
				if (data.level == 3) {
					if (data.compontChildren.length > 0) {
						data.compontChildren = []
						data.name = '容器'
					} else {
						const parent = node.parent;
						const children = parent.data.children || parent.data;
						const index = children.findIndex(d => d.id === data.id);
						children.splice(index, 1);
					}
				} else {
					const parent = node.parent;
					const children = parent.data.children || parent.data;
					const index = children.findIndex(d => d.id === data.id);
					children.splice(index, 1);
					if (parent && parent.children && data.level < 3) {
						parent.data.containerLayout.num = parent.data.children.length
					}
				}
				this.needTreeAddCmp = null
			},
			handleDragStart(node, ev) {
				// console.log('drag start', node);
			},
			handleDragEnter(draggingNode, dropNode, ev) {
				// console.log('tree drag enter: ', dropNode.label);
			},
			handleDragLeave(draggingNode, dropNode, ev) {
				// console.log('tree drag leave: ', dropNode.label);
			},
			handleDragOver(draggingNode, dropNode, ev) {
				// console.log('tree drag over: ', dropNode.label);
			},
			handleDragEnd(draggingNode, dropNode, dropType, ev) {
				console.log('tree drag end: ', draggingNode, dropNode, dropType, ev);
				if (draggingNode.data.level == 3) {
					this.searchMove(this.centerList)
				}
			},
			searchMove(list, pData) {
				list.forEach(item => {
					console.log('item', item)
					if (item.children) {
						item.containerLayout.num = item.children.length
						this.searchMove(item.children, item)
					}
					// if(data.id == item.id) {
					// 	console.log('pData', pData);
					// 	pData.containerLayout.num = pData.children.length
					// 	console.log('searchMove', data);
					// }
					// if(item.children){
					// 	this.searchMove(data,item.children,item)
					// }

				})
			},
			handleDrop(draggingNode, dropNode, dropType, ev) {
				// console.log('tree drop: ', dropNode.label, dropType);
			},
			allowDrop(draggingNode, dropNode, type) {
				console.log('draggingNode, dropNode, type', draggingNode, dropNode, type)
				if (draggingNode.level == 3) {
					if (dropNode.level == 2 && type == 'inner') {
						return true
					}
					if (dropNode.level == 3 && (type == 'next' || type == 'prev')) {
						return true
					}

				}
				if (draggingNode.level == 2) {
					if (dropNode.level == 1 && type == 'inner' && dropNode.data.name == '容器') {
						return true
					}
					if (dropNode.level == 2 && (type == 'next' || type == 'prev')) {
						return true
					}
				}

				if (draggingNode.level == 1) {
					if (dropNode.level == 1 && (type == 'next' || type == 'prev')) {
						return true
					}
				}

			},
			allowDrag(draggingNode) {
				return true;
				// return draggingNode.data.label.indexOf('三级 3-2-2') === -1;
			},
			qjList() {
				if (this.qjCenterLists.length > 0) {
					let item = this.qjCenterLists[this.qjCenterLists.length - 1]
					this.returnListState = false
					this.centerList = lodash.cloneDeep(item)

					this.treeKey = this.treeKey + 1
					this.selectdItem = null
					console.log('this.centerList2356', this.centerList)
				}
			},
			retrunList() {
				console.log('this.recordCenterLists123', this.recordCenterLists)
				if (this.recordCenterLists.length > 0) {
					let item = this.recordCenterLists[this.recordCenterLists.length - 1]
					this.returnListState = false
					// this.qjCenterLists.push(lodash.cloneDeep(this.centerList))
					// if(this.qjCenterLists.length == 30) {
					// 	this.qjCenterLists.splice(0,1)
					// }
					this.centerList = JSON.parse(item)
					this.recordCenterLists.splice(this.recordCenterLists.length - 1, 1)
					this.treeKey = this.treeKey + 1
					// this.selectdItem = null
					if (this.selectdItem) {
						this.serachSelectItem(this.centerList)
					}
					console.log('this.centerList', this.centerList)
				}
				console.log('this.recordCenterLists', this.recordCenterLists)
			},
			serachSelectItem(list) {
				if (list) {
					list.forEach(item => {
						if (item.id == this.selectdItem.id) {
							this.selectdItem = item
						} else {
							this.serachSelectItem(item.children)
						}
					})
				}
			},

			renderNodeContent(h, {
				node,
				data,
				store
			}) {
				// 对特定节点禁止展开

				// if (data.level === 2 && data.children.length == 1 && data.children[0].compontChildren.length == 1) {
				// 	console.log('renderNodeContent123',node, data, store)
				// 	node.expanded = false;
				// 	// node.loaded = false;
				// 	node.isLeaf = true;         // 伪装成叶子节点（隐藏展开图标）
				// }


				if (data.name != '容器') {
					node.expanded = false;
					node.loaded = false;
					node.isLeaf = true; // 伪装成叶子节点（隐藏展开图标）
				}

				let that = this
				console.log('renderNodeContent')
				return h('span', {
					class: 'custom-tree-node',
					props: {
						node,
						data
					}
				}, [h('span', {}, that.renderContent(node, data)),
					h('i', {
						style: {
							'margin-right': '10px'
						},
						class: ['el-icon-plus', 'tit-icon'],
						on: {
							click: function(e) {
								e.preventDefault();
								e.stopPropagation();
								that.addNode(data, node)
								return false
							}
						}
					}, ''),
					h('i', {
						style: {
							'margin-right': '10px'
						},
						class: ['el-icon-setting', 'tit-icon'],
						on: {
							click: function(e) {
								e.preventDefault();
								e.stopPropagation();
								that.setNode(data, node)
								return false
							}
						}
					}, ''),
					h('i', {
						style: {
							'margin-right': '10px'
						},
						class: ['el-icon-delete', 'tit-icon'],
						on: {
							click: function(e) {
								e.preventDefault();
								e.stopPropagation();
								that.delNode(data, node)
								return false
							}
						}
					}, ''),
				]);
			},
			//锚点跳转
			goAnchor(id) {
				/*参数selector是id选择器（#anchor14）*/
				document.querySelector('#' + 's_' + id ).scrollIntoView({
					behavior: "smooth"
				});
			},
			currentChangeNode(node, data) {
				console.log('currentChangeNodenode，data', node, data)
				this.needTreeAddCmp = data.data
				if(data.level == 2){
					this.goAnchor(data.parent.data.id)
				}
				if(data.level == 3){
					this.goAnchor(data.parent.parent.data.id)
				}
				if(data.level == 1){
					this.goAnchor(data.data.id)
				}
				
				// if(data.data.)
				// if(data.parent) {
				// 	this.pItem = data.parent
				// }
				this.setNode(data.data, node)
				if (data.name != '容器') {
					node.expanded = false;
					node.loaded = false;
					node.isLeaf = true; // 伪装成叶子节点（隐藏展开图标）
				}
				
			},
			copyComp(node, data) {
				console.log('copyCompdata', data)

				if (data.data.level == 1) {
					let obj = lodash.cloneDeep(data.data)
					obj.id = (new Date().getTime()) + 'container'
					obj.children.forEach((childItem, childIndex) => {
						childItem.id = (new Date().getTime()) + (childIndex + 'container2')
						childItem.children.forEach((twoChildItem, twoChildIndex) => {
							twoChildItem.id = (new Date().getTime()) + (twoChildIndex + 'container3' +
								childIndex)
							if (twoChildItem.compontChildren.length > 0) {
								twoChildItem.compontChildren[0].id = new Date().getTime() + (
									twoChildIndex + '' + childIndex)
							}
						})

					})
					console.log('copyCompobj', obj)
					this.centerList.push(obj)
				}

				if (data.data.level == 2) {
					let obj = lodash.cloneDeep(data.data)
					obj.id = (new Date().getTime()) + 'container2'
					obj.children.forEach((childItem, childIndex) => {
						childItem.id = (new Date().getTime()) + (childIndex + 'container2')
						if (childItem.compontChildren.length > 0) {
							childItem.compontChildren[0].id = new Date().getTime() + ('' + childIndex)
						}
					})
					data.parent.data.children.push(obj)
				}


				if (data.data.level == 3) {
					let obj = lodash.cloneDeep(data.data)
					obj.id = (new Date().getTime()) + 'container3'
					if (obj.compontChildren.length > 0) {
						obj.compontChildren[0].id = new Date().getTime() + ''
					}
					data.parent.data.children.push(obj)
				}
				this.$message.success('复制完成')

			},
			renderContent(node, data) {
				// console.log('renderContentrenderContent', node, data)
				if (data.name != '容器') {
					// node.expanded = false;
					// node.isLeaf = true; // 伪装成叶子节点（隐藏展开图标）
					// 关键点3：直接移除子节点（避免动画）
				} else {
					if (that.expandedKeys.indexOf(data.id) == -1) {
						that.expandedKeys.push(data.id)
					}
				}
				return data.name
			},
			getChildren(node) {
				console.log('node', node)
				if (node.level == 3) {
					if (node.compontChildren.length > 0) {
						node.name = node.compontChildren[0].name
					}
				}
				// 优先返回children，如果没有则返回compontChildren
				return node.children
			},
			confirmGoods(e) {
				console.log('confirmGoods e', e)
				this.selectdItem.compontChildren[0].data = lodash.cloneDeep(e)
				this.dialogGoodsVisible = false


				this.$forceUpdate()
			},
			confirmText(e) {
				console.log('confirmText e', e)
				this.selectdItem.compontChildren[0].data.text.list.forEach(item => {
					if (e[item.language]) {
						item.text = e[item.language]
					}
				})
				this.dialogTextVisible = false
			},
			deleteImgs(index) {
				this.selectdItem.compontChildren[0].data.imgUrl.list.splice(index, 1)

				// this.selectdItem.compontChildren[0].data.imgUrl.list.push({
				// 	url:""
				// })

				let ik = -1
				this.selectdItem.compontChildren[0].data.imgUrl.list.forEach(e => {
					if (e.url == '') {
						ik = 1
					}
				})
				if (ik == -1) {
					this.selectdItem.compontChildren[0].data.imgUrl.list.push({
						url: ""
					})
				}
			},
			confirmSelectImg(e) {
				console.log('e', e)
				console.log(this.selectdItem)
				if (this.selectdItem.compontChildren[0].compoentName == 'wmImg') {
					// this.selectdItem.compontChildren[0].data.imgUrl.list[this.imgsIndex] = e
					this.selectdItem.compontChildren[0].data.imgUrl.list.splice(this.imgsIndex, 1)
					this.selectdItem.compontChildren[0].data.imgUrl.list.splice(this.imgsIndex, 0, e)
				}
				if (this.selectdItem.compontChildren[0].compoentName == 'wmCarousel') {
					// this.selectdItem.compontChildren[0].data.imgUrl.list[this.imgsIndex] = e
					this.selectdItem.compontChildren[0].data.imgUrl.list.splice(this.imgsIndex, 1)
					this.selectdItem.compontChildren[0].data.imgUrl.list.splice(this.imgsIndex, 0, e)

					let index = -1
					this.selectdItem.compontChildren[0].data.imgUrl.list.forEach(e => {
						if (e.url == '') {
							index = 1
						}
					})
					if (index == -1) {
						this.selectdItem.compontChildren[0].data.imgUrl.list.push({
							url: ""
						})
					}
				}
				this.haveData = true
				this.dialogVisibleImgs = false
			},
			// preview(frame) {
			// 	var myIframe = $("#frame");
			// 	var url = basePath + "/base/commonFileUpload/preview?id=" + frame + "&split=1";
			// 	$('#frame').attr('src', url);
			// },
			watchPageChange(newVal) {
				let filed = 'navList'
				if (parseInt(this.pageValue) > 4) {
					this.config.center.page.forEach(pageItem => {
						if (pageItem.pageValue == this.pageNewValue) {
							filed = pageItem.filed
						}
					})
				} else {
					if (this.pageNewValue == '1') {
						filed = 'navList'
					}
					if (this.pageNewValue == '2') {
						filed = 'navPhoneList'
					}
					if (this.pageNewValue == '3') {
						filed = 'footerList'
					}
					if (this.pageNewValue == '4') {
						filed = 'footerPhoneList'
					}
				}
				console.log('watchPageChange', newVal)
				console.log('filedfiled', filed)
				if (newVal.length > 0) {
					this.setList({
						filed: filed,
						list: newVal
					})
				}
			},
			getField(type) {
				let field = ''
				this.config.center.page.forEach(pageItem => {
					if (pageItem.type == type) {
						field = pageItem.filed
					}
				})
				console.log('getFieldgetField', field)
				return field
			},
			async changePage(e) {
				try {
					this.loading = true
					this.drawerStruct = false
					this.editableTabsValue = '1'
					this.cmpZindex = 0
					console.log('e', e)
					console.log('drawerStruct', this.drawerStruct)
					this.pageNewValue = e
					this.centerList = []
					this.recordCenterLists = []
					this.selectdItem = null
					this.returnListState = false
					let filed = 'navList'
					let type = 'pcNav'
					this.leftList = lodash.cloneDeep(compoentsConfig)
					// this.leftList[0].children = []
					let wsid = this.$cookies.get("wsid")
					let showData = await getDesignShow({
						wsid,
						// type
					})


					if (showData.data.data.list.goodsConfig) {
						console.log('JSON.parse(showData.data.data.list.goodsConfig)', JSON.parse(showData.data.data
							.list.goodsConfig))
						this.setList({
							filed: 'goodsConfig',
							list: JSON.parse(showData.data.data.list.goodsConfig)
						})
					}

					if (showData.data.data.remote) {
						this.remote = showData.data.data.remote
					}
					if (showData.data.data.all_setting) {
						this.all_setting = JSON.parse(showData.data.data.all_setting.data)
						if (this.all_setting.length > 0) {
							let itemSetFont = this.all_setting[0].tabList[1]
							this.fontList = itemSetFont.config.setfontFamily.fontList
						}
						console.log('this.all_setting', this.all_setting)
					}
					if (this.pageValue == '10' || this.pageValue == '11') {
						for (let i in showData.data.data.list) {
							if (JSON.parse(showData.data.data.list[i]).length > 0) {
								this.setList({
									filed: this.getField(i),
									list: JSON.parse(showData.data.data.list[i])
								})
							}
						}
					}
					this.config.center.page.forEach(pageItem => {
						if (pageItem.pageValue == e) {
							filed = pageItem.filed
							type = pageItem.type
							this.equipment = pageItem.equipment
						}
						if (pageItem.loadCmp && this[pageItem.filed].length == 0) {
							pageItem.loadCmp.forEach(loadCmpItem => {
								this.leftList.forEach(item => {
									if (item.compoentName == loadCmpItem) {
										let obj = lodash.cloneDeep(this.leftList[0])
										console.log('objobjobjobj', obj)
										let cloneObj = lodash.cloneDeep(item)
										this.cloneRule(obj, false)
										obj.cancelDelete = true
										obj.name = cloneObj.name
										obj.children[0].name = cloneObj.name
										obj.children[0].children[0].name = cloneObj.name
										obj.children[0].children[0].compontChildren.push(
											cloneObj)
										this.setList({
											filed: pageItem.filed,
											list: [obj]
										})
										this.initFieldStyle(pageItem.filed)
									}
								})
							})
						}
					})
					if (this.pageValue == '10' || this.pageValue == '11') {
						this.globalSetShow = false
						this.$nextTick(() => {
							this.globalSetShow = true
						})
					}
					if (e != '10' && e != '11') {
						if (this[filed].length == 0) {
							// 自动添加一个容器
							let obj = lodash.cloneDeep(this.leftList[0])
							obj.children = []
							if (e == '1' || e == '2') {
								obj.preStyle.sticky = true
							}
							// if (e == '6') {
							// 	obj.preStyle.bottomSticky = true
							// }
							obj.id = new Date().getTime()
							// obj.children[0].id = new Date().getTime() + 'child'
							this.setList({
								filed,
								list: [obj]
							})
							if (showData.data.data.list[type] && JSON.parse(showData.data.data.list[type]).length >
								0) {
								this.centerList = JSON.parse(showData.data.data.list[type])
							} else {
								this.centerList = [obj]
							}

							this.loading = false
						} else {
							this.centerList = this[filed]
							console.log('this.centerList', this.centerList)
						}
						this.requestFun()
					}
					this.loading = false
				} catch (e) {
					console.log('catche', e)
					this.loading = false
				}
			},
			mouseenterSet(item,pItem,ppItem) {
				console.log('mouseenterSetitem123', item)
				if (item.name != '容器') {
					if (item.level == 2) {
						this.mouseenterItem = item.children[0]
						return
					}
					if (item.level == 1) {
						this.mouseenterItem = item.children[0].children[0]
						return
					}
				}
				// if(ppItem.name != '容器') {
				// 	this.mouseenterItem = ppItem
				// 	return 
				// }
				// if(pItem.name != '容器') {
				// 	this.mouseenterItem = pItem
				// 	return
				// }
				
				
				
				this.mouseenterItem = item
				// console.log('mouseenterSet', item)
			},
			mouseenterdel(item) {
				this.mouseenterItem = item
				// console.log('mouseenterdel', item)
			},
			onCreated(editor) {
				this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
			},

			delItem(e, type, index, pIndex, topPIndex) {
				console.log('delItem', e)
				console.log('delItem', this.centerList)
				if (type == 1) {
					this.centerList.splice(index, 1)
				}
				// 删除第二层
				if (type == 2) {
					if (pIndex.children.length > 1) {
						pIndex.children.splice(index, 1)
						pIndex.containerLayout.num = pIndex.containerLayout.num - 1
					} else {
						this.$message.error("最少为一个子元素")
					}
				}
				// 删除第三层
				if (type == 3) {
					console.log('pIndex', pIndex)
					if (pIndex.children.length > 1) {
						// 直接删除
						if (pIndex.children[index].compontChildren.length > 0) {
							pIndex.children[index].compontChildren.splice(0, 1)
						} else {
							pIndex.children.splice(index, 1)
						}
						pIndex.containerLayout.num = pIndex.containerLayout.num - 1
					} else {
						if (pIndex.children[index].compontChildren.length > 0) {
							pIndex.children[index].compontChildren.splice(0, 1)
						} else {
							this.$message.error("最少为一个子元素")
						}

					}
				}
			},
			clear() {
				this.selectdItem = null
				this.centerList = []
			},
			onWindowsMousedown: function(e) {
				let clazz = e.target.getAttribute('class');
				let id = e.target.getAttribute('id');
				if (clazz === 'el-dropdown-menu__item') {
					// todo sth.
				}

				this.dropdown_visible = false;
				this.dropdown_name = undefined;
			},
			rightClick(e, item, l, index) {
				// console.log('rightClick')
				// console.log('e', e)
				// console.log('e', e.target)
				// this.dropdown_visible = true;
				// this.left = e.clientX + 20;
				// this.top = e.clientY - 3;

				// this.delInfo.item = item
				// this.delInfo.l = l
				// this.delInfo.index = index
				// this.selectItemContainer(item)
			},
			linkFront() {
				let preview = window.open('https://' + this.remote, '_bank ');
				preview.location.reload(true);
			},
			async preview() {
				this.loading = true
				// await this.requestData("navList")
				// await this.requestData("navPhoneList")
				// await this.requestData("footerList")
				// await this.requestData("footerPhoneList")
				// await this.requestData("homeList")

				// for(let i = 0;i < this.config.center.page.length;i++) {
				// 	await this.requestData(this.config.center.page[i].filed)
				// }

				console.log('preview', this.navList)
				console.log('preview footerList', this.footerList)
				let filed = "navList"
				this.config.center.page.forEach(pageItem => {
					if (pageItem.pageValue == this.pageValue) {
						filed = pageItem.filed

					}
				})
				if (this.pageValue != '10' && this.pageValue != '11') {
					this.setList({
						filed: filed,
						list: this.centerList
					})
				}
				console.log('centerList', this.centerList)
				console.log('this.detailList', this.detailList)

				localStorage.setItem('filed', filed);
				localStorage.setItem('navList', JSON.stringify(this.navList));
				localStorage.setItem('navPhoneList', JSON.stringify(this.navPhoneList));
				localStorage.setItem('homeList', JSON.stringify(this.homeList));
				localStorage.setItem('footerList', JSON.stringify(this.footerList));
				localStorage.setItem('footerPhoneList', JSON.stringify(this.footerPhoneList));
				localStorage.setItem('bottomCartPhoneList', JSON.stringify(this.bottomCartPhoneList));
				localStorage.setItem('all_setting', JSON.stringify(this.all_setting));
				localStorage.setItem('detailList', JSON.stringify(this.detailList));
				// await this.save()
				// await this.changePage('6')
				this.loading = false
				const {
					href
				} = this.$router.resolve({
					path: '/preview'
				});
				let preview = window.open(href, '_bank ');
				preview.location.reload(true);
			},
			// async requestData(fieldList) {
			// 	// 装配 导航
			// 	for (let i = 0; i < this[fieldList].length; i++) {
			// 		let item = this[fieldList][i]
			// 		if (item.requestData) {
			// 			for (let j = 0; j < item.children.length; j++) {
			// 				let childrenItem = item.children[j]
			// 				for (let k = 0; k < childrenItem.children.length; k++) {
			// 					let twoChildrenItem = childrenItem.children[k]
			// 					for (let m = 0; m < twoChildrenItem.compontChildren.length; m++) {
			// 						let compontChildrenItem = twoChildrenItem.compontChildren[m]
			// 						if (compontChildrenItem.requestData && compontChildrenItem.requestData.mounted) {
			// 							let data = await compontChildrenItem.requestData.mounted(this)
			// 							compontChildrenItem.data[data['field']] = data.data
			// 							console.log('compontChildrenItem.requestData.mounted', compontChildrenItem
			// 								.requestData.mounted)
			// 						}
			// 					}
			// 				}
			// 			}
			// 		}
			// 	}
			// },
			...mapMutations("lowCodeStore", ["setSelectdItem", "setCenterList", "setList"]),
			centerStart(e) {
				// console.log('centerStart e', e)
				this.addComponentPut = false
			},
			centerEnd(e) {
				// console.log('centerEnd e', e)
				this.addContainerPut = true
				this.addComponentPut = true
			},
			selectBgImg() {
				// console.log('selectBgImg')
				this.dialogVisible = true
			},
			confirmImg(e) {
				this.dialogVisible = false

				this.selectdItem.preStyle.bg.img = e.url
				// console.log('confirmImg e', e)
			},
			paddingSet(e) {
				// console.log('paddingSet e', e)
				// console.log('paddingSet this.selectdItem', this.selectdItem)
				if (this.selectdItem.preStyle.paddingSetAll) {
					let num = parseInt(event.target.value)
					this.selectdItem.preStyle.padding = [num, num, num, num]
				}

			},
			marginSet(e) {
				// console.log('marginSet e', event.target.value)
				// console.log('this.selectdItem', this.selectdItem)
				// console.log('marginSet this.selectdItem', this.selectdItem)
				if (this.selectdItem.preStyle.marginSetAll) {
					let num = parseInt(event.target.value)
					this.selectdItem.preStyle.margin = [num, num, num, num]
				}
			},
			getChildConentStyle(e) {
				// console.log('getChildConentStyle e', e)
				// console.log('getChildConentStyle this.selectdItem', this.selectdItem)
				// console.log('getChildConentStyle this.centerList', this.centerList)
				// 文字渐变
				let style = {}
				// if (e.preStyle.compontentStyle.needHW && this.equipment == 'pc') {
				// 	if(e.preStyle.compontentStyle.percentWidthSwitch) {
				// 		style.width = '100%'
				// 	}else {
				// 		style.width = e.preStyle.compontentStyle.width + 'px'
				// 	}

				// 	style.height = e.preStyle.compontentStyle.height + 'px'
				// }
				// if (e.preStyle.compontentStylePhone.needHW && this.equipment == 'phone') {
				// 	if(e.preStyle.compontentStylePhone.percentWidthSwitch) {
				// 		style.width = '100%'
				// 	}else {
				// 		style.width = e.preStyle.compontentStylePhone.width + 'px'
				// 	}
				// 	style.height = e.preStyle.compontentStylePhone.height + 'px'
				// }
				// let background =
				// 	`linear-gradient(${e.preStyle.font.background.angle}deg ,${e.preStyle.font.background.color1}, ${e.preStyle.font.background.color2})`
				// if (e.preStyle.font.background.color1 && e.preStyle.font.background.color2) {
				// 	style.background = background
				// 	style.backgroundClip = 'text'
				// 	style.color = 'transparent'
				// }
				// console.log('getChildConentStylestyle',e.preStyle.compontentStylePhone.percentWidthSwitch)
				// console.log('getChildConentStylestyle1', style)
				return style
			},
			getStyleComponentFather(e) {
				let style = {}
				// if (this.all_setting.length > 0) {
				// 	let itemSetFont = this.all_setting[0].tabList[1]
				// 	e.preStyle.font.color = itemSetFont.config.color
				// 	e.preStyle.font.size = parseInt(itemSetFont.config.fontSize)
				// 	e.preStyle.font.fontFamily = itemSetFont.config.fontFamily
				// 	// childItem.preStyle.size
				// }
				if (e.preStyle.font.color) {
					style.color = e.preStyle.font.color
				}
				if (e.preStyle.font.fontFamily) {
					style.fontFamily = e.preStyle.font.fontFamily
				}
				if (e.preStyle.font.size) {
					// console.log('getStyleComponentFatherstyle e', e)
					style.fontSize = e.preStyle.font.size
				}

				return style
			},
			getFontStyle(e) {
				let item;
				// console.log('getFontStyle', this.fontList)
				this.fontList.forEach(fontItem => {
					if (fontItem.name == e) {
						item = fontItem
					}
				})

				if (item) {
					if (!document.getElementById(item.name)) {
						var style = document.createElement('style');
						style.type = 'text/css';
						style.id = item.name
						style.innerHTML = item.css;
						document.getElementsByTagName('HEAD').item(0).appendChild(style);
					}
				}
			},
			getComponentStyle(e) {
				// console.log('getComponentStyle e', e)
				let style = {}
				// 设置字体
				let fontSize = `${e.preStyle.font.size}px`
				let color = `${e.preStyle.font.color}`
				// 背景渐变
				// 设置宽高
				let width = ""
				let height = ""
				// style.borderRadius = e.preStyle.border.radius + 'px'
				// if (e.preStyle.border.color) {
				// 	style.border = e.preStyle.border.type + " " + e.preStyle.border.color + " " + e.preStyle.border.px +
				// 		"px"
				// }
				let boxShadow =
					`${e.preStyle.boxShadow.h}px ${e.preStyle.boxShadow.v}px ${e.preStyle.boxShadow.blur}px ${e.preStyle.boxShadow.spread}px ${e.preStyle.boxShadow.color}`
				if (e.preStyle.boxShadow.type != 'outset') {
					boxShadow = `${boxShadow} ${e.preStyle.boxShadow.type}`
				}
				let backgroundRepeat = e.preStyle.bg.type

				let margin = {
					marginTop: e.preStyle.margin[0] + 'px',
					marginBottom: e.preStyle.margin[1] + 'px',
					marginLeft: e.preStyle.margin[2] + 'px',
					marginRight: e.preStyle.margin[3] + 'px'
				}
				let padding = {
					paddingTop: e.preStyle.padding[0] + 'px',
					paddingBottom: e.preStyle.padding[1] + 'px',
					paddingLeft: e.preStyle.padding[2] + 'px',
					paddingRight: e.preStyle.padding[3] + 'px'
				}
				style = {
					color,
					// background,
					// fontWeight,
					fontSize,
					// width,
					// height,
					...style,
					backgroundRepeat,
					boxShadow,
					...margin,
					...padding,
					whiteSpace: 'nowrap'
				}

				if (e.preStyle.font.weight) {
					style.fontWeight = e.preStyle.font.weight
				}

				if (e.preStyle.border.borderSize) {
					style.borderTop =
						`${e.preStyle.border.type} ${e.preStyle.border.borderSize[0]}px ${e.preStyle.border.color}`
					style.borderLeft =
						`${e.preStyle.border.type} ${e.preStyle.border.borderSize[1]}px ${e.preStyle.border.color}`
					style.borderBottom =
						`${e.preStyle.border.type} ${e.preStyle.border.borderSize[2]}px ${e.preStyle.border.color}`
					style.borderRight =
						`${e.preStyle.border.type} ${e.preStyle.border.borderSize[3]}px ${e.preStyle.border.color}`
				}


				if (e.preStyle.border.borderRadius) {
					style.borderRadius =
						`${e.preStyle.border.borderRadius[0]}px ${e.preStyle.border.borderRadius[1]}px ${e.preStyle.border.borderRadius[2]}px ${e.preStyle.border.borderRadius[3]}px`
				}

				if (e.preStyle.font.fontFamily) {
					this.getFontStyle(e.preStyle.font.fontFamily)
					style.fontFamily = e.preStyle.font.fontFamily
				}
				// console.log('style', style)
				if (e.preStyle.font.italic) {
					style.fontStyle = 'italic'
				}
				if (e.preStyle.font.fontFamily) {
					// font-family
					style.fontFamily = e.preStyle.font.fontFamily
					// console.log('e.preStyle.font.fontFamily', e.preStyle.font.fontFamily)
				}

				let background =
					`linear-gradient(${e.preStyle.background.angle}deg,${e.preStyle.background.color1},${e.preStyle.background.color2})`

				if (e.preStyle.background.color1 && e.preStyle.background.color2 && e.preStyle.bg.bgtype == 'color') {
					style.background = background
				}

				if (e.preStyle.bg.bgtype && e.preStyle.bg.bgtype == 'img') {
					if (e.preStyle.bg.img) {

						let backgroundImage = `url(${e.preStyle.bg.img})`

						if (e.preStyle.bg.bgImgWidth) {
							style.backgroundSize = e.preStyle.bg.bgImgWidth + 'px';
						} else {
							style.backgroundSize = '100%';
						}
						if (e.preStyle.bg.bgImgHeigth) {
							style.backgroundSize = style.backgroundSize + ' ' + (e.preStyle.bg.bgImgHeigth + 'px')
						} else {
							style.backgroundSize = style.backgroundSize + ' 100%'
						}
						if (e.preStyle.bg.type) {
							style.backgroundRepeat = e.preStyle.bg.type
						}
						if (e.preStyle.bg.position) {
							style.backgroundPosition = e.preStyle.bg.position
						}
						style.backgroundImage = backgroundImage
						if (e.preStyle.bg.type) {
							style.backgroundRepeat = e.preStyle.bg.type
						}
					} else {
						let background =
							`linear-gradient(${e.preStyle.background.angle}deg,${e.preStyle.background.color1},${e.preStyle.background.color2})`
						if (e.preStyle.background.color1 && e.preStyle.background.color2) {
							style.background = background
						}
					}
				}
				// let str = ''
				// for(let k in style) {
				// 	str =str + k + ':' + style[k] + ';'
				// }
				if (e.preStyle.bg.bgtype == 'gradient') {
					style = {
						...style,
						...this.cssStringToObject(e.preStyle.bg.bgGradient)
					}

				}

				// if (e.preStyle.bg.img) {
				// 	style.backgroundImage = backgroundImage
				// }
				// if (e.preStyle.bg.type == "no-repeat-t") {
				// 	style.backgroundRepeat = "no-repeat-t"
				// 	style.backgroundSize = 'cover'
				// }
				// console.log('getComponentStyle style', style)
				return style
			},

			cssStringToObject(cssString) {
				const styleObject = {};

				// 移除所有注释（可选）
				const cleanedCss = cssString.replace(/\/\*[\s\S]*?\*\//g, '');

				// 分割每条规则
				const rules = cleanedCss.split(';').filter(rule => rule.trim() !== '');

				rules.forEach(rule => {
					const [property, value] = rule.split(':').map(item => item.trim());
					if (property && value) {
						// 转换属性名为驼峰式（如 background-color -> backgroundColor）
						const camelCaseProperty = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
						styleObject[camelCaseProperty] = value;
					}
				});

				return styleObject;
			},


			getStyle(e, type) {
				let style = {}

				if (type == 'noFull') {
					let margin = {
						marginTop: e.preStyle.margin[0] + 'px',
						marginBottom: e.preStyle.margin[1] + 'px',
						marginLeft: e.preStyle.margin[2] + 'px',
						marginRight: e.preStyle.margin[3] + 'px'
					}

					let padding = {
						paddingTop: e.preStyle.padding[0] + 'px',
						paddingBottom: e.preStyle.padding[1] + 'px',
						paddingLeft: e.preStyle.padding[2] + 'px',
						paddingRight: e.preStyle.padding[3] + 'px'
					}
					// background-image: url(https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png);
					let backgroundImage = `url(${e.preStyle.bg.img })`
					let backgroundRepeat = e.preStyle.bg.type

					let boxShadow =
						`${e.preStyle.boxShadow.h}px ${e.preStyle.boxShadow.v}px ${e.preStyle.boxShadow.blur}px ${e.preStyle.boxShadow.spread}px ${e.preStyle.boxShadow.color}`
					if (e.preStyle.boxShadow.type != 'outset') {
						boxShadow = `${boxShadow} ${e.preStyle.boxShadow.type}`
					}
					style = {
						...style,
						...padding,
						...margin,
						// backgroundImage,
						// backgroundRepeat,
						boxShadow
					}


					if (e.preStyle.bg.bgtype == 'color') {
						let background =
							`linear-gradient(${e.preStyle.background.angle}deg,${e.preStyle.background.color1},${e.preStyle.background.color2})`
						if (e.preStyle.background.color1 && e.preStyle.background.color2) {
							style.background = background
						}
					}

					if (e.preStyle.bg.bgtype && e.preStyle.bg.bgtype == 'img') {
						if (e.preStyle.bg.img) {

							let backgroundImage = `url(${e.preStyle.bg.img})`

							if (e.preStyle.bg.bgImgWidth) {
								style.backgroundSize = e.preStyle.bg.bgImgWidth + 'px';
							} else {
								style.backgroundSize = '100%';
							}
							if (e.preStyle.bg.bgImgHeigth) {
								style.backgroundSize = style.backgroundSize + ' ' + (e.preStyle.bg.bgImgHeigth + 'px')
							} else {
								style.backgroundSize = style.backgroundSize + ' 100%'
							}
							if (e.preStyle.bg.type) {
								style.backgroundRepeat = e.preStyle.bg.type
							}
							if (e.preStyle.bg.position) {
								style.backgroundPosition = e.preStyle.bg.position
							}
							style.backgroundImage = backgroundImage
							if (e.preStyle.bg.type) {
								style.backgroundRepeat = e.preStyle.bg.type
							}
						} else {

						}
					}


					if (e.preStyle.border.borderSize) {
						style.borderTop =
							`${e.preStyle.border.type} ${e.preStyle.border.borderSize[0]}px ${e.preStyle.border.color}`
						style.borderLeft =
							`${e.preStyle.border.type} ${e.preStyle.border.borderSize[1]}px ${e.preStyle.border.color}`
						style.borderBottom =
							`${e.preStyle.border.type} ${e.preStyle.border.borderSize[2]}px ${e.preStyle.border.color}`
						style.borderRight =
							`${e.preStyle.border.type} ${e.preStyle.border.borderSize[3]}px ${e.preStyle.border.color}`
					}

					if (e.preStyle.border.borderRadius) {
						style.borderRadius =
							`${e.preStyle.border.borderRadius[0]}px ${e.preStyle.border.borderRadius[1]}px ${e.preStyle.border.borderRadius[2]}px ${e.preStyle.border.borderRadius[3]}px`
					}
					if (e.preStyle.sticky) {
						style.position = 'sticky'
						style.top = "20px"
						// console.log('e.preStyle.stickye.preStyle.stickye.preStyle.stickye.preStyle.stickye.preStyle.sticky', e
						// 	.preStyle.sticky)
					}
					let str = ''
					for (let k in style) {
						str = str + k + ':' + style[k] + ';'
					}
					return str
				}
				if (type == 'full') {
					if (e.preStyle.bg.bgtype == 'color') {
						let background =
							`linear-gradient(${e.preStyle.background.angle}deg,${e.preStyle.background.color1},${e.preStyle.background.color2})`
						if (e.preStyle.background.color1 && e.preStyle.background.color2) {
							style.background = background
						}
					}

					if (e.preStyle.bg.bgtype && e.preStyle.bg.bgtype == 'img') {
						if (e.preStyle.bg.img) {

							let backgroundImage = `url(${e.preStyle.bg.img})`

							if (e.preStyle.bg.bgImgWidth) {
								style.backgroundSize = e.preStyle.bg.bgImgWidth + 'px';
							} else {
								style.backgroundSize = '100%';
							}
							if (e.preStyle.bg.bgImgHeigth) {
								style.backgroundSize = style.backgroundSize + ' ' + (e.preStyle.bg.bgImgHeigth + 'px')
							} else {
								style.backgroundSize = style.backgroundSize + ' 100%'
							}
							if (e.preStyle.bg.type) {
								style.backgroundRepeat = e.preStyle.bg.type
							}
							if (e.preStyle.bg.position) {
								style.backgroundPosition = e.preStyle.bg.position
							}
							style.backgroundImage = backgroundImage
							if (e.preStyle.bg.type) {
								style.backgroundRepeat = e.preStyle.bg.type
							}
						} else {

						}
					}
					let str = ''
					for (let k in style) {
						str = str + k + ':' + style[k] + ';'
					}
					if (e.preStyle.bg.bgtype == 'gradient') {
						str = str + e.preStyle.bg.bgGradient
					}

					// console.log('strstrstrstr', str)
					return str
				}



				let margin = {
					marginTop: e.preStyle.margin[0] + 'px',
					marginBottom: e.preStyle.margin[1] + 'px',
					marginLeft: e.preStyle.margin[2] + 'px',
					marginRight: e.preStyle.margin[3] + 'px'
				}
				// background-image: url(https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png);
				let backgroundImage = `url(${e.preStyle.bg.img })`
				let backgroundRepeat = e.preStyle.bg.type

				let boxShadow =
					`${e.preStyle.boxShadow.h}px ${e.preStyle.boxShadow.v}px ${e.preStyle.boxShadow.blur}px ${e.preStyle.boxShadow.spread}px ${e.preStyle.boxShadow.color}`
				if (e.preStyle.boxShadow.type != 'outset') {
					boxShadow = `${boxShadow} ${e.preStyle.boxShadow.type}`
				}
				style = {
					...style,
					// ...padding,
					...margin,
					// backgroundImage,
					// backgroundRepeat,
					boxShadow
				}
				if (e.preStyle.border.borderSize) {
					style.borderTop =
						`${e.preStyle.border.type} ${e.preStyle.border.borderSize[0]}px ${e.preStyle.border.color}`
					style.borderLeft =
						`${e.preStyle.border.type} ${e.preStyle.border.borderSize[1]}px ${e.preStyle.border.color}`
					style.borderBottom =
						`${e.preStyle.border.type} ${e.preStyle.border.borderSize[2]}px ${e.preStyle.border.color}`
					style.borderRight =
						`${e.preStyle.border.type} ${e.preStyle.border.borderSize[3]}px ${e.preStyle.border.color}`
				}

				if (e.preStyle.border.borderRadius) {
					style.borderRadius =
						`${e.preStyle.border.borderRadius[0]}px ${e.preStyle.border.borderRadius[1]}px ${e.preStyle.border.borderRadius[2]}px ${e.preStyle.border.borderRadius[3]}px`
				}
				if (e.preStyle.sticky) {
					style.position = 'sticky'
					style.top = "20px"
					// console.log('e.preStyle.stickye.preStyle.stickye.preStyle.stickye.preStyle.stickye.preStyle.sticky', e
					// 	.preStyle.sticky)
				}
				if (e.preStyle.bg.bgtype == 'color') {
					let background =
						`linear-gradient(${e.preStyle.background.angle}deg,${e.preStyle.background.color1},${e.preStyle.background.color2})`
					if (e.preStyle.background.color1 && e.preStyle.background.color2) {
						style.background = background
					}
				}

				if (e.preStyle.bg.bgtype && e.preStyle.bg.bgtype == 'img') {
					if (e.preStyle.bg.img) {

						let backgroundImage = `url(${e.preStyle.bg.img})`

						if (e.preStyle.bg.bgImgWidth) {
							style.backgroundSize = e.preStyle.bg.bgImgWidth + 'px';
						} else {
							style.backgroundSize = '100%';
						}
						if (e.preStyle.bg.bgImgHeigth) {
							style.backgroundSize = style.backgroundSize + ' ' + (e.preStyle.bg.bgImgHeigth + 'px')
						} else {
							style.backgroundSize = style.backgroundSize + ' 100%'
						}
						if (e.preStyle.bg.type) {
							style.backgroundRepeat = e.preStyle.bg.type
						}
						if (e.preStyle.bg.position) {
							style.backgroundPosition = e.preStyle.bg.position
						}
						style.backgroundImage = backgroundImage
						if (e.preStyle.bg.type) {
							style.backgroundRepeat = e.preStyle.bg.type
						}
					} else {

					}
				}
				let str = ''
				for (let k in style) {
					str = str + k + ':' + style[k] + ';'
				}
				if (e.preStyle.bg.bgtype == 'gradient') {
					str = str + e.preStyle.bg.bgGradient
				}

				// console.log('strstrstrstr', str)
				return str
				// return style
			},
			getPull(childItem, item) {
				// console.log('itemitem item ', item)
				// console.log('getPull childItem ', childItem)
				// console.log(childItem.containerLayout.col.switch)
				if (this.equipment == "pc") {
					if (item.containerLayout.col.switch) {
						return childItem.containerLayout.col.pull == 0 ? null : childItem.containerLayout.col.pull
					}
				} else {
					if (item.containerLayout.phoneCol.switch) {
						return childItem.containerLayout.phoneCol.pull == 0 ? null : childItem.containerLayout.phoneCol
							.pull
						// return childItem.containerLayout.col.pull == 0 ? null : childItem.containerLayout.col.pull
					}
					// if (childItem.containerLayout.phoneCol.switch) {
					// 	return childItem.containerLayout.phoneCol.pull == 0 ? null : childItem.containerLayout.phoneCol.pull
					// }
				}

			},
			getPush(childItem, item) {
				// console.log('getPush childItem ', childItem)
				if (this.equipment == "pc") {
					if (item.containerLayout.col.switch) {
						return childItem.containerLayout.col.push == 0 ? null : childItem.containerLayout.col.push
					}
				} else {
					if (item.containerLayout.phoneCol.switch) {
						return childItem.containerLayout.phoneCol.push == 0 ? null : childItem.containerLayout.phoneCol
							.push
					}
				}
			},
			changeEq(e) {
				// console.log('e', e)
				// console.log(this.pageValue)
				this.isFullWidthKey = this.isFullWidthKey + 1
				if (this.pageValue == '1' && e == 'pc') {
					// 页眉
					this.pageNewValue = '1'
					this.changePage('1')
				}
				if (this.pageValue == '1' && e == 'phone') {
					// 页眉
					this.pageNewValue = '2'

					this.changePage('2')
				}
				if (this.pageValue == '3' && e == 'pc') {
					// 页脚
					this.pageNewValue = '3'
					this.changePage('3')
				}
				if (this.pageValue == '3' && e == 'phone') {
					// 页脚
					this.pageNewValue = '4'
					this.changePage('4')
				}
				this.equipment = e
				// console.log("changeEq this.equipment ", this.equipment)
			},
			// 获取分类的商品配置
			getClassfiyGoodsConfig() {
				try {
					let obj = {}
					this.classifyList.forEach(item => {
						if (item.name == '商品分类') {
							obj = item.children[0].children[0].compontChildren[0].layoutConfig.goodsConfig
						}
					})
					// console.log('getClassfiyGoodsConfig', obj)
					return obj
				} catch (e) {
					return {}
				}
			},

			async save() {

				try {
					let type = 'pcNav'
					let filed = 'navList'
					if (parseInt(this.pageValue) > 4) {
						this.config.center.page.forEach(pageItem => {
							if (pageItem.pageValue == this.pageValue) {
								filed = pageItem.filed
								type = pageItem.type
							}
						})
					} else {
						if (this.pageNewValue == '1') {
							type = 'pcNav'
							filed = 'navList'
						}
						if (this.pageNewValue == '2') {
							type = 'phoneNav'
							filed = 'navPhoneList'
						}
						if (this.pageNewValue == '3') {
							type = 'pcFooter'
							filed = 'footerList'
						}
						if (this.pageNewValue == '4') {
							type = 'phoneFooter'
							filed = 'footerPhoneList'
						}
					}
					this.loading = true

					if (this.pageValue != '10' && this.pageValue != '11') {
						this.setList({
							filed: filed,
							list: this.centerList
						})
					}

					// console.log('this.filed', filed)
					// console.log('JSON.stringify(this.navList)', this.navList)
					let wsid = this.$cookies.get("wsid")
					let data = await getDesignSave({
						wsid,
						data: {
							pcNav: JSON.stringify(this.navList),
							phoneNav: JSON.stringify(this.navPhoneList),
							pcFooter: JSON.stringify(this.footerList),
							phoneFooter: JSON.stringify(this.footerPhoneList),
							home: JSON.stringify(this.homeList),
							detail: JSON.stringify(this.detailList),
							classifyList: JSON.stringify(this.classifyList),
							globalDialogList: JSON.stringify(this.globalDialogList),
							goodsConfig: JSON.stringify([this.getClassfiyGoodsConfig()])
						},
					})

					// console.log('this.setConfigList', this.setConfigList)
					await getDesignAllSetting({
						data: JSON.stringify(this.setConfigList),
						wsid
					})
					this.loading = false
					this.$message.success('保存成功')
					// console.log('保存的数据', data)
					// console.log("changeEq this.centerList ", this.centerList)
				} catch (e) {
					this.loading = false
					this.$message.error('保存失败')
				}
			},

			// 保存分类商品装修的数据
			saveGoodsDesign() {

			},


			changeDetailSwitch(e) {
				// console.log('changeDetailSwitch e', e)
			},
			changeRow(e) {
				// console.log('changeRow e', e)
				this.selectdItem.containerLayout.justify = e.justify
			},
			changeCol(e) {
				// console.log('changeCol e', e)
				this.selectdItem.containerLayout.align = e.align
			},
			getSpan(item, childItem) {
				let column = 24
				if (this.equipment == "pc") {
					// 首先判断当前的col的switch 状态
					if (item.containerLayout.col.switch) {
						column = childItem.containerLayout.col.span
					} else {
						// column = column / item.containerLayout.pcMax
					}
				} else {
					if (item.containerLayout.phoneCol.switch) {
						column = childItem.containerLayout.phoneCol.span
					} else {
						// column = column / item.containerLayout.phoneMax
					}
				}
				return column
			},
			changeSGNum(e) {
				// console.log('changeSGNum e', e)
				// console.log('changeSGNum this.selectdItem', this.selectdItem)
				let num = 0
				this.selectdItem.containerLayout.num = e
				if (this.selectdItem.children) {
					let len = this.selectdItem.children.length
					num = e - len
					if (num > 0) {
						// 判断层级
						if (this.selectdItem.level == 1) {
							let newObj = lodash.cloneDeep(obj)
							newObj.id = new Date().getTime()
							newObj.children[0].id = (new Date().getTime()) + "child"
							// console.log("newObj.id ", newObj.id)
							this.selectdItem.children.push(newObj)
						}
						if (this.selectdItem.level == 2) {
							this.selectdItem.children.push({
								...lodash.cloneDeep(componentObj),
								id: new Date().getTime()
							})
						}
					}
					if (num < 0) {
						this.selectdItem.children.splice(len - (len - num), len - num)
					}
				}
			},
			selectItemContainer(e, type, index, pIndex, topPIndex, pItem, ppItem) {
				// console.log('selectItemContainerpItem', pItem)
				// console.log('selectItemContainerpItem', e)
				// console.log('selectItemContainere',e)
				// console.log('selectItemContainere',pItem)
				// console.log('selectItemContainere',ppItem)
				
				
				this.currentNodeKey = e.id
				if (pItem && pItem.name != '容器') {
					this.pContainerItem = pItem
					this.currentNodeKey = pItem.id
				} else {
					this.pContainerItem = null
				}

				if (ppItem && ppItem.name != '容器') {
					this.pContainerItem = ppItem
					this.currentNodeKey = ppItem.id
				}

				if (this.selectdItem) {
					if (this.selectdItem.id == e.id) {
						return
					}
				}
				if (e.level < 3) {
					this.rightTab = '1'
				} else {
					if (e.compontChildren.length > 0 && e.compontChildren[0].rightComponentTabs) {
						// ...e.compontChildren[0].rightComponentTabs, 
						this.rightComponentTabs = [...[{
								title: '组件样式',
								name: '3',
							},
							// {
							// 	title: '数据',
							// 	name: '2',
							// },
						]]
						// this.rightComponentTabs = e.compontChildren[0].rightComponentTabs
						this.rightTab = this.rightComponentTabs[0].name
					} else {
						this.rightTab = '3'
						this.rightComponentTabs = [{
								title: '组件样式',
								name: '3',
							},
							// {
							// 	title: '数据',
							// 	name: '2',
							// },
						]
					}
					if (e.compontChildren.length > 0 && e.compontChildren[0].filter) {
						let arr = []
						this.rightComponentTabs.forEach(item => {
							if (e.compontChildren[0].filter.indexOf(item.name) == -1) {
								arr.push(item)
							}
						})
						this.rightComponentTabs = arr
					}
				}
				// this.delInfo.l = type
				// this.delInfo.index = index
				// this.delInfo.pIndex = pIndex
				// this.delInfo.topPIndex = topPIndex
				this.selectdItem = null
				
				this.treeKey = this.treeKey + 1
				// console.log('this.currentNodeKey', this.currentNodeKey)
				this.$nextTick(() => {
					if (this.all_setting.length > 0) {
						// 全局设置
						let itemSetFont = this.all_setting[0].tabList[1]
						if(!e.preStyle.font.fontFamily) {
							this.$set(e.preStyle.font,'fontFamily',itemSetFont.config.setfontFamily.fontFamily)
						}
					}
					this.selectdItem = e
					console.log('selectItemContainere11',e)
					
					
				})
			},
			selectItem(e) {
				// console.log('selectItem e', e)
				if (e.level < 3) {
					this.rightTab = '1'
				} else {
					this.rightTab = '3'
				}
				// console.log('this.rightTab', this.rightTab)
				this.setSelectdItem(e)
				this.selectdItem = e

			},
			cloneRule(element, clone = true) {
				let that = this
				// alert(1)
				// console.log('this.cloneRuleall_setting', this.all_setting)
				// console.log('cloneRule element', element)
				let newElement;
				if (clone) {
					newElement = lodash.cloneDeep(element)
				} else {
					newElement = element
				}
				newElement.id = new Date().getTime()
				if (newElement.level == 4) {
					this.newElementId = newElement.id
					// console.log('newElement', newElement)
				}
				if (newElement.children) {
					newElement.children.forEach(e => {
						e.id = new Date().getTime()
						e.id = e.id + 'child123456'
						// 两层
						if (e.children) {
							e.children.forEach(childItem => {
								childItem.id = new Date().getTime()
								childItem.id = childItem.id + 'childItem'
								if (this.all_setting.length > 0) {
									// 全局设置
									let itemSetFont = this.all_setting[0].tabList[1]
									childItem.preStyle.font.color = itemSetFont.config.setColor.color
									childItem.preStyle.font.size = parseInt(itemSetFont.config.setFontSize
										.fontSize)
									childItem.preStyle.font.fontFamily = itemSetFont.config.setfontFamily
										.fontFamily
									childItem.preStyle.font.name = itemSetFont.config.setfontFamily.name
									// console.log('itemSetFont', itemSetFont)
								}
							})
						}
					})
				}
				return newElement;
			},
			handleTabsEdit() {},
			leftStart(e, list) {
				// console.log('leftStart e', e)
				if (list[e.oldIndex].compoentName == "container") {
					this.addComponentPut = false

				} else {
					list[e.oldIndex].isLeftEnd = false
					if (list[e.oldIndex].isNeedData) {
						this.haveData = false
					}
					this.addContainerPut = false
				}
				// console.log('this.addContainerPut', this.addContainerPut)
			},
			sortDrag(e) {
				// console.log('sortDrag 1', e)
			},
			leftEnd1(e) {
				// console.log('leftEnd1 e', e)
			},
			leftEnd(e) {
				this.ghostClass = ''
				// console.log('leftEnd e', e)
				this.addComponentPut = true
				this.addContainerPut = true
				// console.log('this.centerList', this.centerList)
				this.centerList.forEach(item => {
					item.children.forEach((cmpItem, cmpIndex) => {
						if (cmpItem.level == 4) {
							item.children.splice(cmpIndex, 1)
							let addIndex = cmpIndex == 0 ? 0 : cmpIndex - 1
							let child = lodash.cloneDeep(compoentsConfig[0].children)
							child[0].name = cmpItem.name
							child[0].id = (new Date().getTime()) + 'child2'
							child[0].children[0].id = (new Date().getTime()) + 'child3'
							child[0].children[0].name = cmpItem.name
							child[0].children[0].compontChildren.push(cmpItem)

							// console.log('childchildchildchildchild', child)
							if (cmpIndex >= item.children.length) {
								item.children.push(child[0])
							} else {
								item.children.splice(addIndex, 0, child[0])
							}
						}
						if (cmpItem.level == 2) {
							cmpItem.children.forEach((twoCmpItem, twoIndex) => {
								if (twoCmpItem.level == 4) {
									// 手动添加一层
									let cmp = twoCmpItem
									let addIndex = twoIndex == 0 ? 0 : twoIndex - 1
									cmpItem.children.splice(twoIndex, 1)
									let child = lodash.cloneDeep(compoentsConfig[0].children[0]
										.children[0])
									child.id = (new Date().getTime()) + 'child3'
									child.compontChildren.push(cmp)
									if (twoIndex >= cmpItem.children.length) {
										cmpItem.children.push(child)
									} else {
										cmpItem.children.splice(addIndex, 0, child)
									}
								}
							})
						}
					})
				})
				// console.log('this.centerListthis.centerList', this.centerList)
				this.centerList.forEach(item => {
					item.children.forEach(childrenItem => {
						childrenItem.children.forEach(twoChildrenItem => {
							if (twoChildrenItem.compontChildren.length == 1) {
								twoChildrenItem.name = twoChildrenItem.compontChildren[0].name
							}
						})
					})
				})
				this.initStyle()
			},
			async initFieldStyle(field) {
				let compontChildrenItem;
				this[field].forEach(async (l1) => {
					l1.children.forEach(async l2 => {
						l2.children.forEach(async l3 => {
							if (l3.compontChildren.length > 0) {
								if (l3.compontChildren[0].id == this
									.newElementId) {
									// l3.compontentStyle
									if (JSON.stringify(l3.compontChildren[0]
											.preStyle) != "{}") {

										// 添加默认样式
										l3.preStyle = {
											...l3.preStyle,
											...l3.compontChildren[0].preStyle

										}
										// l3.preStyle.compontentStyle = {
										// 	...l3.compontChildren[0]
										// 	.preStyle.pc
										// }
										// l3.preStyle.compontentStylePhone = {
										// 	...l3.compontChildren[0].preStyle.phone
										// }
										// console.log(
										// 	'l3.preStyle.compontentStylePhone',
										// 	l3.preStyle.compontentStylePhone)

										// if (this.equipment == 'pc') {
										// 	l3.preStyle.compontentStyle = {
										// 		...l3.compontChildren[0]
										// 		.preStyle.pc
										// 	}
										// } else {
										// 	l3.preStyle.compontentStyle = {
										// 		...l3.compontChildren[0]
										// 		.preStyle.phone
										// 	}
										// }
										// console.log('l3l3l3l3', l3)

									}
									if (l3.compontChildren[0].requestFun) {
										l1.requestFun = true
										// console.log('initFierequestFunldStyle', l1)
									}
									compontChildrenItem = l3.compontChildren[0]
								}
							}
						})
					})
				})
				// console.log('initFieldStyle', this[field])
				this.newElementId = null
				this.$forceUpdate()
			},

			async initStyle() {
				let compontChildrenItem;
				this.centerList.forEach(l1 => {
					l1.children.forEach(l2 => {
						l2.children.forEach(l3 => {
							if (l3.compontChildren.length > 0) {
								if (l3.compontChildren[0].id == this
									.newElementId) {
									// l3.compontentStyle
									if (JSON.stringify(l3.compontChildren[0]
											.preStyle) != "{}") {
										// l3.preStyle.compontentStyle = {
										// 	...l3.compontChildren[0]
										// 	.preStyle.pc
										// }
										// l3.preStyle.compontentStylePhone = {
										// 	...l3.compontChildren[0].preStyle.phone
										// }
										l3.preStyle = {
											...l3.preStyle,
											...l3.compontChildren[0].preStyle

										}
										// console.log('l3l3l3l3', l3)
										// l3.preStyle.compontentStyle = {
										// 	...l3.compontChildren[0].preStyle
										// }
									}
									if (l3.compontChildren[0].requestFun) {
										l1.requestFun = true
									}
									compontChildrenItem = l3.compontChildren[0]
								}
							}

						})
					})
				})
				// console.log('initStyle', this.centerList)
				this.newElementId = null
				this.$forceUpdate()
			},
			async initData(compoent,childrenItem, twoChildrenItem,item) {
				this.loading = true
				let that = this
				try {
					let name = compoent.compoentName
					for (let i = 0; i < apiConfig.length; i++) {
						let fun = apiConfig[i]
						if (fun[name]) {
							if (compoent.requestFun) {
								// console.log('name', name)
								// console.log('apiConfig', apiConfig)
								for (let j = 0; j < compoent.requestFun.length; j++) {
									let funName = compoent.requestFun[j]
									let data = await fun[name]['requestData'][funName](that, 'design', {
										// classfiy:compoent.data.classfiy
										data: compoent,
										childrenItem, twoChildrenItem,
											item
									})
									// console.log('initData', data)
								}
							}
						}
					}
					this.loading = false
				} catch (e) {
					// console.log('e', e)
					this.loading = false
				}
			},
			async requestFun() {
				// console.log('requestFun')
				let type = 'pcNav'
				let filed = 'navList'
				this.config.center.page.forEach(pageItem => {
					if (pageItem.pageValue == this.pageValue) {
						filed = pageItem.filed
						type = pageItem.type
					}
				})
				await this.requestInitData(filed)
				// if (this.pageValue == '1') {
				// 	type = 'pcNav'
				// 	filed = 'navList'
				// 	await this.requestInitData('navList')
				// }
				// if (this.pageValue == '2') {
				// 	type = 'phoneNav'
				// 	filed = 'navPhoneList'
				// 	await this.requestInitData("navPhoneList")
				// }
				// if (this.pageValue == '3') {
				// 	type = 'pcFooter'
				// 	filed = 'footerList'
				// 	await this.requestInitData("footerList")
				// }
				// if (this.pageValue == '4') {
				// 	type = 'phoneFooter'
				// 	filed = 'footerPhoneList'
				// 	await this.requestInitData("footerPhoneList")
				// }
				// if (this.pageValue == '5') {
				// 	type = 'home'
				// 	filed = 'homeList'
				// 	await this.requestInitData("homeList")
				// }
			},
			async requestInitData(fieldList) {
				// 装配 导航
				let that = this
				for (let i = 0; i < this[fieldList].length; i++) {
					let item = this[fieldList][i]
					// item.requestData
					if (item.requestFun && item.requestFun.length > 0) {
						for (let j = 0; j < item.children.length; j++) {
							let childrenItem = item.children[j]
							for (let k = 0; k < childrenItem.children.length; k++) {
								let twoChildrenItem = childrenItem.children[k]
								for (let m = 0; m < twoChildrenItem.compontChildren.length; m++) {
									let compontChildrenItem = twoChildrenItem.compontChildren[m]
									that.initData(compontChildrenItem,childrenItem, twoChildrenItem,
										item)
								}
							}
						}
					}
				}
			},
			handleTabsRightEdit(e) {
				// console.log('handleTabsRightEdit e', e)
			}
		}
	}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
	::v-deep .el-tree__drop-indicator {
		height: 5px;
		background-color: #07c160;
	}

	::v-deep .tree-drawer {
		.el-drawer__container {
			.el-drawer {
				.el-drawer__header {
					height: 0px;
					margin-bottom: 0px
				}
			}
		}

	}

	// ::v-deep .el-drawer__header {

	// 	}
	// ::v-deep .el-switch__core{
	//   width:35px!important;
	//   height:20px;
	//   /*color:#409EFF;*/
	// }
	// ::v-deep .el-switch__core::after{
	//   width:14px;
	//   height:14px;
	//   margin-top:2px;
	//   margin-bottom: 2px;
	// }

	::v-deep .el-switch__core {
		width: 35px !important;
		height: 18px;
		/*color:#409EFF;*/
	}

	/*设置圆*/
	::v-deep .el-switch__core::after {
		width: 14px;
		height: 14px;
		// margin-top:-1px;
		// margin-bottom: 2px;
	}

	.ghost {
		height: 3px;
		overflow: hidden;
		color: #fff;
		background-color: #5555ff;
		opacity: 0.7;
		// display: flex;
		// align-items: center;
		font-size: 14px;
		margin: auto;
		width: calc(100% - 24px) // display: flex;
			// border: solid 1px #00aa7f ;
	}

	.tit-icon:hover {
		color: #8c62ff;
	}

	.tit-icon1:hover {
		color: #aaaaff;
	}


	.custom-tree-node {
		display: flex;
		justify-content: space-between;
		width: 100%;
		align-items: center;
		font-size: 14px;
		margin-right: 14px;

	}

	::v-deep .select-imgs {
		background-color: #293042;

		.el-dialog__title {
			color: #fff;
		}

		.el-dialog__body {
			padding: 0px;
		}
	}

	.unselectable {
		-webkit-user-select: none;
		/* Safari */
		-moz-user-select: none;
		/* Firefox */
		-ms-user-select: none;
		/* Internet Explorer/Edge */
		user-select: none;
		/* 标准语法 */
	}

	// .el-input__inner:hover {
	// 	border: 1px solid #8c62ff;
	// }

	// .el-select-dropdown {
	// 	color: #8C62FF;
	// 	border: 1px solid #8c62ff;
	// }

	// .el-button:hover {
	// 	border: 1px solid #8c62ff;
	// 	background-color: #8c62ff;
	// 	color: #fff;
	// }

	::v-deep .el-select,
	::v-deep .el-input,
	::v-deep .el-input__inner {

		// text-align: center;
	}

	::v-deep .el-tree-node__content {
		margin-top: 5px;
	}

	// ::v-deep .el-select .el-input.is-focus .el-input__inner {
	// 	border: 1px solid #242754;
	// }

	// ::v-deep .el-select .el-input__inner:focus {
	// 	border: 1px solid #242754;
	// }

	::v-deep .el-select-dropdown__item::after .selected {
		color: #242754;
		background-color: #242754;
	}

	::v-deep .el-scrollbar__view .el-select-dropdown__list {
		color: #242754;
	}

	input:focus {
		outline: none;
		border: 1px solid #242754;
		border-radius: 3px;
	}

	input {
		outline: none;
		border: 1px solid #c1c1c1;
		border-radius: 5px;
	}

	.el-dropdown-menu__item {
		color: #fff;
		font-weight: bold;
		z-index: 1000;
	}

	::v-deep .el-dropdown-menu__item:hover {
		background-color: #0055ff;
		z-index: 1000;
	}

	.sea-dropdown-menu {
		position: fixed;
		width: 150px;
		background-color: #b0b0b0;
		z-index: 1000;
		border-radius: 3px;
		// -webkit-box-shadow: 1px 2px 10px #ccc;
		// box-shadow: 1px 2px 10px #ccc;
		clip-path: polygon(5% 0, 100% 0, 100% 100%, 5% 100%, 5% 65%, 0 50%, 5% 35%);
		color: #fff;
	}

	.folde {
		cursor: pointer;
	}

	.folde:hover {
		color: #55aaff;
	}

	.flex-item-center {
		display: flex;
		align-items: center;
	}

	.left-top {
		cursor: pointer;
	}

	.left-top:hover {
		color: #55aaff;
	}

	.top {
		height: 60px;
		width: 100%;
		background-color: #ffffff;
		color: #000000;
		display: flex;
		align-items: center;
		// border-radius: 10px;
		justify-content: space-between;
		border-bottom: solid 1px #cacaca;
	}




	.left {
		// border: solid 1px #242754;
		// position: fixed;
		background-color: #fff;
		// height: calc(100vh - 3px);
		cursor: move;
		user-select: none;
		width: 200px;
		// border: solid 1px #cacaca;
		// border-radius: 20px;
		// overflow-y: scroll;

		.iconset {
			color: "#242754";
		}

		.tabs {
			margin: 10px;
			background-color: #55aaff;
		}

		::v-deep .el-tabs__item {
			height: 34px;
			color: #000000;
			// font-weight: bold;
		}

		::v-deep .is-active {
			color: #242754;
		}

		// ::v-deep .el-tabs__item:hover {
		// 	height: 34px;
		// 	color: #8C62FF;
		// }

		.item {
			// border: solid 1px #cacaca;
			width: 82px;
			height: 82px;
			border-radius: 12px;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			cursor: pointer;
			// background: rgba(140, 98, 255, 0.15);
			opacity: 0.75;
			// color: #8C62FF;
			font-size: 14px;
			border: solid 1px #e6e6e6;
		}

		.group {
			display: grid;
			grid-template-columns: repeat(auto-fill, 80px);
			grid-row-gap: 10px;
			grid-column-gap: 15px;
			justify-content: center;
		}

	}

	.tool-box {
		display: flex;
		align-items: center;
		justify-content: space-between;
		// margin-top: 10px;
	}

	.center {
		overflow-x: auto;
		/* 或者 scroll */
		white-space: nowrap;

		background-color: #fff;
		cursor: pointer;
		height: calc(100vh - 55px);
		// width: calc(100vw - 472px);
		width: 100%;

		border-left: solid 1px #cacaca;
		border-right: solid 1px #cacaca;
		border-bottom: solid 1px #cacaca;
		// border-radius: 20px;
		display: flex;
		justify-content: center;

		.center-container {
			padding: 0px;
			// border: dashed 1px #55aaff;
			// border-radius: 10px;
			// margin-top: 6px;
			// margin-bottom: 6px;
		}

		.center-group {
			display: block;
			overflow-y: scroll;
			z-index: 1000;
			width: 100%;

		}

		.container-child {
			// border-radius: 10px;
			// border: dashed 1px #ffaa00;
			width: 100%;
			height: 100%;

		}
	}

	.right {
		border: solid 1px #e8e8e8;

		// z-index: 100;
		// position: fixed;
		// top: 0px;
		// right: 0px;
		// height: calc(100vh - 3px);
		// cursor: move;
		user-select: none;
		// height: calc(100vh - 3px);

		// border-radius: 20px;
		overflow-y: scroll;
		overflow-x: auto;
		background-color: #fff;

		::v-deep .el-tabs__item {
			height: 34px;
			color: #000000;
			// font-weight: bold;
		}

		::v-deep .is-active {
			color: #8C62FF;
		}
	}

	.col-item {
		width: 100%;
		padding: 10px 0px;
		border-radius: 10px;
		border: dashed 1px #ffaa00;
	}

	::v-deep .el-drawer__header {
		margin-bottom: 20px;
	}



	.slide-enter-active {
		animation-name: slideInUp;
		animation-duration: 0.2s;
		animation-fill-mode: both;
	}

	.slide-leave-active {
		animation-name: slideOutDown;
		animation-duration: 0.2s;
		animation-fill-mode: both;
	}

	@keyframes slideInUp {
		0% {
			transform: translate3d(-56px, 0, 0);
			visibility: visible;
		}

		to {
			transform: translateX(0);
		}
	}

	@keyframes slideOutDown {
		0% {
			transform: translateX(0);
		}

		to {
			visibility: hidden;
			transform: translate3d(-56px, 0, 0);
			opacity: 0;
		}
	}

	.container-row::before {
		content: "";
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		width: 1500px;
		/* 与父容器同宽 */
		height: 100px;
		background-color: #55007f;
		/* 你想要的背景颜色 */
	}


	// .slider-enter-active {
	// 	animation-name: sliderInUp;
	// 	animation-duration:  1s;
	// 	animation-fill-mode: forwards;
	// }

	// .slider-leave-active {
	// 	animation-name: sliderOutDown;
	// 	animation-duration: 1s;
	// 	animation-fill-mode: forwards;
	// }

	// @keyframes sliderInUp {
	// 	0% {
	// 		transform: translate3d(30px, 0, 0);
	// 		visibility: visible;
	// 	}

	// 	to {
	// 		transform: translateX(0);
	// 	}
	// }

	// @keyframes sliderOutDown {
	// 	0% {
	// 		transform: translateX(0);
	// 	}

	// 	to {
	// 		visibility: hidden;
	// 		transform: translate3d(30px, 0, 0);
	// 		opacity: 0;
	// 	}
	// }
</style>